	import React, { useState, useEffect, useContext, useRef, useCallback, useMemo } from "react";
import { useDebounce } from "use-debounce";
import { useParams, useHistory, useLocation } from "react-router-dom";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import {
	Box,
	Button,
	Chip,
	Collapse,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	Divider,
	Grid,
	IconButton,
	InputAdornment,
	List,
	ListItem,
	ListItemAvatar,
	ListItemIcon,
	ListItemSecondaryAction,
	ListItemText,
	Menu,
	MenuItem,
	Paper,
	Popover,
	SvgIcon,
	TextField,
	Toolbar,
	Tooltip,
	Typography,
	InputBase,
	Avatar,
	Tabs,
	Tab,
	Badge,
	CircularProgress,
} from "@material-ui/core";
import {
	FilterList as FilterListIcon,
	Close as CloseIcon,
	ArrowBack as ArrowBackIcon,
	Delete as DeleteIcon,
	CheckCircle as CheckCircleIcon,
	Replay as ReplayIcon,
	Block as BlockIcon,
	Label as LabelIcon,
	ViewColumn as ViewColumnIcon,
	Image as ImageIcon,
	InsertDriveFile as FileIcon,
	Videocam as VideoIcon,
	Description as DocumentIcon,
	GetApp as GetAppIcon,
	Create as SignatureIcon,
	Timer as ScheduleIcon,
	Comment as QuickMessageIcon,
	Visibility as VisibilityIcon,
	Done as DoneIcon,
	DoneAll as DoneAllIcon,
	Edit as EditIcon,
	Menu as MenuIcon,
	Close as CloseMenuIcon,
	MoreHoriz as MoreHorizIcon,
	Add as AddIcon,
	AccountCircle as AccountCircleIcon,
	MoreVert as MoreVertIcon,
	Mic as MicIcon,
	EmojiEmotions as EmojiIcon,
	AttachFile as AttachFileIcon,
	Send as SendIcon,
	Chat as ChatIcon,
	SwapHoriz as SwapHorizIcon,
	WhatsApp as WhatsAppIcon,
	Facebook as FacebookIcon,
	Instagram as InstagramIcon,
	Android as AndroidIcon,
	Archive as ArchiveIcon,
	VisibilityOff as VisibilityOffIcon,
	Receipt as ReceiptIcon,
	Event as EventIcon,
	BusinessCenter as BusinessCenterIcon,
	Person as PersonIcon,
	LocationOn as LocationOnIcon,
	ExpandMore as ExpandMoreIcon,
	GroupAdd as GroupAddIcon,
} from "@material-ui/icons";
import CallIcon from '@mui/icons-material/Call';
import PhoneInTalkIcon from '@mui/icons-material/PhoneInTalk';
import AddIcCallIcon from '@mui/icons-material/AddIcCall';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import { AiSuggestModal, AiSummaryModal, AiAskModal } from "../../components/AiAssistantModals";
import SmartToyIcon from '@mui/icons-material/SmartToy';
import HistoryIcon from '@mui/icons-material/History';
import StickyNote2Icon from '@mui/icons-material/StickyNote2';
import AudioModal from "../../components/AudioModal";
import InteractiveButtonsPreview from "../../components/InteractiveButtonsPreview";
import ButtonPreview from "../../components/ButtonPreview";
import ModalImageCors from "../../components/ModalImageCors";
import ScheduleModal from "../../components/ScheduleModal";
import NewTicketModal from "../../components/NewTicketModal";
import LigacaoOficial from "../../components/LigacaoOficial";
import PersonAddAlt1Icon from '@mui/icons-material/PersonAddAlt1';
import GroupsIcon from '@mui/icons-material/Groups';
import TransferTicketModalCustom from "../../components/TransferTicketModalCustom";
import MediaPreviewModal from "../../components/MediaPreviewModal";
import MediaGalleryModal from "../../components/MediaGalleryModal";
import QuickMessagePreviewModal from "../../components/QuickMessagePreviewModal";
import DeleteConfirmModal from "../../components/MessageActionsModal/DeleteConfirmModal";
import EditMessageModal from "../../components/MessageActionsModal/EditMessageModal";
import ForwardMessageModal from "../../components/MessageActionsModal/ForwardMessageModal";
import TicketTagsKanbanModal from "../../components/TicketTagsKanbanModal";
import TicketNotesDrawer from "../../components/TicketNotesDrawer";
import TicketMessagesDialog from "../../components/TicketMessagesDialog";
import ConnectionIcon from "../../components/ConnectionIcon";
import ContactModal from "../../components/ContactModal";
import FaturaModal from "../../components/FaturaModal";
import AppointmentModal from "../../components/AppointmentModal";
import ProjectModal from "../../components/ProjectModal";
import AttachmentModal from "../../components/AttachmentModal";
import EmailComposeModal from "../../components/EmailComposeModal";
import FormSelectModal from "../../components/FormSelectModal";
import ContactSendModal from "../../components/ContactSendModal";
import LocationModal from "../../components/LocationModal";
import ModalCamera from "../../components/CameraModal";
import { ClientDetailsModal, ConvertToClientModal } from "../../components/ClientDetailsModal";
import MessageInput from "../../components/MessageInput";
import { ReplyMessageProvider } from "../../context/ReplyingMessage/ReplyingMessageContext";
import { ForwardMessageProvider } from "../../context/ForwarMessage/ForwardMessageContext";
import { EditMessageProvider } from "../../context/EditingMessage/EditingMessageContext";
import { AuthContext } from "../../context/Auth/AuthContext";
import { TicketsContext } from "../../context/Tickets/TicketsContext";
import api from "../../services/api";
import MicRecorder from "mic-recorder-to-mp3";
import { socketConnection } from "../../services/socket";
import { format, formatDistanceToNow, parseISO } from "date-fns";
import { ptBR } from "date-fns/locale";
import TicketActionsMenu from "../../components/TicketActionsMenu";
import useQuickMessages from "../../hooks/useQuickMessages";
import { toast } from "react-toastify";
import { useSystemAlert } from "../../components/SystemAlert";
import GroupParticipantsModal from "../../components/GroupParticipantsModal";
import GroupSettingsModal from "../../components/GroupSettingsModal";
import GroupImageModal from "../../components/GroupImageModal";
import SettingsIcon from "@material-ui/icons/Settings";
import PeopleIcon from "@material-ui/icons/People";
import PhotoCameraIcon from "@material-ui/icons/PhotoCamera";
import LinkIcon from "@material-ui/icons/Link";

const Mp3Recorder = new MicRecorder({ bitRate: 128 });

const useStyles = makeStyles(theme => ({
	'@keyframes pulse': {
		'0%': {
			opacity: 1,
			transform: 'scale(1)',
		},
	mobileHeaderToggle: {
		marginLeft: "auto",
		backgroundColor: "#e1e4ea",
	},
	mobileActionsCollapse: {
		width: "100%",
		display: "flex",
		flexWrap: "wrap",
		justifyContent: "flex-end",
		gap: 6,
	},
	mobileHeaderActions: {
		width: "100%",
		display: "flex",
		flexWrap: "wrap",
		justifyContent: "flex-end",
		gap: 6,
		marginTop: 8
	},
		'50%': {
			opacity: 0.5,
			transform: 'scale(1.2)',
		},
		'100%': {
			opacity: 1,
			transform: 'scale(1)',
		},
	},
	root: {
		display: "flex",
		height: "calc(100vh - 64px)",
		minHeight: "calc(100vh - 64px)",
		backgroundColor: "#111b21",
		overflow: "hidden",
		[theme.breakpoints.down("sm")]: {
			height: "calc(100vh - 56px)",
			minHeight: "calc(100vh - 56px)",
		},
	},
	rootMobile: {
		flexDirection: "column",
	},
	
	sidebar: {
		width: 420,
		minWidth: 420,
		maxWidth: 420,
		height: "100%",
		backgroundColor: "#ffffff",
		borderRight: "1px solid #e9edef",
		display: "flex",
		flexDirection: "column",
		overflow: "hidden",
		[theme.breakpoints.down('md')]: {
			width: 360,
			minWidth: 360,
			maxWidth: 360,
		},
	},
	sidebarMobile: {
		width: "100%",
		minWidth: "100%",
		maxWidth: "100%",
		borderRight: "none",
		height: "100%",
		maxHeight: "100vh",
		overflowY: "auto",
	},
	
	sidebarHeader: {
		minHeight: 60,
		backgroundColor: "#f0f2f5",
		display: "flex",
		alignItems: "center",
		justifyContent: "space-between",
		flexWrap: "wrap",
		rowGap: 6,
		padding: "10px 16px",
		borderBottom: "1px solid #e9edef",
		flexShrink: 0,
	},
	
	// Animação para status de digitação
	'@keyframes pulse': {
		'0%': {
			opacity: 1,
			transform: 'scale(1)',
		},
		'50%': {
			opacity: 0.5,
			transform: 'scale(0.8)',
		},
		'100%': {
			opacity: 1,
			transform: 'scale(1)',
		},
	},
	
	sidebarSearch: {
		padding: "8px 16px",
		backgroundColor: "#ffffff",
		borderBottom: "1px solid #e9edef",
	},
	
	searchInput: {
		backgroundColor: "#f0f2f5",
		borderRadius: 8,
		padding: "8px 12px",
		width: "100%",
		display: "flex",
		alignItems: "center",
		"& input": {
			marginLeft: 8,
			flex: 1,
		},
	},
	
	tabs: {
		borderBottom: "1px solid #e9edef",
		backgroundColor: "#ffffff",
		flexShrink: 0,
		"& .MuiTab-root": {
			minWidth: 80,
			textTransform: "none",
			fontSize: 12,
			fontWeight: 500,
			padding: "6px 12px",
		},
	},
	
	ticketsList: {
		flex: 1,
		minHeight: 0,
		overflowY: "auto",
		backgroundColor: "#ffffff",
		"&::-webkit-scrollbar": {
			width: "6px",
		},
		"&::-webkit-scrollbar-thumb": {
			backgroundColor: "#aaa",
			borderRadius: "3px",
		},
	},
	
	ticketItem: {
		display: "flex",
		alignItems: "center",
		padding: "8px 16px",
		cursor: "pointer",
		borderBottom: "1px solid #e9edef",
		transition: "background-color 0.2s",
		"&:hover": {
			backgroundColor: "#f5f6f6",
		},
		"&.active": {
			backgroundColor: "#f0f2f5",
		},
	},
	
	ticketDropdownArrow: {
		marginLeft: 4,
	},
	
	ticketAvatar: {
		width: 49,
		height: 49,
		marginRight: 15,
		flexShrink: 0,
	},
	
	ticketInfo: {
		flex: 1,
		minWidth: 0,
		overflow: "hidden",
		display: "flex",
		flexDirection: "column",
		gap: 2,
	},
	
	ticketName: {
		fontSize: 17,
		fontWeight: 400,
		color: "#111b21",
		overflow: "hidden",
		textOverflow: "ellipsis",
		whiteSpace: "nowrap",
		lineHeight: "21px",
	},
	
	ticketTime: {
		fontSize: 12,
		color: "#667781",
		whiteSpace: "nowrap",
		marginLeft: 6,
	},
	
	ticketLastMessage: {
		fontSize: 14,
		color: "#667781",
		overflow: "hidden",
		textOverflow: "ellipsis",
		whiteSpace: "nowrap",
		display: "flex",
		alignItems: "center",
		gap: 8,
		lineHeight: "20px",
	},
	
	chatArea: {
		flex: 1,
		display: "flex",
		flexDirection: "column",
		height: "calc(100vh - 64px)",
		backgroundColor: "#ffffff",
		position: "relative",
		overflow: "hidden",
		top: 0,
	},
	chatAreaMobile: {
		width: "100%",
		minWidth: "100%",
		maxWidth: "100%",
		flex: "1 1 auto",
		height: "calc(100vh - 64px)",
	},
	
	chatHeader: {
		height: 60,
		backgroundColor: "#f0f2f5",
		borderBottom: "1px solid #e9edef",
		display: "flex",
		alignItems: "center",
		padding: "0 16px",
		flexShrink: 0,
		position: "sticky",
		top: 0,
		zIndex: 10,
	},
	chatHeaderMobile: {
		flexWrap: "wrap",
		height: "auto",
		minHeight: 60,
		paddingTop: 8,
		paddingBottom: 8,
		gap: 8
	},
	
	chatHeaderInfo: {
		flex: 1,
		marginLeft: 12,
	},
	
	chatMessages: {
		flex: 1,
		overflowY: "auto",
		backgroundColor: "#efeae2",
		backgroundImage: `url("data:image/svg+xml,%3Csvg width='100' height='100' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M0 0h100v100H0z' fill='%23efeae2'/%3E%3Cpath d='M20 20h60v60H20z' fill='%23f0f0f0' opacity='0.05'/%3E%3C/svg%3E")`,
		padding: 20,
		userSelect: 'text',
		WebkitUserSelect: 'text',
		MozUserSelect: 'text',
		msUserSelect: 'text',
	},
	
	messageGroup: {
		marginBottom: 12,
		display: "flex",
		flexDirection: "column",
		alignItems: (props) => props.fromMe ? "flex-end" : "flex-start",
	},
	
	messageBubble: {
		maxWidth: "65%",
		padding: "6px 7px 8px 9px",
		borderRadius: 8,
		backgroundColor: (props) => props.fromMe ? "#d9fdd3" : "#ffffff",
		boxShadow: "0 1px 0.5px rgba(0,0,0,0.13)",
		position: "relative",
		marginBottom: 2,
		userSelect: 'text',
		WebkitUserSelect: 'text',
		MozUserSelect: 'text',
		msUserSelect: 'text',
	},
	
	messageText: {
		fontSize: 14,
		color: "#111b21",
		wordWrap: "break-word",
		marginBottom: 4,
		userSelect: 'text',
		WebkitUserSelect: 'text',
		MozUserSelect: 'text',
		msUserSelect: 'text',
	},
	
	messageTime: {
		fontSize: 11,
		color: "#667781",
		textAlign: "right",
		marginTop: 4,
	},
	
	chatInput: {
		backgroundColor: "#f0f2f5",
		borderTop: "1px solid #e9edef",
		padding: "12px 16px",
		display: "flex",
		alignItems: "center",
		gap: 8,
		position: "sticky",
		bottom: 0,
		zIndex: 10,
	},
	
	inputField: {
		flex: 1,
		backgroundColor: "#ffffff",
		borderRadius: 8,
		padding: "10px 12px",
		fontSize: 15,
		position: 'relative',
	},
	
	welcomeContainer: {
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
		justifyContent: "center",
		height: "100%",
		backgroundColor: "#f0f2f5",
		borderBottom: "6px solid #00a884",
		textAlign: "center",
		padding: 40,
	},
	
	welcomeIcon: {
		fontSize: 120,
		color: "#00a884",
		opacity: 0.3,
		marginBottom: 24,
	},
	
	welcomeTitle: {
		fontSize: 32,
		fontWeight: 300,
		color: "#41525d",
		marginBottom: 16,
		fontFamily: "'Segoe UI', Helvetica, Arial, sans-serif",
	},
	
	welcomeText: {
		fontSize: 14,
		color: "#667781",
		lineHeight: 1.5,
		maxWidth: 480,
		fontFamily: "'Segoe UI', Helvetica, Arial, sans-serif",
	},
	
	unreadBadge: {
		backgroundColor: "#25d366",
		color: "#fff",
		borderRadius: "10px",
		minWidth: 20,
		height: 20,
		padding: "0 6px",
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		fontSize: 12,
		fontWeight: 600,
	},
	
	statusChip: {
		height: 20,
		fontSize: 11,
		fontWeight: 500,
	},
}));

const CHANNEL_STYLES = {
	whatsapp: { bg: "#e8f5e9", color: "#00a884" },
	facebook: { bg: "#e7f0ff", color: "#1877F2" },
	instagram: { bg: "#ffe7f1", color: "#E4405F" },
};

// Função para detectar se é mensagem automática de anúncio Facebook/Instagram
const isAdAutomaticMessage = (message, channel) => {
	if (!message || !channel || !['facebook', 'instagram'].includes(channel)) return false;
	
	const adKeywords = [
		// Facebook
		'obrigado por entrar em contato',
		'agradecemos seu contato', 
		'responderemos em breve',
		'em breve retornamos',
		'mensagem automática',
		'atendimento automático',
		'fora do horário',
		'horário de atendimento',
		// Instagram
		'thanks for reaching out',
		'thank you for contacting',
		'we\'ll get back to you',
		'automated message',
		'auto reply',
		'out of office',
		// Padrões de anúncio
		'anúncio',
		'advertisement',
		'promoção',
		'oferta'
	];
	
	const messageText = (message.body || '').toLowerCase();
	
	// Verificar se contém palavras-chave de anúncio
	const hasAdKeyword = adKeywords.some(keyword => messageText.includes(keyword));
	
	// Verificar se é muito curto (muitas mensagens de anúncio são curtas)
	const isVeryShort = messageText.length < 20;
	
	// Verificar se contém emojis comuns de anúncios
	const hasAdEmoji = /[\ud83d\udce2\ud83d\udccb\ud83c\udfaf\ud83d\udcc8\ud83d\udcb0\ud83c\udff7\ufe0f]/.test(messageText);
	
	return hasAdKeyword || (isVeryShort && hasAdEmoji);
};

// Função para extrair parâmetros UTM da URL
const getUTMParameters = () => {
	const params = new URLSearchParams(window.location.search);
	const utmSource = params.get('utm_source');
	const utmMedium = params.get('utm_medium');
	const utmCampaign = params.get('utm_campaign');
	const utmTerm = params.get('utm_term');
	const utmContent = params.get('utm_content');
	
	if (utmSource || utmMedium || utmCampaign) {
		const utmParams = [];
		if (utmSource) utmParams.push(`source: ${utmSource}`);
		if (utmMedium) utmParams.push(`medium: ${utmMedium}`);
		if (utmCampaign) utmParams.push(`campaign: ${utmCampaign}`);
		if (utmTerm) utmParams.push(`term: ${utmTerm}`);
		if (utmContent) utmParams.push(`content: ${utmContent}`);
		
		return {
			source: `UTM: ${utmParams.join(' | ')}`,
			campaign: utmCampaign || ''
		};
	}
	
	return { source: '', campaign: '' };
};

// Função para criar lead automaticamente de anúncio Facebook/Instagram
const createLeadFromAd = async (ticket) => {
	try {
		const utmData = getUTMParameters();
		
		const leadData = {
			name: ticket.contact?.name || 'Contato Anúncio',
			email: '',
			phone: ticket.contact?.number || '',
			source: utmData.source || 'Facebook/Instagram Ads',
			campaign: utmData.campaign || '',
			status: 'new',
			temperature: 'quente',
			notes: `Lead gerado automaticamente via anúncio ${ticket.channel === 'facebook' ? 'Facebook' : 'Instagram'}\n` +
					`Ticket ID: ${ticket.id}\n` +
					`Data: ${new Date().toLocaleString('pt-BR')}\n` +
					`Canal: ${ticket.channel}`
		};
		
		// Construir URL com UTMs para enviar ao backend
		const utmParams = new URLSearchParams();
		if (utmData.source && utmData.source.includes('UTM:')) {
			// Extrair UTMs do source para enviar como query params
			const utmMatches = utmData.source.match(/source: ([^|]+)|medium: ([^|]+)|campaign: ([^|]+)|term: ([^|]+)|content: ([^|]+)/g);
			if (utmMatches) {
				utmMatches.forEach(match => {
					if (match.includes('source:')) {
						utmParams.append('utm_source', match.split('source: ')[1]);
					} else if (match.includes('medium:')) {
						utmParams.append('utm_medium', match.split('medium: ')[1]);
					} else if (match.includes('campaign:')) {
						utmParams.append('utm_campaign', match.split('campaign: ')[1]);
					} else if (match.includes('term:')) {
						utmParams.append('utm_term', match.split('term: ')[1]);
					} else if (match.includes('content:')) {
						utmParams.append('utm_content', match.split('content: ')[1]);
					}
				});
			}
		}
		
		const url = `/crm/leads${utmParams.toString() ? '?' + utmParams.toString() : ''}`;
		const { data } = await api.post(url, leadData);
		
		// Opcional: mostrar notificação
		if (window.Notification && Notification.permission === "granted") {
			new Notification('🎯 Lead Criado', {
				body: `${leadData.name} foi adicionado automaticamente`,
				icon: "/logo.png"
			});
		}
		
		return data;
	} catch (err) {
	}
};

const getChannelStyle = (channel) => CHANNEL_STYLES[channel] || CHANNEL_STYLES.whatsapp;

// Função para formatar texto do WhatsApp (negrito, itálico, riscado, monospace, quebras de linha)
const formatWhatsAppText = (text) => {
	if (!text || typeof text !== 'string') return text;

	// Escapar HTML para segurança
	let formatted = text
		.replace(/&/g, '&amp;')
		.replace(/</g, '&lt;')
		.replace(/>/g, '&gt;');

	// Negrito: *texto*
	formatted = formatted.replace(/\*([^*]+)\*/g, '<strong>$1</strong>');

	// Itálico: _texto_
	formatted = formatted.replace(/\_([^_]+)\_/g, '<em>$1</em>');

	// Riscado: ~texto~
	formatted = formatted.replace(/\~([^~]+)\~/g, '<del>$1</del>');

	// Monospace: ```texto```
	formatted = formatted.replace(/\`\`\`([^`]+)\`\`\`/g, '<code style="background:#f0f0f0;padding:2px 4px;border-radius:3px;font-family:monospace">$1</code>');

	// Monospace inline: `texto`
	formatted = formatted.replace(/\`([^`]+)\`/g, '<code style="background:#f0f0f0;padding:2px 4px;border-radius:3px;font-family:monospace">$1</code>');

	// Regex combinada: email ANTES de URL para não quebrar "user@gmail.com"
	// Suporta subdomínios múltiplos (ex: forms.site.com.br)
	const linkRegex = /(\b[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}\b)|(https?:\/\/[^\s<>"&]+)|(www\.[a-zA-Z0-9][^\s<>"&]+)|([a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?)+\.(com\.br|org\.br|net\.br|gov\.br|edu\.br|mil\.br|com|br|org|net|gov|edu|info|biz|io|ai|app|dev|tech|store|online|site|co|us|uk|ca|au|de|fr|es|it|pt|mx|ar)(?:[^\s<>"&]*)?)/g;

	formatted = formatted.replace(linkRegex, (match, email, httpsUrl, wwwUrl, domainUrl) => {
		if (email) {
			return `<a href="https://mail.google.com/mail/?view=cm&to=${encodeURIComponent(email)}" target="_blank" rel="noopener noreferrer" style="color:#0084ff;text-decoration:underline;cursor:pointer;user-select:text;font-weight:500;">${email}</a>`;
		}
		const url = httpsUrl || wwwUrl || domainUrl;
		if (!url) return match;
		const href = url.startsWith('http') ? url : `https://${url}`;
		return `<a href="${href}" target="_blank" rel="noopener noreferrer" style="color:#0084ff;text-decoration:underline;cursor:pointer;user-select:text;">${url}</a>`;
	});

	// Quebras de linha: \n para <br>
	formatted = formatted.replace(/\n/g, '<br/>');

	return formatted;
};

const Atendimentos = () => {
	const classes = useStyles();
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
	const { ticketId } = useParams();
	const history = useHistory();
	const location = useLocation();
	const { user } = useContext(AuthContext);
	const { showConfirm, showAlert } = useSystemAlert();
	
	// Verificar se está no modo mobile app (via URL params)
	const urlParams = new URLSearchParams(location.search);
	const mobileApp = urlParams.get('mobileApp') === 'true';
	const hideMenu = urlParams.get('hideMenu') === 'true';
	
	// Ocultar menu fixo se estiver no modo mobile app
	const shouldHideMobileMenu = mobileApp && hideMenu;
	
	// Índice inicial da aba: 0 para todos (Automação para admin, Aguardando para não-admin)
	const [tabIndex, setTabIndex] = useState(0);
	const [tickets, setTickets] = useState([]);
	const [selectedTicket, setSelectedTicket] = useState(null);
	const [messages, setMessages] = useState([]);

	// Mapa de reações por mensagem: { [msgId]: { [emoji]: count } }
	const reactionsMap = useMemo(() => {
		const map = {};
		messages.forEach(msg => {
			if (msg.mediaType !== "reactionMessage") return;
			const targetId = msg.quotedMsg?.id;
			if (!targetId) return;
			if (!map[targetId]) map[targetId] = {};
			const emoji = (msg.body || "").trim();
			if (emoji) {
				map[targetId][emoji] = (map[targetId][emoji] || 0) + 1;
			}
		});
		return map;
	}, [messages]);

	// Mensagens sem reactionMessage (reações são exibidas inline no original)
	const messagesWithoutReactions = useMemo(
		() => messages.filter(msg => msg.mediaType !== "reactionMessage"),
		[messages]
	);
	const [loading, setLoading] = useState(false);
	const [searchTerm, setSearchTerm] = useState("");
	const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");
	const [filterAnchor, setFilterAnchor] = useState(null);
	const [selectedQueues, setSelectedQueues] = useState([]);
	const [selectedUsers, setSelectedUsers] = useState([]);
	const [selectedTags, setSelectedTags] = useState([]);
	const [selectedKanbanTags, setSelectedKanbanTags] = useState([]);
	const [selectedWhatsapps, setSelectedWhatsapps] = useState([]);
	const [selectedChannelsQuickFilter, setSelectedChannelsQuickFilter] = useState([]);
	const [messageDirectionFilter, setMessageDirectionFilter] = useState(null); // 'waiting_customer' | 'waiting_agent' | null
	const [queues, setQueues] = useState([]);
	const [users, setUsers] = useState([]);
	const [tags, setTags] = useState([]);
	const [whatsapps, setWhatsapps] = useState([]);
	const [unreadCounts, setUnreadCounts] = useState({
		pending: 0,
		open: 0,
		closed: 0,
		automation: 0,
		groups: 0
	});
	const [closeAllDialogOpen, setCloseAllDialogOpen] = useState(false);
	const [closingAllTickets, setClosingAllTickets] = useState(false);
	const [currentTime, setCurrentTime] = useState(Date.now());
	const [messageMenuAnchor, setMessageMenuAnchor] = useState(null);
	const [selectedMessage, setSelectedMessage] = useState(null);
	const [deleteModalOpen, setDeleteModalOpen] = useState(false);
	const [editModalOpen, setEditModalOpen] = useState(false);
	const [forwardModalOpen, setForwardModalOpen] = useState(false);
	const [replyingTo, setReplyingTo] = useState(null);
	const [viewingDeletedMessage, setViewingDeletedMessage] = useState(null);
	const [ticketMenuAnchor, setTicketMenuAnchor] = useState(null);
	const [selectedTicketForMenu, setSelectedTicketForMenu] = useState(null);
	const [tagsKanbanModalOpen, setTagsKanbanModalOpen] = useState(false);
	const [notesDrawerOpen, setNotesDrawerOpen] = useState(false);
	const [mediaGalleryOpen, setMediaGalleryOpen] = useState(false);
	const [galleryMedias, setGalleryMedias] = useState([]);
	const [galleryInitialIndex, setGalleryInitialIndex] = useState(0);
	const [hasMore, setHasMore] = useState(false);
	const [pageNumber, setPageNumber] = useState(1);
	// Paginação da lista de tickets
	const [ticketsHasMore, setTicketsHasMore] = useState(false);
	const [ticketsPage, setTicketsPage] = useState(1);
	const [loadingMoreTickets, setLoadingMoreTickets] = useState(false);
	const ticketsListRef = useRef(null);
	const TICKETS_PAGE_SIZE = 12;
	const TICKETS_MORE_SIZE = 5;
	const [loadingMore, setLoadingMore] = useState(false);
	const [contactModalOpen, setContactModalOpen] = useState(false);
	const [contactModalContact, setContactModalContact] = useState(null);
	const [faturaModalOpen, setFaturaModalOpen] = useState(false);
	const [appointmentModalOpen, setAppointmentModalOpen] = useState(false);
	const [appointmentInitialData, setAppointmentInitialData] = useState(null);
	const [projectModalOpen, setProjectModalOpen] = useState(false);
	const [clientDetailsModalOpen, setClientDetailsModalOpen] = useState(false);
	const [convertToClientModalOpen, setConvertToClientModalOpen] = useState(false);
	const [historyModalOpen, setHistoryModalOpen] = useState(false);
	const [mobileView, setMobileView] = useState("list");
	const [transferTicketModalOpen, setTransferTicketModalOpen] = useState(false);
	const [mobileActionsOpen, setMobileActionsOpen] = useState(false);
	const [showEmojiPicker, setShowEmojiPicker] = useState(false);
	const [showQuickReplies, setShowQuickReplies] = useState(false);
	const [quickMessages, setQuickMessages] = useState([]);
	const [quickMessagesOpen, setQuickMessagesOpen] = useState(false);
	const [quickMessagePreview, setQuickMessagePreview] = useState(null);
	const [quickMessagePreviewOpen, setQuickMessagePreviewOpen] = useState(false);
	const [inputMessage, setInputMessage] = useState("");
	const [debouncedInputMessage] = useDebounce(inputMessage, 500);
	const [signMessage, setSignMessage] = useState(true);
	const [selectedFile, setSelectedFile] = useState(null);
	const [selectedFiles, setSelectedFiles] = useState([]);
	const [mediaPreviewOpen, setMediaPreviewOpen] = useState(false);
	const [mediaRecorder, setMediaRecorder] = useState(null);
	const [recording, setRecording] = useState(false);
	const [recordingTime, setRecordingTime] = useState(0);
	const [recordingInterval, setRecordingInterval] = useState(null);
	const [isTyping, setIsTyping] = useState(false);
	const [typingUser, setTypingUser] = useState(null);
	const [scheduleModalOpen, setScheduleModalOpen] = useState(false);
	const [attachmentModalOpen, setAttachmentModalOpen] = useState(false);
	const [emailComposeOpen, setEmailComposeOpen] = useState(false);
	const [emailComposeTo, setEmailComposeTo] = useState("");
	const [quizSelectOpen, setQuizSelectOpen] = useState(false);
	const [contactSendModalOpen, setContactSendModalOpen] = useState(false);
	const [locationModalOpen, setLocationModalOpen] = useState(false);
	const [cameraModalOpen, setCameraModalOpen] = useState(false);
	const [filteredQuickMessages, setFilteredQuickMessages] = useState([]);
	const userType = (user?.userType || "admin").toLowerCase();
	const isRestrictedUserType = userType === "attendant" || userType === "professional";
	const canCreateGroup = userType === "administrador" || user?.allowGroup === true;

	const [createGroupModal, setCreateGroupModal] = useState(false);
	const [novaConversaAberta, setNovaConversaAberta] = useState(false);
	const [chamadaOficial, setChamadaOficial] = useState(null);
	const [newGroupSubject, setNewGroupSubject] = useState("");
	const [newGroupParticipants, setNewGroupParticipants] = useState("");
	const [newGroupWhatsappId, setNewGroupWhatsappId] = useState("");
	const [creatingGroup, setCreatingGroup] = useState(false);
	const [participantsModal, setParticipantsModal] = useState({ open: false, jid: null, whatsappId: null, name: "" });
	const [settingsModal, setSettingsModal] = useState({ open: false, jid: null, whatsappId: null, name: "" });
	const [imageModal, setImageModal] = useState({ open: false, jid: null, whatsappId: null, name: "" });
	const [inviteModal, setInviteModal] = useState({ open: false, jid: null, whatsappId: null, name: "", link: "", loading: false });
	const [groupAdminMap, setGroupAdminMap] = useState({});

	const [showAllTickets, setShowAllTickets] = useState(() => {
		if (isRestrictedUserType) return false;
		const savedState = localStorage.getItem('showAllTickets');
		return savedState ? JSON.parse(savedState) : false;
	});
	const [isSendingMessage, setIsSendingMessage] = useState(false);
	const [aiProviders, setAiProviders] = useState([]);
	const [aiMenuAnchor, setAiMenuAnchor] = useState(null);
	const [aiSuggestOpen, setAiSuggestOpen] = useState(false);
	const [aiSummaryOpen, setAiSummaryOpen] = useState(false);
	const [aiAskOpen, setAiAskOpen] = useState(false);
	const [selectedQuickIndex, setSelectedQuickIndex] = useState(-1);
	const [quickReplySearchTerm, setQuickReplySearchTerm] = useState('');

	const quickReplyStartIndexRef = useRef(-1);
	const keepInputFocusRef = useRef(true);
	const inputMessageRef = useRef(null);
	const messagesEndRef = useRef(null);
	const messagesContainerRef = useRef(null);
	const audioContextRef = useRef(null);
	const fileInputRef = useRef(null);
	const lastSendTimeRef = useRef(0);
	const isSendingMessageRef = useRef(false);
	const selectedTicketRef = useRef(null);
	const isPaginatingRef = useRef(false);
	const lastScrolledMessageIdRef = useRef(null);
	const { list: listQuickMessages } = useQuickMessages();

	// Memoizar flags de permissão para uso nos sockets
	const permissionFlags = useMemo(() => ({
		hasAllTicket: user?.allTicket === "enabled" || user?.allTicket === "enable",
		hasAllUserChat: user?.allUserChat === "enabled" || user?.allUserChat === "enable",
		hasAllQueues: user?.allHistoric === "enabled" || user?.allHistoric === "enable",
		allowGroup: user?.allowGroup === true
	}), [user]);

	// IDs das filas do usuário para filtros
	const userQueueIds = useMemo(() => 
		user?.queues?.map(q => q.id) || [], 
		[user]
	);

	const resetQuickReplyState = useCallback(() => {
		setQuickReplySearchTerm('');
		quickReplyStartIndexRef.current = -1;
		setShowQuickReplies(false);
		setFilteredQuickMessages([]);
		setSelectedQuickIndex(-1);
	}, []);

	const updateQuickReplyContext = useCallback((value) => {
		const slashIndex = value.lastIndexOf('/');
		if (slashIndex === -1) {
			resetQuickReplyState();
			return;
		}
		quickReplyStartIndexRef.current = slashIndex;
		const afterSlash = value.slice(slashIndex + 1);
		const match = afterSlash.match(/^\S*/);
		const query = match ? match[0] : '';
		setQuickReplySearchTerm(query);
	}, [resetQuickReplyState]);

	// Emit de typing com debounce — evita flood de eventos no socket a cada tecla
	useEffect(() => {
		if (!selectedTicket) return;
		const socket = socketConnection({ companyId: user.companyId });
		if (debouncedInputMessage.length > 0) {
			socket.emit(`company-${user.companyId}-typing`, {
				ticketId: selectedTicket.id,
				isTyping: true,
				user: user.name
			});
		} else {
			socket.emit(`company-${user.companyId}-typing`, {
				ticketId: selectedTicket.id,
				isTyping: false,
				user: user.name
			});
		}
	}, [debouncedInputMessage, selectedTicket]);

	const handleSelectQuickReply = useCallback((messageObj) => {
		console.log("🖱️ Selecionou resposta rápida:", messageObj);

		// Resposta rápida com botões CTA — abre preview para confirmar antes de enviar
		if (messageObj.messageType === "buttons" && messageObj.buttons?.length) {
			resetQuickReplyState();
			setInputMessage("");
			setQuickMessagePreview(messageObj);
			setQuickMessagePreviewOpen(true);
			return;
		}

		// Se tem arquivo anexado, abre modal de preview
		if (messageObj.mediaPath) {
			console.log("📎 Tem arquivo - abrindo preview do arquivo");
			setQuickMessagePreview(messageObj);
			setQuickMessagePreviewOpen(true);
			resetQuickReplyState();
			return;
		}
		
		// Se não tem arquivo, insere o texto no campo
		const message = messageObj.message || messageObj;
		setInputMessage(prev => {
			if (quickReplyStartIndexRef.current >= 0) {
				const before = prev.slice(0, quickReplyStartIndexRef.current).trimEnd();
				const afterIndex = quickReplyStartIndexRef.current + 1 + quickReplySearchTerm.length;
				const after = prev.slice(afterIndex).trimStart();
				return [before, message, after].filter(Boolean).join(" ");
			}
			return message;
		});
		resetQuickReplyState();
		keepInputFocusRef.current = true;
		requestAnimationFrame(() => {
			if (inputMessageRef.current) {
				inputMessageRef.current.focus({ preventScroll: true });
			}
		});
	}, [quickReplySearchTerm, resetQuickReplyState]);

	const channelQuickOptions = [
		{ key: "whatsapp", label: "WhatsApp", color: "#25d366", icon: <WhatsAppIcon fontSize="small" /> },
		{ key: "facebook", label: "Facebook", color: "#1877F2", icon: <FacebookIcon fontSize="small" /> },
		{ key: "instagram", label: "Instagram", color: "#E4405F", icon: <InstagramIcon fontSize="small" /> }
	];

	const toggleChannelQuickFilter = channel => {
		setSelectedChannelsQuickFilter(prev =>
			prev.includes(channel) ? prev.filter(item => item !== channel) : [...prev, channel]
		);
	};

	const handleOpenContactModal = () => {
		if (selectedTicket?.contact) {
			setContactModalContact(selectedTicket.contact);
			setContactModalOpen(true);
		}
	};

	// ===== WAVoIP - Botão de Ligação =====
	const [wavoipModalOpen, setWavoipModalOpen] = useState(false);
	const [wavoipUrl, setWavoipUrl] = useState("");
	const [activeCallRecordId, setActiveCallRecordId] = useState(null);
	const [callStartTime, setCallStartTime] = useState(null);

	// A Meta so deixa a empresa ligar para quem autorizou. Sem este pedido, a
	// ligacao para um contato novo e recusada e nao ha como o atendente saber
	// por que. Limites dela: 1 pedido por 24h e 2 em 7 dias.
	const [pedindoPermissao, setPedindoPermissao] = useState(false);

	const handlePedirPermissaoLigacao = async () => {
		const numero = String(selectedTicket?.contact?.number || "").replace(/\D/g, "");
		if (!numero) {
			toast.error("Contato sem número.");
			return;
		}
		setPedindoPermissao(true);
		try {
			await api.post(
				`/whatsapp-official/${selectedTicket.whatsappId}/chamada/permissao`,
				{ numero }
			);
			toast.success("Pedido enviado. O cliente precisa aceitar para você poder ligar.");
		} catch (e) {
			toast.error(
				e?.response?.data?.error ||
					e?.response?.data?.message ||
					"Não foi possível enviar o pedido."
			);
		}
		setPedindoPermissao(false);
	};

	// Ligacao pela API oficial. Caminho proprio, botao proprio — o Wavoip
	// continua exatamente como era, sem se misturar com este.
	const handleLigacaoOficial = async () => {
		const numero = String(selectedTicket?.contact?.number || "").replace(/\D/g, "");
		if (!numero) {
			toast.error("Contato sem número para ligar.");
			return;
		}
		setChamadaOficial({
			whatsappId: selectedTicket.whatsappId,
			numero,
			nome: selectedTicket?.contact?.name || numero,
			chave: Date.now()
		});
	};

	const handleOpenWavoipCall = async () => {
		if (!selectedTicket) return;
		try {
			// Solicitar permissão do microfone antes de abrir a chamada
			try {
				const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
				// Parar o stream imediatamente - só precisamos da permissão
				stream.getTracks().forEach(track => track.stop());
			} catch (micErr) {
				toast.error("Permissão do microfone negada. Libere o microfone nas configurações do navegador para realizar chamadas.");
				return;
			}

			const { data } = await api.get(`/tickets/${selectedTicket.id}`);
			const token = data?.whatsapp?.wavoip;
			const phone = data?.contact?.number?.replace(/\D/g, "");
			const name = data?.contact?.name;

			if (!token || !phone) {
				toast.error("Token WAVoIP ou número de telefone não disponível.");
				return;
			}

			// Registrar chamada de saída no histórico
			try {
				const callRes = await api.post("/call-records", {
					contactId: data?.contact?.id,
					whatsappId: data?.whatsapp?.id,
					ticketId: selectedTicket.id,
					toNumber: phone,
				});
				setActiveCallRecordId(callRes.data.id);
				setCallStartTime(Date.now());
			} catch (callErr) {
				console.error("Erro ao registrar chamada:", callErr);
			}

			const url = `https://app.wavoip.com/call?token=${token}&phone=${phone}&name=${name}&start_if_ready=true&close_after_call=true`;
			setWavoipUrl(url);
			setWavoipModalOpen(true);
		} catch (err) {
			toast.error("Erro ao buscar dados para ligação.");
		}
	};

	const handleCloseWavoipModal = async () => {
		// Atualizar registro da chamada com duração
		if (activeCallRecordId && callStartTime) {
			const duration = Math.round((Date.now() - callStartTime) / 1000);
			try {
				await api.put(`/call-records/${activeCallRecordId}`, {
					status: duration > 3 ? "answered" : "missed",
					duration,
				});
			} catch (err) {
				console.error("Erro ao atualizar chamada:", err);
			}
		}
		setActiveCallRecordId(null);
		setCallStartTime(null);
		setWavoipModalOpen(false);
		setWavoipUrl("");
	};

	const handleOpenAppointmentModal = async () => {
		if (!selectedTicket) return;

		try {
			// Buscar agenda do usuário logado
			const { data: schedulesRes } = await api.get("/user-schedules");
			const userSchedule = schedulesRes.schedules?.find(s => s.userId === user?.id && s.active);

			const ticketClientId = selectedTicket?.crmClient?.id;
			const contactClientRaw = selectedTicket?.contact?.crmClients?.[0];
			const contactClientId =
				typeof contactClientRaw === "object" ? contactClientRaw?.id : contactClientRaw;
			const resolvedClientId = ticketClientId || contactClientId || null;

			// Determinar qual vínculo usar: cliente > contato
			let initialData = {
				scheduleId: userSchedule?.id || null,
				contactId: null,
				clientId: null,
				leadId: null
			};

			// Prioridade: Cliente vinculado ao ticket/contato
			if (resolvedClientId) {
				initialData.clientId = resolvedClientId;
			}
			// Se não tem cliente, usar contato
			else if (selectedTicket.contact?.id) {
				initialData.contactId = selectedTicket.contact.id;
			}

			setAppointmentInitialData(initialData);
			setAppointmentModalOpen(true);
		} catch (err) {
			console.error("Erro ao abrir modal de compromisso:", err);
			setAppointmentModalOpen(true);
		}
	};

	const handleOpenFaturaModal = async () => {
		if (!selectedTicket) {
			toast.error("Nenhum ticket selecionado.");
			return;
		}
		
		// **NOVO: Verificação por telefone**
		const hasClient = selectedTicket?.crmClient || selectedTicket?.contact?.crmClients?.[0];
		
		if (hasClient) {
			// Se já tem cliente vinculado, abre o modal
			setFaturaModalOpen(true);
			return;
		}
		
		// **NOVO: Buscar cliente por telefone**
		try {
			const contactPhone = selectedTicket?.contact?.number;
			if (!contactPhone) {
				// **CORREÇÃO: Abrir modal mesmo sem telefone para busca manual**
				setFaturaModalOpen(true);
				return;
			}
			
			// Limpar o telefone (remover caracteres especiais)
			const cleanPhone = contactPhone.replace(/\D/g, '');
			
			// Buscar em clientes, leads e contatos pelo telefone
			const { data: clients } = await api.get(`/clients`, {
				params: { searchParam: cleanPhone, phone: cleanPhone }
			});
			
			const { data: leads } = await api.get(`/leads`, {
				params: { searchParam: cleanPhone, phone: cleanPhone }
			});
			
			const { data: contacts } = await api.get(`/contacts`, {
				params: { searchParam: cleanPhone, phone: cleanPhone }
			});
			
			// Verificar se encontrou algum cliente/lead/contato com o mesmo telefone
			const foundClient = clients.find(c => c.phone && c.phone.replace(/\D/g, '') === cleanPhone);
			const foundLead = leads.find(l => l.phone && l.phone.replace(/\D/g, '') === cleanPhone);
			const foundContact = contacts.find(c => c.number && c.number.replace(/\D/g, '') === cleanPhone);
			
			if (foundClient) {
				// Vincular o cliente encontrado ao contato
				await api.put(`/contacts/${selectedTicket.contact.id}`, {
					crmClients: [foundClient.id]
				});
				
				// Atualizar o ticket selecionado com o cliente vinculado
				setSelectedTicket(prev => ({
					...prev,
					crmClient: foundClient,
					contact: {
						...prev.contact,
						crmClients: [foundClient]
					}
				}));
				
				toast.success(`Cliente "${foundClient.name}" encontrado e vinculado pelo telefone!`);
				setFaturaModalOpen(true);
				return;
			}
			
			if (foundLead) {
				toast.info(`Lead "${foundLead.name}" encontrado com mesmo telefone. Converta o lead para cliente primeiro.`);
				return;
			}
			
			if (foundContact) {
				toast.warning("Contato encontrado com mesmo telefone, mas sem cliente vinculado.");
				return;
			}
			
			// **CORREÇÃO: Abrir modal mesmo sem encontrar cliente para vinculação manual**
			setFaturaModalOpen(true);
			
		} catch (err) {
			// **CORREÇÃO: Abrir modal mesmo em caso de erro**
			setFaturaModalOpen(true);
		}
	};

	const handleOpenProjectModal = () => {
		if (!selectedTicket) return;
		setProjectModalOpen(true);
	};

	const handleOpenClientDetailsModal = () => {
		if (!selectedTicket) return;
		
		const client = selectedTicket?.crmClient || selectedTicket?.contact?.crmClients?.[0];
		
		if (client) {
			setClientDetailsModalOpen(true);
		}
	};

	const handleConvertToClient = async (emailFromModal = '') => {
		if (!selectedTicket?.contact) return;
		
		try {
			// **NOVO: Usar email do modal ou do contato**
			const finalEmail = emailFromModal || selectedTicket.contact.email || `${selectedTicket.contact.number}@whatsapp.local`;
			
			// **NOVO: Verificar se cliente já existe antes de criar**
			const { data: existingClients } = await api.get('/crm/clients', {
				params: { 
					companyId: 1, // ou user?.companyId
					email: finalEmail,
					phone: selectedTicket.contact.number
				}
			});
			
			// Se já existe cliente, apenas vincular ao contato
			if (existingClients && existingClients.length > 0) {
				const existingClient = existingClients[0];
				
				// Vincular cliente existente ao contato
				await api.put(`/contacts/${selectedTicket.contact.id}`, {
					crmClients: [existingClient.id]
				});
				
				// **RECARREGAR TICKET DO BACKEND**
				const { data: reloadedTicket } = await api.get(`/tickets/${selectedTicket.id}`);
				
				// **CRIAR NOVO OBJETO IMUTÁVEL garantindo que crmClient está populado**
				const clientData = reloadedTicket.crmClient || reloadedTicket.contact?.crmClients?.[0] || null;
				
				const updatedTicket = {
					...reloadedTicket,
					crmClient: clientData,
					contact: {
						...reloadedTicket.contact,
						crmClients: reloadedTicket.contact?.crmClients || []
					},
					_updateKey: Date.now() // Força re-render
				};
				
				// **ATUALIZAÇÃO DIRETA SEM LIMPAR**
				setSelectedTicket(updatedTicket);
				
				setTickets(prevTickets => 
					prevTickets.map(ticket => 
						ticket.id === selectedTicket.id ? updatedTicket : ticket
					)
				);
				
				toast.success('Cliente existente vinculado ao contato com sucesso!');
				setConvertToClientModalOpen(false);
				
				// **FORÇAR RE-RENDER antes de abrir modal**
				await new Promise(resolve => setTimeout(resolve, 100));
				
				// Aguardar estado atualizar antes de abrir modal
				setTimeout(() => {
					setClientDetailsModalOpen(true);
				}, 200);
				return;
			}
			
			// Criar novo cliente se não existir
			const { data: newClient } = await api.post('/crm/clients', {
				name: selectedTicket.contact.name,
				email: finalEmail, // **USAR EMAIL DO MODAL**
				phone: selectedTicket.contact.number,
				userId: user?.id,
				whatsappId: selectedTicket.whatsappId,
				source: 'whatsapp'
			});
			
			// Vincular cliente ao contato
			await api.put(`/contacts/${selectedTicket.contact.id}`, {
				crmClients: [newClient.id]
			});
			
			// **NOVO: Converter leads vinculados ao contato para este cliente**
			try {
				console.log('🔍 Buscando leads para contato ID:', selectedTicket.contact.id);
				
				// **CORREÇÃO: Usar a API correta como no LeadModal**
				let contactLeads = [];
				
				try {
					// **Tentativa 1: Buscar todos os leads (como no LeadModal)**
					const { data: allLeads } = await api.get("/crm/leads");
					console.log('📋 Todos os leads carregados:', allLeads?.length || 0);
					
					// Filtrar leads do contato atual
					contactLeads = allLeads.filter(lead => {
						const matchByPhone = lead.phone === selectedTicket.contact.number;
						const matchByEmail = lead.email === selectedTicket.contact.email;
						const matchByName = lead.name === selectedTicket.contact.name;
						
						console.log('🔍 Lead analisado:', {
							id: lead.id,
							name: lead.name,
							phone: lead.phone,
							email: lead.email,
							matchByPhone,
							matchByEmail,
							matchByName
						});
						
						return matchByPhone || matchByEmail || matchByName;
					});
					
					console.log('✅ Leads encontrados por filtro:', contactLeads.length);
					
				} catch (err) {
					console.error('❌ Erro ao buscar leads:', err);
				}
				
				if (contactLeads && contactLeads.length > 0) {
					console.log('🔄 Convertendo', contactLeads.length, 'leads...');
					
					// Atualizar todos os leads para vincular ao novo cliente
					const leadUpdatePromises = contactLeads.map(lead => {
						console.log('🔄 Convertendo lead:', lead.id, '→ cliente:', newClient.id);
						
						// **CORREÇÃO: Usar API correta como no LeadModal**
						const payload = {
							...lead,
							clientId: newClient.id,
							status: 'converted'
						};
						
						return api.put(`/crm/leads/${lead.id}`, payload);
					});
					
					await Promise.all(leadUpdatePromises);
					console.log(`✅ ${contactLeads.length} leads convertidos e vinculados ao cliente ${newClient.id}`);
				} else {
					console.log('⚠️ Nenhum lead encontrado para o contato');
				}
			} catch (leadError) {
				console.error('❌ Erro ao converter leads do contato:', leadError);
			}
			
			// **RECARREGAR TICKET DO BACKEND para garantir dados atualizados**
			const { data: reloadedTicket } = await api.get(`/tickets/${selectedTicket.id}`);
			
			console.log('🔄 Ticket recarregado do backend:', reloadedTicket);
			
			// **CRIAR NOVO OBJETO IMUTÁVEL garantindo que crmClient está populado**
			const clientData = reloadedTicket.crmClient || reloadedTicket.contact?.crmClients?.[0] || null;
			
			const updatedTicket = {
				...reloadedTicket,
				crmClient: clientData,
				contact: {
					...reloadedTicket.contact,
					crmClients: reloadedTicket.contact?.crmClients || []
				},
				_updateKey: Date.now() // Força re-render
			};
			
			// **ATUALIZAÇÃO DIRETA SEM LIMPAR**
			setSelectedTicket(updatedTicket);
			
			// **NOVO: Atualizar ticket na lista de tickets também**
			setTickets(prevTickets => {
				const newTickets = prevTickets.map(ticket => 
					ticket.id === selectedTicket.id ? updatedTicket : ticket
				);
				return newTickets;
			});
			
			toast.success('Contato e leads convertidos para cliente com sucesso!');
			setConvertToClientModalOpen(false);
			
			// **FORÇAR RE-RENDER antes de abrir modal**
			await new Promise(resolve => setTimeout(resolve, 100));
			
			// Aguardar estado atualizar antes de abrir modal
			setTimeout(() => {
				setClientDetailsModalOpen(true);
			}, 200);
			
		} catch (err) {
			console.error('Erro ao converter contato para cliente:', err);
			toast.error('Erro ao converter contato para cliente');
		}
	};

	// **USAR useMemo para garantir re-render quando selectedTicket mudar**
	const hasClient = useMemo(() => {
		return selectedTicket?.crmClient || selectedTicket?.contact?.crmClients?.[0];
	}, [selectedTicket?.crmClient, selectedTicket?.contact?.crmClients]);

	const renderTicketActionButtons = (buttonSize = 36, iconSize = 20) => {
		if (!selectedTicket) return null;

		const buttonBaseStyle = {
			width: buttonSize,
			height: buttonSize,
		};

		return (
			<>
				{selectedTicket.status === "pending" && (
					<>
						<IconButton
							size="small"
							onClick={async () => {
								try {
									await api.put(`/tickets/${selectedTicket.id}`, {
										status: "open",
										userId: user?.id,
									});
									
									// **NOVO: Atualização instantânea sem F5**
									setTickets(prevTickets => {
										const updatedTickets = prevTickets.map(ticket => {
											if (ticket.id === selectedTicket.id) {
												return {
													...ticket,
													status: "open",
													userId: user?.id,
													updatedAt: new Date().toISOString()
												};
											}
											return ticket;
										});
										
										// Reordena para colocar o ticket aceito no topo da aba "Atendendo"
										return updatedTickets.sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt));
									});
									
									// Atualiza o ticket selecionado
									setSelectedTicket(prev => ({
										...prev,
										status: "open",
										userId: user?.id
									}));
									
									// Atualiza contadores
									loadUnreadCounts();
									
									// **NOVO: Muda para aba "Atendendo" (tab 2) e navega para o ticket**
									if (tabIndex !== 2) {
										setTabIndex(2);
									}
									
									// **NOVO: Navega para a URL do ticket aceito**
									history.push(`/atendimentos/${selectedTicket.id}`);
									
								} catch (err) {
								}
							}}
							style={{
								...buttonBaseStyle,
								backgroundColor: "#00a884",
								color: "#fff",
							}}
							title="Aceitar"
						>
							<CheckCircleIcon style={{ fontSize: iconSize }} />
						</IconButton>
						<IconButton
							size="small"
							onClick={async () => {
								const confirmIgnorar = await showConfirm({
									type: "warning",
									title: "Ignorar Ticket",
									message: "Deseja realmente ignorar este ticket?",
									confirmText: "Sim, ignorar",
									cancelText: "Cancelar",
								});
								if (confirmIgnorar) {
									try {
										await api.delete(`/tickets/${selectedTicket.id}`);
										setSelectedTicket(null);
										history.push("/atendimentos");
										loadTickets();
										loadUnreadCounts();
									} catch (err) {
									}
								}
							}}
							style={{
								...buttonBaseStyle,
								backgroundColor: "#f44336",
								color: "#fff",
							}}
							title="Ignorar"
						>
							<BlockIcon style={{ fontSize: iconSize }} />
						</IconButton>
					</>
				)}
				{canReturnClosedTicket && (
					<IconButton
						size="small"
						onClick={handleReturnTicket}
						style={{
							...buttonBaseStyle,
							backgroundColor: "#1976d2",
							color: "#fff",
						}}
						title="Retornar ticket"
					>
						<ReplayIcon style={{ fontSize: iconSize }} />
					</IconButton>
				)}
				{selectedTicket.status === "open" && (
					<>
						<IconButton
							size="small"
							onClick={handleOpenWavoipCall}
							style={{
								...buttonBaseStyle,
								backgroundColor: "#0872b9",
								color: "#fff",
							}}
							title="Iniciar chamada"
						>
							<CallIcon style={{ fontSize: iconSize }} />
						</IconButton>

						{/* Ligacao pela API oficial da Meta. Botao SEPARADO do Wavoip
						    de proposito: sao caminhos diferentes e o atendente
						    precisa saber por qual esta ligando. */}
						{(selectedTicket?.whatsapp?.channel === "whatsapp_official" ||
							selectedTicket?.channel === "whatsapp_official") && (
							<IconButton
								size="small"
								onClick={handleLigacaoOficial}
								style={{
									...buttonBaseStyle,
									backgroundColor: "#00a884",
									color: "#fff",
								}}
								title="Ligar pela API oficial"
							>
								<PhoneInTalkIcon style={{ fontSize: iconSize }} />
							</IconButton>
						)}

						{(selectedTicket?.whatsapp?.channel === "whatsapp_official" ||
							selectedTicket?.channel === "whatsapp_official") && (
							<IconButton
								size="small"
								disabled={pedindoPermissao}
								onClick={handlePedirPermissaoLigacao}
								style={{
									...buttonBaseStyle,
									backgroundColor: "#7c5cff",
									color: "#fff",
								}}
								title="Pedir permissão para ligar"
							>
								<AddIcCallIcon style={{ fontSize: iconSize }} />
							</IconButton>
						)}
						<IconButton
							size="small"
							onClick={() => setHistoryModalOpen(true)}
							style={{
								...buttonBaseStyle,
								backgroundColor: "#ff9800",
								color: "#fff",
							}}
							title="Histórico de Conversas"
						>
							<HistoryIcon style={{ fontSize: iconSize }} />
						</IconButton>
						<IconButton
							size="small"
							onClick={handleOpenFaturaModal}
							style={{
								...buttonBaseStyle,
								backgroundColor: "#9c27b0",
								color: "#fff",
							}}
							title="Criar Fatura"
						>
							<ReceiptIcon style={{ fontSize: iconSize }} />
						</IconButton>
						<IconButton
							size="small"
							onClick={handleOpenAppointmentModal}
							style={{
								...buttonBaseStyle,
								backgroundColor: "#4caf50",
								color: "#fff",
							}}
							title="Agendar Compromisso"
						>
							<EventIcon style={{ fontSize: iconSize }} />
						</IconButton>
						<IconButton
							size="small"
							onClick={async () => {
								const confirmFechar = await showConfirm({
									type: "warning",
									title: "Fechar Ticket",
									message: "Deseja realmente fechar este ticket?",
									confirmText: "Sim, fechar",
									cancelText: "Cancelar",
								});
								if (confirmFechar) {
									try {
										await api.put(`/tickets/${selectedTicket.id}`, {
											status: "closed",
										});
										setSelectedTicket(null);
										history.push("/atendimentos");
										loadTickets();
										loadUnreadCounts();
									} catch (err) {
									}
								}
							}}
							style={{
								...buttonBaseStyle,
								backgroundColor: "#ff9800",
								color: "#fff",
							}}
							title="Fechar"
						>
							<CheckCircleIcon style={{ fontSize: iconSize }} />
						</IconButton>
						{["administrador", "gerente"].includes(user?.userType) && (
						<IconButton
							size="small"
							onClick={async () => {
								const confirmExcluir = await showConfirm({
									type: "error",
									title: "Excluir Ticket",
									message: "Deseja realmente excluir este ticket?",
									confirmText: "Sim, excluir",
									cancelText: "Cancelar",
								});
								if (confirmExcluir) {
									try {
										await api.delete(`/tickets/${selectedTicket.id}`);
										setSelectedTicket(null);
										history.push("/atendimentos");
										loadTickets();
										loadUnreadCounts();
									} catch (err) {
									}
								}
							}}
							style={{
								...buttonBaseStyle,
								backgroundColor: "#f44336",
								color: "#fff",
							}}
							title="Excluir"
						>
							<DeleteIcon style={{ fontSize: iconSize }} />
						</IconButton>
						)}
						<IconButton
							size="small"
							onClick={handleOpenTransferModal}
							style={{
								...buttonBaseStyle,
								backgroundColor: "#437db5",
								color: "#fff",
							}}
							title="Transferir fila/atendente"
						>
							<SwapHorizIcon style={{ fontSize: iconSize }} />
						</IconButton>
						<IconButton
							size="small"
							onClick={async () => {
								try {
									await api.post(`/tickets/${selectedTicket.id}/reset-flow`);
									toast.success("Fluxo reiniciado. A pr\u00f3xima mensagem do cliente come\u00e7a do zero.");
								} catch (err) {}
							}}
							style={{
								...buttonBaseStyle,
								backgroundColor: "#14B8A6",
								color: "#fff",
							}}
							title="Reiniciar fluxo"
						>
							<ReplayIcon style={{ fontSize: iconSize }} />
						</IconButton>
						{/* Botão de cliente oculto temporariamente */}
						{false && hasClient && (
						<IconButton
							size="small"
							onClick={handleOpenClientDetailsModal}
							style={{
								...buttonBaseStyle,
								backgroundColor: "#2196f3",
								color: "#fff",
							}}
							title="Ver Detalhes do Cliente"
						>
							<PersonIcon style={{ fontSize: iconSize }} />
						</IconButton>
					)}
						<IconButton
							size="small"
							onClick={handleOpenProjectModal}
							style={{
								...buttonBaseStyle,
								backgroundColor: "#ff6b35",
								color: "#fff",
							}}
							title="Criar Projeto"
						>
							<BusinessCenterIcon style={{ fontSize: iconSize }} />
						</IconButton>
						</>
				)}
				{(selectedTicket.status === "group") && (
					<IconButton
						size="small"
						onClick={async () => {
							const confirmFechar = await showConfirm({
								type: "warning",
								title: "Fechar Grupo",
								message: "Deseja realmente fechar este grupo?",
								confirmText: "Sim, fechar",
								cancelText: "Cancelar",
							});
							if (confirmFechar) {
								try {
									await api.put(`/tickets/${selectedTicket.id}`, { status: "closed" });
									setSelectedTicket(null);
									history.push("/atendimentos");
									loadTickets();
									loadUnreadCounts();
								} catch (err) {}
							}
						}}
						style={{
							...buttonBaseStyle,
							backgroundColor: "#ff9800",
							color: "#fff",
						}}
						title="Fechar grupo"
					>
						<CheckCircleIcon style={{ fontSize: iconSize }} />
					</IconButton>
				)}
				<IconButton
					size="small"
					onClick={() => setNotesDrawerOpen(true)}
					style={{
						...buttonBaseStyle,
						backgroundColor: "#6366f1",
						color: "#fff",
					}}
					title="Histórico de Atendimento"
				>
					<StickyNote2Icon style={{ fontSize: iconSize }} />
				</IconButton>
				<IconButton
					size="small"
					onClick={() => setTagsKanbanModalOpen(true)}
					style={{
						...buttonBaseStyle,
						backgroundColor: "#00a884",
						color: "#fff",
					}}
					title="Tags e Kanban"
				>
					<AddIcon style={{ fontSize: iconSize }} />
				</IconButton>
			</>
		);
	};

	const formatWaitingTime = (ticket) => {
		if (!ticket || ticket.status !== "pending") {
		 return null;
		}
		
		// Mostrar tempo de espera se tem usuário OU fila
		if (!hasAssignedUser(ticket) && !hasQueue(ticket)) {
			return null;
		}

		const referenceDate = ticket.updatedAt || ticket.createdAt;
		if (!referenceDate) return null;

		let parsedDate;
		try {
			parsedDate =
				typeof referenceDate === "string"
					? parseISO(referenceDate)
					: new Date(referenceDate);
		} catch (err) {
			return null;
		}

		return `Aguardando há ${formatDistanceToNow(parsedDate, {
			locale: ptBR,
			addSuffix: false
		})}`;
	};
	const handleCloseContactModal = () => {
		setContactModalOpen(false);
		setContactModalContact(null);
	};
	const handleOpenTransferModal = () => {
		if (!selectedTicket) return;
		setTransferTicketModalOpen(true);
	};

	const handleCloseTransferModal = async (ticketUpdated = false) => {
		setTransferTicketModalOpen(false);
		// O socket recebe o evento de atualização e cuida do estado automaticamente.
		// Re-buscar o ticket aqui causava race condition no mobile (ticket restaurado após o socket já tê-lo removido).
	};

	// **NOVO: Forçar re-render quando selectedTicket mudar**
	useEffect(() => {
		if (selectedTicket) {
			const client = selectedTicket?.crmClient || selectedTicket?.contact?.crmClients?.[0];
		}
	}, [selectedTicket]);


useEffect(() => {
	const raf = requestAnimationFrame(() => {
		if (inputMessageRef.current) {
			inputMessageRef.current.focus({ preventScroll: true });
			keepInputFocusRef.current = true;
		}
	});
	return () => cancelAnimationFrame(raf);
}, [messages, selectedTicket?.id]);

	const handleQuickReplyKeyDown = useCallback((e) => {
		if (!showQuickReplies) return false;

		switch (e.key) {
			case "ArrowDown":
				e.preventDefault();
				setSelectedQuickIndex(prev => {
					const next = prev + 1;
					return next >= filteredQuickMessages.length ? 0 : next;
				});
				return true;
			case "ArrowUp":
				e.preventDefault();
				setSelectedQuickIndex(prev => {
					const prevIndex = prev - 1;
					return prevIndex < 0 ? filteredQuickMessages.length - 1 : prevIndex;
				});
				return true;
			case "Enter":
				e.preventDefault();
				if (selectedQuickIndex >= 0 && filteredQuickMessages[selectedQuickIndex]) {
					handleSelectQuickReply(filteredQuickMessages[selectedQuickIndex]);
				}
				return true;
			case "Escape":
				e.preventDefault();
				setShowQuickReplies(false);
				setFilteredQuickMessages([]);
				setSelectedQuickIndex(-1);
				return true;
			default:
				return false;
		}
	}, [showQuickReplies, filteredQuickMessages, selectedQuickIndex, handleSelectQuickReply]);

	// Solicitar permissão para notificações ao carregar
	useEffect(() => {
		if ("Notification" in window && Notification.permission === "default") {
			Notification.requestPermission().then(permission => {
				if (permission === "granted") {
				}
			});
		}
	}, []);

	// Solicitar permissão do microfone ao carregar a página
	useEffect(() => {
		const requestMicrophonePermission = async () => {
			try {
				if ("permissions" in navigator) {
					const permission = await navigator.permissions.query({ name: 'microphone' });
					
					if (permission.state === 'prompt') {
					}
				}
			} catch (err) {
			}
		};
		
		requestMicrophonePermission();
	}, []);

	// Função para tocar som de notificação
	const playNotificationSound = () => {
		try {
			if (!audioContextRef.current) {
				audioContextRef.current = new (window.AudioContext || window.webkitAudioContext)();
			}
			
			const audioContext = audioContextRef.current;
			const oscillator = audioContext.createOscillator();
			const gainNode = audioContext.createGain();
			
			oscillator.connect(gainNode);
			gainNode.connect(audioContext.destination);
			
			// Som similar ao WhatsApp: duas notas rápidas e mais alto
			oscillator.frequency.setValueAtTime(600, audioContext.currentTime);
			oscillator.frequency.setValueAtTime(800, audioContext.currentTime + 0.1);
			
			// Aumentar volume para 0.5 (50% do máximo)
			gainNode.gain.setValueAtTime(0.5, audioContext.currentTime);
			gainNode.gain.exponentialRampToValueAtTime(0.01, audioContext.currentTime + 0.3);
			
			oscillator.start(audioContext.currentTime);
			oscillator.stop(audioContext.currentTime + 0.3);
		} catch (err) {
			if (err?.response?.status === 403) {
				handlePermissionDenied();
			} else {
				console.error("Erro ao carregar mensagens", err);
			}
		}
	};

	// Função para exibir notificação de desktop
	const showDesktopNotification = (contactName, messageBody) => {
		if ("Notification" in window && Notification.permission === "granted") {
			try {
				
				// Limitar tamanho da mensagem para notificação
				const truncatedBody = messageBody?.length > 100 
					? messageBody.substring(0, 100) + "..." 
					: messageBody || "Mídia";
				
				const notification = new Notification(`🔔 Nova mensagem de ${contactName}`, {
					body: truncatedBody,
					icon: "/logo.png",
					badge: "/logo.png",
					tag: "whaticket-message",
					renotify: true,
					requireInteraction: false,
					silent: false, // Garante que o som do navegador também toque
					vibrate: [200, 100, 200] // Vibração em dispositivos móveis
				});

				// Foca na janela quando clicar na notificação
				notification.onclick = () => {
					window.focus();
					notification.close();
				};

				// Auto-fecha após 8 segundos (mais tempo para ler)
				setTimeout(() => notification.close(), 8000);
				
				// Feedback visual no console
			} catch (err) {
			}
		} else if ("Notification" in window && Notification.permission === "denied") {
		} else {
		}
	};

	const scrollToBottom = (force = false) => {
		if (messagesEndRef.current) {
			const container = messagesContainerRef.current;
			if (!container) return;
			
			// Se for forçado, rola agressivamente sem verificar posição
			if (force) {
				// Usar scrollIntoView com behavior "auto" para mais agressividade
				messagesEndRef.current.scrollIntoView({ behavior: "auto" });
				
				// Segunda tentativa: scroll direto do container
				setTimeout(() => {
					if (container && messagesEndRef.current) {
						container.scrollTop = container.scrollHeight;
					}
				}, 50);
			} else {
				// Comportamento normal/inteligente - REATIVADO (WhatsApp Web)
				const isAtBottom = container.scrollHeight - container.scrollTop - container.clientHeight <= 150;
				
				if (isAtBottom) {
					messagesEndRef.current.scrollIntoView({ behavior: "smooth" });
				}
			}
		}
	};

	useEffect(() => {
		if (!loadingMore && messages.length > 0) {
			const lastMessage = messages[messages.length - 1];

			// Só rolar se a última mensagem é realmente nova (nova mensagem adicionada ao final)
			// Se o ID não mudou, foram adicionadas mensagens antigas ao início (paginação) — não rolar
			if (lastMessage?.id === lastScrolledMessageIdRef.current) return;
			lastScrolledMessageIdRef.current = lastMessage?.id;

			const isMyMessage = lastMessage?.fromMe === true;
			const container = messagesContainerRef.current;
			const isAtBottom = container ? (container.scrollHeight - container.scrollTop - container.clientHeight <= 150) : false;

			if (isMyMessage || isAtBottom) {
				setTimeout(() => {
					if (isMyMessage) {
						scrollToBottom(true);
						setTimeout(() => scrollToBottom(true), 100);
					} else {
						scrollToBottom(false);
					}
				}, 50);
			}
		}
	}, [messages, loadingMore]);

	useEffect(() => {
		const container = messagesContainerRef.current;
		if (!container) return;

		const handleScroll = () => {
			if (container.scrollTop < 100 && hasMore && !loadingMore) {
				loadMoreMessages();
			}
		};

		container.addEventListener('scroll', handleScroll);
		return () => container.removeEventListener('scroll', handleScroll);
	}, [hasMore, loadingMore, pageNumber, selectedTicket]);

	useEffect(() => {
		const handler = setTimeout(() => {
			setDebouncedSearchTerm(searchTerm);
		}, 350);
		return () => clearTimeout(handler);
	}, [searchTerm]);

	useEffect(() => {
		const interval = setInterval(() => {
			setCurrentTime(Date.now());
		}, 60000);

		return () => clearInterval(interval);
	}, []);

	// REATIVADO - Scroll apenas ao selecionar ticket (abertura inicial)
	useEffect(() => {
		if (selectedTicket && messages.length > 0) {
			// Forçar scroll para o final apenas na abertura
			setTimeout(() => {
				scrollToBottom(true);
			}, 100);
			
			setTimeout(() => {
				scrollToBottom(true);
			}, 250);
			
			setTimeout(() => {
				scrollToBottom(true);
			}, 400);
		}
	}, [selectedTicket?.id]);

	useEffect(() => {
		loadTickets();
		loadUnreadCounts();
	}, [
		tabIndex,
		debouncedSearchTerm,
		selectedQueues,
		selectedUsers,
		selectedTags,
		selectedKanbanTags,
		selectedWhatsapps,
		messageDirectionFilter,
		selectedChannelsQuickFilter,
		showAllTickets
	]);

	useEffect(() => {
		if (isMobile) {
			setShowEmojiPicker(false);
		}
	}, [isMobile]);

	useEffect(() => {
		if (ticketId) {
			// Navegação via URL (vindo de relatório/calendário) — força abertura sem verificar filtros
			forceOpenTicket(ticketId);
		} else {
			setSelectedTicket(null);
			setMessages([]);
		}
	}, [ticketId]);

	useEffect(() => {
		if (!ticketId) {
			history.replace('/atendimentos');
		}
	}, []);

	useEffect(() => {
		const loadQuickMessages = async () => {
			try {
				const messages = await listQuickMessages({ companyId: user.companyId, userId: user.id });
				setQuickMessages(messages);
			} catch (err) {
				console.error("❌ Erro ao carregar respostas rápidas:", err);
			}
		};
		loadQuickMessages();
	}, []);

	// Salva o estado do showAllTickets no localStorage quando mudar
	useEffect(() => {
		if (isRestrictedUserType) {
			setShowAllTickets(false);
			localStorage.removeItem('showAllTickets');
			return;
		}
		localStorage.setItem('showAllTickets', JSON.stringify(showAllTickets));
	}, [showAllTickets, isRestrictedUserType]);

	// Função para alternar o estado do showAllTickets
	const toggleShowAllTickets = () => {
		if (isRestrictedUserType) return;
		setShowAllTickets(prev => !prev);
	};

	useEffect(() => {
		loadFiltersData();
	}, []);

	// Manter refs sincronizados para uso no WebSocket (evita closure stale)
	const tabIndexRef = useRef(tabIndex);

	// Função combinada para verificar se ticket deve ser exibido
	const shouldDisplayTicketRef = useRef((ticket) => {
		if (!ticket) return false;
		
		// Verificar permissão base
		let canSeeTicket = false;
		if (ticket.userId === user?.id) {
			canSeeTicket = true;
		} else if (!ticket.userId && ticket.status === "pending") {
			const belongsToUserQueue = permissionFlags.hasAllQueues ||
				userQueueIds.includes(ticket.queueId) ||
				(!ticket.queueId && permissionFlags.hasAllTicket);
			canSeeTicket = belongsToUserQueue;
		} else if (ticket.userId && ticket.userId !== user?.id) {
			canSeeTicket = permissionFlags.hasAllUserChat || permissionFlags.hasAllTicket;
		} else if (ticket.status === "closed") {
			canSeeTicket = true;
		}
		
		// Verificar se pertence à aba atual
		const currentTab = tabIndexRef.current;
		let belongsToCurrentTab = false;
		
		// Grupos sempre aparecem APENAS na aba Grupos
		if (ticket.isGroup) {
			belongsToCurrentTab = currentTab === 4; // Apenas aba Grupos
		} else {
			if (currentTab === 0) {
				belongsToCurrentTab = ticket.status === "pending" && !hasAssignedUser(ticket) && !hasQueue(ticket); // Automação
			} else if (currentTab === 1) {
				belongsToCurrentTab = ticket.status === "pending" && (hasAssignedUser(ticket) || hasQueue(ticket)); // Aguardando
			} else if (currentTab === 2) {
				belongsToCurrentTab = ticket.status === "open" && hasAssignedUser(ticket); // Atendendo
			} else if (currentTab === 3) {
				belongsToCurrentTab = ticket.status === "closed"; // Fechados
			}
		}
		
		return canSeeTicket && belongsToCurrentTab;
	});

	// Manter refs sincronizadas para uso no WebSocket
	useEffect(() => {
		tabIndexRef.current = tabIndex;
		selectedTicketRef.current = selectedTicket;
	}, [tabIndex, selectedTicket]);

	// Refs sempre atualizadas para evitar stale closure no socket handler
	const ticketMatchesCurrentFiltersRef = useRef(null);
	const loadUnreadCountsRef = useRef(null);

	useEffect(() => {
		const socket = socketConnection({ companyId: user.companyId });

		socket.on(`company-${user.companyId}-ticket`, (data) => {
			if (data.action === "update" || data.action === "create") {
				// Usa ref para garantir loadUnreadCounts sempre atualizado (evita stale closure)
				setTimeout(() => {
					if (loadUnreadCountsRef.current) { loadUnreadCountsRef.current(); }
				}, 200);

				// Usa ref sempre atualizada para evitar stale closure (null-safe: se ref ainda não inicializou, ignora)
				if (ticketMatchesCurrentFiltersRef.current && !ticketMatchesCurrentFiltersRef.current(data.ticket)) {
					console.log(`[SOCKET-TICKET] Removendo ticket #${data.ticket?.id} — não passa no filtro atual. status=${data.ticket?.status}, userId=${data.ticket?.userId}, queueId=${data.ticket?.queueId}, isGroup=${data.ticket?.isGroup}`);
					// Remove da lista se já estiver visível
					setTickets(prev => {
						const existia = prev.some(t => t.id === data.ticket.id);
						if (existia) console.log(`[SOCKET-TICKET] Ticket #${data.ticket.id} removido da lista`);
						return prev.filter(t => t.id !== data.ticket.id);
					});

					// **CRÍTICO: Se este ticket estava selecionado, remove da seleção e limpa URL**
					const currentTicket = selectedTicketRef.current;
					if (currentTicket && currentTicket.id === data.ticket.id) {
						setSelectedTicket(null);
						setMessages([]);
						history.push("/atendimentos" + window.location.search);
					}

					return;
				}
				
				// Para notificação, verifica se pertence à aba atual
				const currentTab = tabIndexRef.current;
				const ticketStatus = data.ticket.status;
				
				let belongsToCurrentTab = false;
				// Grupos sempre aparecem APENAS na aba Grupos
				if (data.ticket.isGroup) {
					belongsToCurrentTab = currentTab === 4; // Apenas aba Grupos
				} else {
					if (currentTab === 0) {
						belongsToCurrentTab = ticketStatus === "pending" && !data.ticket.userId && !data.ticket.queueId; // Automação
					} else if (currentTab === 1) {
						belongsToCurrentTab = ticketStatus === "pending" && (data.ticket.userId || data.ticket.queueId); // Aguardando
					} else if (currentTab === 2) {
						belongsToCurrentTab = ticketStatus === "open" && data.ticket.userId; // Atendendo
					} else if (currentTab === 3) {
						belongsToCurrentTab = ticketStatus === "closed"; // Fechados
					}
				}
				
				// Só mostra notificação se pertencer à aba atual
				const shouldNotify = belongsToCurrentTab;
				
				setTickets((prevTickets) => {
					const ticketIndex = prevTickets.findIndex(t => t.id === data.ticket.id);
					
					if (ticketIndex !== -1) {
						// Ticket já existe na lista - apenas atualiza
						const updatedTickets = [...prevTickets];
						const oldTicket = updatedTickets[ticketIndex];
						updatedTickets[ticketIndex] = data.ticket;
						
						// Reordena APENAS se for mensagem nova (lastMessage mudou) OU se status mudou (muda de aba)
						const shouldReorder = oldTicket.lastMessage !== data.ticket.lastMessage ||
							oldTicket.status !== data.ticket.status;
						
						if (shouldReorder) {
							const result = updatedTickets.sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt));
							return [...result];
						}
						
						// Forçar re-renderização mesmo sem mudanças significativas
						return [...updatedTickets];
					} else if (shouldNotify && ticketMatchesCurrentFiltersRef.current?.(data.ticket)) {
						playNotificationSound();
						showDesktopNotification(
							data.ticket?.contact?.name || "Novo Ticket",
							"Você recebeu um novo ticket"
						);
						const result = [data.ticket, ...prevTickets].sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt));
						return result;
					}
					return prevTickets;
				});
				
				const currentTicket = selectedTicketRef.current;
				if (currentTicket && data.ticket.id === currentTicket.id) {
					setSelectedTicket(data.ticket);
				}
			}
			if (data.action === "delete") {
				console.log(`[SOCKET-TICKET] Delete ticket #${data.ticketId}`);
				setTickets((prevTickets) => prevTickets.filter(t => t.id !== data.ticketId));
				if (loadUnreadCountsRef.current) { loadUnreadCountsRef.current(); }
				const currentTicket = selectedTicketRef.current;
				if (currentTicket && data.ticketId === currentTicket.id) {
					setSelectedTicket(null);
					// Limpa o ID do ticket da URL
					history.push("/atendimentos" + window.location.search);
				}
			}
		});

		socket.on(`company-${user.companyId}-appMessage`, (data) => {
			if (data.action === "create") {
				// Usa ref para garantir loadUnreadCounts sempre atualizado
				setTimeout(() => {
					if (loadUnreadCountsRef.current) { loadUnreadCountsRef.current(); }
				}, 200);
				
				// Usa ref sempre atualizada para evitar stale closure
				if (data.ticket && ticketMatchesCurrentFiltersRef.current && !ticketMatchesCurrentFiltersRef.current(data.ticket)) {
					return;
				}

				// **NOVO: Verificar aba atual antes de notificar**
				const currentTab = tabIndexRef.current;
				
				// **CORREÇÃO: Atualização instantânea e sem duplicação**
				setTickets((prevTickets) => {
					const ticketIndex = prevTickets.findIndex(t => t.id === data.message.ticketId);
					
					// Se o ticket já existe, atualiza imediatamente
					if (ticketIndex !== -1) {
						const updatedTickets = [...prevTickets];
						const ticket = { ...updatedTickets[ticketIndex] };
						
						// Atualiza dados da mensagem
						ticket.lastMessage = data.message.body;
						ticket.updatedAt = data.message.createdAt;
						
						// Atualiza unreadMessages baseado em quem enviou
						if (!data.message.fromMe) {
							ticket.unreadMessages = (ticket.unreadMessages || 0) + 1;
							
							// **NOVO: Verificar se pertence à aba atual para notificação**
							let belongsToCurrentTab = false;
					// Grupos sempre aparecem APENAS na aba Grupos
					if (ticket.isGroup) {
						belongsToCurrentTab = currentTab === 4; // Apenas aba Grupos
					} else {
						if (currentTab === 0) {
							belongsToCurrentTab = ticket.status === "pending" && !ticket.userId && !ticket.queueId; // Automação
						} else if (currentTab === 1) {
							belongsToCurrentTab = ticket.status === "pending" && (ticket.userId || ticket.queueId); // Aguardando
						} else if (currentTab === 2) {
							belongsToCurrentTab = ticket.status === "open" && ticket.userId; // Atendendo
						} else if (currentTab === 3) {
							belongsToCurrentTab = ticket.status === "closed"; // Fechados
						}
					}
							
							// Toca som e exibe notificação apenas se pertencer à aba atual
							if (belongsToCurrentTab) {
								const ticketChannel = ticket.channel;
								if (!isAdAutomaticMessage(data.message, ticketChannel)) {
									playNotificationSound();
									showDesktopNotification(
										ticket.contact?.name || "Novo Contato",
										data.message.body
									);
								}
							}
						} else {
							// Se é mensagem enviada por mim, zera o contador
							ticket.unreadMessages = 0;
						}
						
						updatedTickets[ticketIndex] = ticket;
						
						// **NOVO: Reordena imediatamente para mostrar no topo**
						const result = updatedTickets.sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt));
						return [...result]; // Forçar re-renderização
					}
					
					// Se o ticket não existe, verifica se pode adicionar
					else if (data.ticket) {
						if (ticketMatchesCurrentFiltersRef.current?.(data.ticket)) {
							// Verificar se é ticket de Facebook/Instagram e criar lead automaticamente
							if (["facebook", "instagram"].includes(data.ticket.channel)) {
								if (!isAdAutomaticMessage(data.message, data.ticket.channel)) {
									createLeadFromAd(data.ticket);
								}
							}
							
							const result = [data.ticket, ...prevTickets].sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt));
							return result;
						}
					}
					
					return prevTickets;
				});
				
				// **NOVO: Atualizar selectedTicket se a mensagem for do ticket atual**
				const currentTicket = selectedTicketRef.current;
				if (currentTicket && data.message.ticketId === currentTicket.id) {
					// Usa ref sempre atualizada para evitar stale closure
					if (ticketMatchesCurrentFiltersRef.current && !ticketMatchesCurrentFiltersRef.current(data.ticket || currentTicket)) {
						// Usuário não pode ver este ticket, remove da seleção
						setSelectedTicket(null);
						setMessages([]);
						return;
					}
					
					// Atualiza o ticket selecionado com novos dados
					setSelectedTicket(prev => {
						if (!prev || prev.id !== data.message.ticketId) return prev;
						return {
							...prev,
							lastMessage: data.message.body,
							updatedAt: data.message.createdAt,
							unreadMessages: data.message.fromMe ? 0 : (prev.unreadMessages || 0) + 1
						};
					});
					
					// **NOVO: Adicionar mensagem à lista em tempo real**
					setMessages(prevMessages => {
						const messageExists = prevMessages.some(msg => msg.id === data.message.id);
						if (!messageExists) {
							// Remove uma mensagem temporária (fromMe) quando a real chega
							let removedTemp = false;
							const withoutOneTemp = data.message.fromMe
								? prevMessages.filter(msg => {
										if (!removedTemp && msg.id?.toString().startsWith("temp-")) {
											removedTemp = true;
											return false;
										}
										return true;
									})
								: prevMessages;
							return [...withoutOneTemp, data.message];
						}
						return prevMessages;
					});
					
					// Força scroll para o final se a mensagem for de outra pessoa
					if (!data.message.fromMe) {
						setTimeout(() => {
							if (messagesEndRef.current) {
								messagesEndRef.current.scrollIntoView({ behavior: "smooth" });
							}
						}, 100);
					}
				}
			}
			
			if (data.action === "update") {
				// Atualizar mensagem existente (ack, isEdited, isDeleted, etc)
				const currentTicket = selectedTicketRef.current;
				if (currentTicket && data.message.ticketId === currentTicket.id) {
					setMessages((prev) => 
						prev.map((msg) => 
							msg.id === data.message.id 
								? { ...msg, ...data.message }
								: msg
						)
					);
				}
			}
		});

		// Evento para status de digitação
		socket.on(`company-${user.companyId}-typing`, (data) => {
			
			const currentTicket = selectedTicketRef.current;
			if (currentTicket && data.ticketId === currentTicket.id) {
				setIsTyping(data.isTyping);
				setTypingUser(data.user);
				
				// Auto-remove após 3 segundos
				if (data.isTyping) {
					setTimeout(() => {
						setIsTyping(false);
						setTypingUser(null);
					}, 3000);
				}
			}
		});

		// Listener para atualização de contact
		socket.on(`company-${user.companyId}-contact`, (data) => {
			
			if (data.action === "update") {
				const currentTicket = selectedTicketRef.current;
				
				// Atualiza o ticket selecionado se o contato for o mesmo
				if (currentTicket && currentTicket.contact?.id === data.contact.id) {
					// Se o contato foi vinculado a um cliente, atualizar também crmClient
					const updatedClient = data.contact.crmClients?.[0] || null;
					
					setSelectedTicket(prev => ({
						...prev,
						contact: data.contact,
						crmClient: updatedClient || prev.crmClient
					}));
				}
				
				// Atualiza na lista de tickets
				setTickets(prevTickets => 
					prevTickets.map(ticket => {
						if (ticket.contact?.id === data.contact.id) {
							const updatedClient = data.contact.crmClients?.[0] || null;
							return {
								...ticket,
								contact: data.contact,
								crmClient: updatedClient || ticket.crmClient
							};
						}
						return ticket;
					})
				);
			}
		});

		socket.on(`company-${user.companyId}-groupParticipants`, (data) => {
			if (!data?.groupJid) return;
			if (data.action === "promote" || data.action === "demote") {
				if (data.amIAdmin !== null && data.amIAdmin !== undefined) {
					setGroupAdminMap(prev => ({ ...prev, [data.groupJid]: data.amIAdmin }));
				} else {
					// Remove do cache para forçar re-fetch na próxima abertura
					setGroupAdminMap(prev => {
						const next = { ...prev };
						delete next[data.groupJid];
						return next;
					});
				}
			}
		});

		return () => {
			socket.disconnect();
		};
	}, [user.companyId, permissionFlags, userQueueIds, tabIndex]);

	const hasAssignedUser = useCallback((ticket) =>
		Boolean(ticket?.userId || ticket?.user?.id), []);
	const hasQueue = useCallback((ticket) =>
		Boolean(ticket?.queueId || ticket?.queue?.id), []);
	const isAutomationTicket = useCallback((ticket) => {
		if (!ticket) return false;
		return ticket.status === "pending" && !Boolean(ticket?.userId || ticket?.user?.id) && !Boolean(ticket?.queueId || ticket?.queue?.id) && !ticket.isGroup;
	}, []);

	// TAB_CONFIG dinâmico baseado no perfil do usuário
	const TAB_CONFIG = useMemo(() => [
		{ key: "automation", name: "Automação", status: "pending", filter: isAutomationTicket },
		{ key: "pending", name: "Aguardando", status: "pending", filter: (ticket) => (
			ticket?.status === "pending" && (hasAssignedUser(ticket) || hasQueue(ticket)) && !ticket.isGroup
		) },
		{ key: "open", name: "Atendendo", status: "open", filter: (ticket) => (
			ticket?.status === "open" && hasAssignedUser(ticket) && !ticket.isGroup
		) },
		{ key: "closed", name: "Fechados", status: "closed", filter: (ticket) => (
			ticket?.status === "closed" && !ticket.isGroup
		) },
		{ key: "groups", name: "Grupos", status: "group", filter: (ticket) => ticket.isGroup === true }
	], [isAutomationTicket, hasAssignedUser, hasQueue]);

	// Função para verificar se ticket corresponde aos filtros atuais
	const ticketMatchesCurrentFilters = useCallback((ticket) => {
		if (!ticket) return false;

		const _debug = (reason) => {
			console.log(`[FILTER] Ticket #${ticket.id} DESCARTADO — ${reason} | status=${ticket.status} userId=${ticket.userId} queueId=${ticket.queueId} isGroup=${ticket.isGroup} channel=${ticket.channel} whatsappId=${ticket.whatsappId}`);
			return false;
		};

		const canSeeOtherUsersTickets = permissionFlags.hasAllUserChat || permissionFlags.hasAllTicket;
		const canSeeTicketsWithoutQueue = permissionFlags.hasAllTicket;

		const inferredQueueId = ticket.queueId || ticket.queue?.id;

		if (!showAllTickets) {
			const queueFilter = selectedQueues.length > 0 ? selectedQueues : userQueueIds;
			// Normaliza para número para evitar mismatch string vs number
			const queueFilterNorm = queueFilter.map(Number);
			if (queueFilterNorm.length > 0) {
				if (!inferredQueueId) {
					// Ticket sem fila: passa somente se usuário tem permissão allTicket
					if (!canSeeTicketsWithoutQueue) {
						return _debug(`fila null e sem permissão allTicket`);
					}
					// Tem allTicket → deixa passar (automation ticket)
				} else if (!queueFilterNorm.includes(Number(inferredQueueId))) {
					return _debug(`fila ${inferredQueueId} não está em queueFilter=[${queueFilterNorm}]`);
				}
			}

			if (ticket.userId && Number(ticket.userId) !== Number(user?.id) && !canSeeOtherUsersTickets) {
				return _debug(`userId=${ticket.userId} != myId=${user?.id} e sem permissão allUserChat`);
			}

			if (!inferredQueueId && Number(ticket.userId) !== Number(user?.id) && !canSeeTicketsWithoutQueue) {
				return _debug(`sem fila e userId=${ticket.userId} != myId e sem allTicket`);
			}

			if (selectedUsers.length > 0) {
				const selectedUsersNorm = selectedUsers.map(Number);
				if (!ticket.userId || !selectedUsersNorm.includes(Number(ticket.userId))) {
					return _debug(`userId=${ticket.userId} não está em selectedUsers=[${selectedUsersNorm}]`);
				}
			}

			if (selectedTags.length > 0) {
				const ticketTagIds = Array.isArray(ticket.tags)
					? ticket.tags.map(tag => Number(tag.id || tag))
					: [];
				const selectedTagsNorm = selectedTags.map(Number);
				const hasTag = ticketTagIds.some(tagId => selectedTagsNorm.includes(tagId));
				if (!hasTag) {
					return _debug(`tags do ticket [${ticketTagIds}] não batem com selectedTags=[${selectedTagsNorm}]`);
				}
			}

			if (selectedKanbanTags.length > 0) {
				const ticketTagIds = Array.isArray(ticket.tags)
					? ticket.tags.map(tag => Number(tag.id || tag))
					: [];
				const selectedKanbanNorm = selectedKanbanTags.map(Number);
				const hasKanban = ticketTagIds.some(tagId => selectedKanbanNorm.includes(tagId));
				if (!hasKanban) {
					return _debug(`kanban tags do ticket [${ticketTagIds}] não batem com selectedKanbanTags=[${selectedKanbanNorm}]`);
				}
			}

			if (selectedWhatsapps.length > 0) {
				const selectedWhatsappsNorm = selectedWhatsapps.map(Number);
				if (!ticket.whatsappId || !selectedWhatsappsNorm.includes(Number(ticket.whatsappId))) {
					return _debug(`whatsappId=${ticket.whatsappId} não está em selectedWhatsapps=[${selectedWhatsappsNorm}]`);
				}
			}

			if (selectedChannelsQuickFilter.length > 0) {
				if (!ticket.channel || !selectedChannelsQuickFilter.includes(ticket.channel)) {
					return _debug(`channel=${ticket.channel} não está em selectedChannels=[${selectedChannelsQuickFilter}]`);
				}
			}
		} else {
			if (ticket.userId && Number(ticket.userId) !== Number(user?.id) && !canSeeOtherUsersTickets) {
				return _debug(`[showAll] userId=${ticket.userId} != myId=${user?.id} sem allUserChat`);
			}

			if (!inferredQueueId && !canSeeTicketsWithoutQueue) {
				return _debug(`[showAll] sem fila e sem permissão allTicket`);
			}
		}

		// lastMessageFromMe vem de ListTicketsService (transform). No socket (ShowTicketService) não existe.
		// Fallback: ticket.messages[0].fromMe (socket). Se nenhum existe, não filtra.
		if (messageDirectionFilter === "waiting_customer" || messageDirectionFilter === "waiting_agent") {
			let lastFromMe = ticket.lastMessageFromMe;
			if (lastFromMe === undefined || lastFromMe === null) {
				lastFromMe = Array.isArray(ticket.messages) && ticket.messages.length > 0
					? ticket.messages[0].fromMe
					: null;
			}
			if (lastFromMe !== null) {
				// waiting_customer = última msg foi MInha (espera cliente responder): lastFromMe=true
				if (messageDirectionFilter === "waiting_customer" && lastFromMe !== true) {
					return _debug(`messageDirectionFilter=waiting_customer mas lastFromMe=${lastFromMe}`);
				}
				// waiting_agent = última msg foi do cliente (espera agente responder): lastFromMe=false
				if (messageDirectionFilter === "waiting_agent" && lastFromMe !== false) {
					return _debug(`messageDirectionFilter=waiting_agent mas lastFromMe=${lastFromMe}`);
				}
			}
		}

		const currentTabIndex = tabIndexRef.current;
		const currentTab = TAB_CONFIG[currentTabIndex];
		if (currentTab?.key === "groups") {
			return ticket.isGroup === true;
		}
		if (currentTab?.filter && !currentTab.filter(ticket)) {
			return _debug(`currentTab.filter(${currentTab.key}) falhou`);
		}

		return true;
	}, [selectedQueues, showAllTickets, userQueueIds, selectedUsers, selectedTags, selectedKanbanTags, selectedWhatsapps, selectedChannelsQuickFilter, messageDirectionFilter, TAB_CONFIG, permissionFlags.hasAllTicket, permissionFlags.hasAllUserChat, user?.id]);

	// Sincroniza a ref com a versão mais recente de ticketMatchesCurrentFilters
	useEffect(() => {
		ticketMatchesCurrentFiltersRef.current = ticketMatchesCurrentFilters;
	}, [ticketMatchesCurrentFilters]);

	const buildFilterParams = useCallback(() => {
		const canViewAllTickets = permissionFlags.hasAllUserChat || permissionFlags.hasAllTicket;
		const params = {
			searchParam: debouncedSearchTerm
		};

		// **CORREÇÃO: Quando showAllTickets está ativo, não envia nenhum filtro específico**
		if (canViewAllTickets && showAllTickets) {
			params.showAll = "true";
			// Não envia filtros de fila, usuário, tags, WhatsApp quando "ver todos" está ativo
			// Isso permite ver tickets de todas as filas, usuários e conexões
		} else {
			// Só aplica filtros quando "ver todos" NÃO está ativo
			const queueFilter = selectedQueues.length > 0 ? selectedQueues : userQueueIds;
			
			// Filtro de filas
			if (queueFilter.length > 0) {
				params.queueIds = JSON.stringify(queueFilter);
			}

			// Filtros de usuários, tags, WhatsApp apenas quando não está "ver todos"
			if (selectedUsers.length > 0) {
				params.users = JSON.stringify(selectedUsers);
			}
			const allSelectedTags = [...selectedTags, ...selectedKanbanTags];
			if (allSelectedTags.length > 0) {
				params.tags = JSON.stringify(allSelectedTags);
			}
			if (selectedWhatsapps.length > 0) {
				params.whatsappIds = JSON.stringify(selectedWhatsapps);
			} else {
				// Não-admin/gerente só vê tickets da própria conexão WhatsApp
				// Mesmo critério que applyLocalFilters aplica no frontend — sincroniza o count do backend
				const currentUserType = (user?.userType || "").toLowerCase();
				const isAdminOrManager = currentUserType === "administrador" || currentUserType === "gerente";
				if (!isAdminOrManager && user?.whatsappId) {
					params.whatsappIds = JSON.stringify([user.whatsappId]);
				}
			}
		}

		return params;
	}, [user, debouncedSearchTerm, selectedQueues, selectedUsers, selectedTags, selectedKanbanTags, selectedWhatsapps, showAllTickets, permissionFlags, userQueueIds]);

	const applyClientFilters = useCallback(
		(tickets = []) => tickets.filter(ticketMatchesCurrentFilters),
		[ticketMatchesCurrentFilters]
	);

	const applyLocalFilters = useCallback((ticketList) => {
		const userType = (user?.userType || "").toLowerCase();
		const isAdminOrManager = userType === "administrador" || userType === "gerente";
		const userWhatsappId = user?.whatsappId ? Number(user.whatsappId) : null;
		let filtered = applyClientFilters(ticketList);
		if (!isAdminOrManager && userWhatsappId) {
			filtered = filtered.filter(t => {
				const ticketWaId = Number(t.whatsappId || t.whatsapp?.id);
				const passes = ticketWaId === userWhatsappId;
				if (!passes) console.log(`[LOCAL-FILTER] Ticket #${t.id} removido por whatsapp: ticketWaId=${ticketWaId} != userWaId=${userWhatsappId}`);
				return passes;
			});
		}
		return filtered;
	}, [applyClientFilters, user?.userType, user?.whatsappId]);

	const loadTickets = useCallback(async (page = 1, append = false) => {
		try {
			if (page === 1) setLoading(true);
			const currentTab = TAB_CONFIG[tabIndex] || TAB_CONFIG[1];
			const status = currentTab.key === "groups" ? "group" : (currentTab.status || "pending");
			const pendingType = currentTab.key === "automation" ? "automation"
				: currentTab.key === "pending" ? "assigned"
				: undefined;
			const filterParams = buildFilterParams();
			const params = {
				...filterParams,
				status,
				pageNumber: page,
				pageSize: page === 1 ? TICKETS_PAGE_SIZE : TICKETS_MORE_SIZE,
				...(pendingType ? { pendingType } : {}),
			};

			console.log(`[LOAD-TICKETS] Tab="${currentTab.key}" page=${page} params=`, JSON.stringify(filterParams));

			const { data } = await api.get("/tickets", { params });
			const backendCount = data.count;
			const beforeFilter = data.tickets?.length || 0;

			let filtered = applyLocalFilters(data.tickets || []);
			const afterLocalFilter = filtered.length;

			if (currentTab?.filter && currentTab.key !== "groups") {
				filtered = filtered.filter(currentTab.filter);
			}
			const afterTabFilter = filtered.length;

			console.log(`[LOAD-TICKETS] Resultado: backendCount=${backendCount} recebidos=${beforeFilter} apósLocalFilter=${afterLocalFilter} apósTabFilter=${afterTabFilter}`);
			if (afterLocalFilter < beforeFilter) {
				console.warn(`[LOAD-TICKETS] ⚠️ applyLocalFilters removeu ${beforeFilter - afterLocalFilter} tickets!`);
			}
			if (afterTabFilter < afterLocalFilter) {
				console.warn(`[LOAD-TICKETS] ⚠️ tabFilter removeu mais ${afterLocalFilter - afterTabFilter} tickets!`);
			}

			if (append) {
				setTickets(prev => {
					const existingIds = new Set(prev.map(t => t.id));
					const newOnes = filtered.filter(t => !existingIds.has(t.id));
					return [...prev, ...newOnes];
				});
			} else {
				setTickets(filtered);
				setTicketsPage(1);
			}
			setTicketsHasMore(data.hasMore ?? filtered.length >= (page === 1 ? TICKETS_PAGE_SIZE : TICKETS_MORE_SIZE));
		} catch (err) {
			console.error("[LOAD-TICKETS] Erro:", err);
		} finally {
			setLoading(false);
		}
	}, [tabIndex, buildFilterParams, applyLocalFilters, TAB_CONFIG]);

	const loadMoreTickets = useCallback(async () => {
		if (loadingMoreTickets || !ticketsHasMore) return;
		setLoadingMoreTickets(true);
		const nextPage = ticketsPage + 1;
		await loadTickets(nextPage, true);
		setTicketsPage(nextPage);
		setLoadingMoreTickets(false);
	}, [loadingMoreTickets, ticketsHasMore, ticketsPage, loadTickets]);

	// Auto-carrega mais tickets quando a lista não preenche o container (sem scroll disponível)
	// eslint-disable-next-line react-hooks/rules-of-hooks
	useEffect(() => {
		if (loading || loadingMoreTickets || !ticketsHasMore) return;
		const el = ticketsListRef.current;
		if (!el) return;
		// Se o conteúdo cabe sem scroll, carrega mais
		if (el.scrollHeight <= el.clientHeight + 10) {
			loadMoreTickets();
		}
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [tickets.length, loading, ticketsHasMore, loadingMoreTickets]);

	const handlePermissionDenied = useCallback(() => {
		// showAlert({
		// 	type: "warning",
		// 	title: "Acesso negado",
		// 	message: "Este atendimento pertence a outro usuário ou não está mais disponível para você.",
		// 	confirmText: "Entendi"
		// });
		setSelectedTicket(null);
		setMessages([]);
		history.push("/atendimentos");
	}, [history]);

	// Abre ticket diretamente pelo ID sem verificar filtro — usado em navegações externas (relatórios, calendário)
	const forceOpenTicket = async (id) => {
		try {
			const { data } = await api.get(`/tickets/${id}`);
			setSelectedTicket(data);
			loadMessages(id);
			if (isMobile) setMobileView("chat");
		} catch (err) {
			if (err?.response?.status === 403) {
				handlePermissionDenied();
			} else {
				setSelectedTicket(null);
				setMessages([]);
			}
		}
	};

	const loadTicket = async (id) => {
		try {
			const { data } = await api.get(`/tickets/${id}`);

			// **CRÍTICO: Verificar se usuário pode ver este ticket antes de selecionar**
			if (!ticketMatchesCurrentFilters(data)) {
				handlePermissionDenied();
				return;
			}

			setSelectedTicket(data);
			loadMessages(id);
		} catch (err) {
			if (err?.response?.status === 403) {
				handlePermissionDenied();
			} else {
				setSelectedTicket(null);
				setMessages([]);
			}
		}
	};

	const loadMessages = useCallback(async (ticketId) => {
		try {
			const { data } = await api.get(`/messages/${ticketId}`, {
				params: { pageNumber: 1 }
			});
			
			lastScrolledMessageIdRef.current = null; // reset ao trocar de ticket
			setMessages(data.messages);
			setHasMore(data.hasMore);
			setPageNumber(1);

			// Forçar scroll para o final no carregamento
			setTimeout(() => {
				scrollToBottom(true);
			}, 100);
			
			setTimeout(() => {
				scrollToBottom(true);
			}, 300);
			
			setTimeout(() => {
				scrollToBottom(true);
			}, 500);
		} catch (err) {
		}
	}, [scrollToBottom]);

	const loadMoreMessages = useCallback(async () => {
		if (!selectedTicket || loadingMore || !hasMore) return;
		
		setLoadingMore(true);
		const nextPage = pageNumber + 1;
		
		try {
			const { data } = await api.get(`/messages/${selectedTicket.id}`, {
				params: { pageNumber: nextPage }
			});
			
			const container = messagesContainerRef.current;
			const scrollHeightBefore = container.scrollHeight;
			const scrollTopBefore = container.scrollTop;
			
			isPaginatingRef.current = true;
			setMessages(prev => [...data.messages, ...prev]);
			setPageNumber(nextPage);
			setHasMore(data.hasMore);

			// Mantém a posição exata do usuário e libera o flag de paginação depois
			setTimeout(() => {
				if (container) {
					const scrollHeightAfter = container.scrollHeight;
					const heightDifference = scrollHeightAfter - scrollHeightBefore;
					container.scrollTop = scrollTopBefore + heightDifference;
				}
				isPaginatingRef.current = false;
			}, 100);
		} catch (err) {
		} finally {
			setLoadingMore(false);
		}
	}, [selectedTicket, loadingMore, hasMore, pageNumber]);

	const handleTicketClick = async (ticket) => {
		// **CRÍTICO: Verificar se usuário pode ver este ticket antes de navegar**
		if (!ticketMatchesCurrentFilters(ticket)) {
			return; // Não faz nada se não pode ver o ticket
		}
		
		history.push(`/atendimentos/${ticket.id}`);
		if (isMobile) {
			setMobileView("chat");
		}
		
		if (ticket.unreadMessages > 0) {
			try {
				await api.put(`/tickets/${ticket.id}`, {
					unreadMessages: 0,
				});
				
				setTickets((prevTickets) => {
					const updatedTickets = prevTickets.map(t => 
						t.id === ticket.id ? { ...t, unreadMessages: 0 } : t
					);
					return updatedTickets;
				});
				
				loadUnreadCounts();
			} catch (err) {
			}
		}
	};

	const handleSendMessage = useCallback(async () => {
		if (!inputMessage.trim() || !selectedTicket || isSendingMessageRef.current) return;

		console.log("Enviando mensagem:", inputMessage);
		console.log("Ticket selecionado:", selectedTicket.id);

		const now = Date.now();
		if (now - lastSendTimeRef.current < 400) {
			return;
		}
		isSendingMessageRef.current = true;
		setIsSendingMessage(true);
		lastSendTimeRef.current = now;

		try {
			const messageBody = signMessage
				? `*${user?.name || user?.username || "Atendente"}:*\n${inputMessage}`
				: inputMessage;

			const payload = {
				body: messageBody
			};

			// Envia apenas o ID da mensagem citada se existir
			if (replyingTo) {
				payload.quotedMsg = { id: replyingTo.id };
			}

			console.log("Payload enviado:", payload);
			await api.post(`/messages/${selectedTicket.id}`, payload);
			console.log("Mensagem enviada com sucesso");
			
			setInputMessage("");
			setReplyingTo(null);
		} catch (err) {
			console.error("Erro ao enviar mensagem:", err);
			if (err?.response?.status === 403) {
				handlePermissionDenied();
			}
			lastSendTimeRef.current = 0;
		} finally {
			isSendingMessageRef.current = false;
			setIsSendingMessage(false);
		}
	}, [inputMessage, selectedTicket, signMessage, user.name, replyingTo, handlePermissionDenied]);

	const handleInputKeyDown = useCallback((e) => {
		const handledQuickReply = handleQuickReplyKeyDown(e);
		if (handledQuickReply) return;

		if (e.key === "Enter" && !e.shiftKey && !e.isComposing && !e.repeat) {
			e.preventDefault();
			handleSendMessage();
		}
	}, [handleQuickReplyKeyDown, handleSendMessage]);

	const openMediaPreview = useCallback((files) => {
		if (!files || files.length === 0 || !selectedTicket) return false;

		if (files.length === 1) {
			setSelectedFile(files[0]);
			setSelectedFiles([]);
		} else {
			setSelectedFiles(files);
			setSelectedFile(null);
		}
		setMediaPreviewOpen(true);
		return true;
	}, [selectedTicket]);

	const handleFileUpload = (e) => {
		const files = Array.from(e.target.files);
		const opened = openMediaPreview(files);
		if (opened) {
			e.target.value = "";
		}
	};

	const handleSendMedia = async (payload) => {
		if (!payload || !selectedTicket || isSendingMessageRef.current) return;
		isSendingMessageRef.current = true;
		setIsSendingMessage(true);
		lastSendTimeRef.current = Date.now();

		try {

			// Extrai arquivos e legenda do payload
			const filesToSend = Array.isArray(payload.files) ? payload.files : [payload.files];
			const caption = payload.caption || "";

			// **SOLUÇÃO: Não criar mensagem de legenda separada**
			// Deixa o backend salvar a legenda no body da mensagem de mídia
			const tempMediaMessages = filesToSend.map((file, index) => ({
				id: `temp-media-${Date.now()}-${index}`,
				mediaUrl: URL.createObjectURL(file),
				mediaType: file.type.startsWith("image")
					? "image"
					: file.type.startsWith("video")
					? "video"
					: file.type.startsWith("audio")
					? "audio"
					: "file",
				body: caption, // **IMPORTANTE: Coloca a legenda no body da mensagem de mídia**
				fromMe: true,
				createdAt: new Date().toISOString(),
				loading: true
			}));

			// Optimistic UI update - adiciona apenas a mensagem de mídia (com legenda no body)
			setMessages(prev => [...prev, ...tempMediaMessages]);

			// **VERDADE: Backend espera formData simples**
			const formData = new FormData();
			formData.append("fromMe", true);
			formData.append("isPrivate", "false");
			
			// Para cada arquivo, adiciona mídia e legenda
			filesToSend.forEach(file => {
				formData.append("medias", file);
				formData.append("body", caption); // Backend usa 'body' para legenda
			});

			if (replyingTo) {
				formData.append("quotedMsg", JSON.stringify({ id: replyingTo.id }));
			}

			await api.post(`/messages/${selectedTicket.id}`, formData, {
				headers: {
					"Content-Type": "multipart/form-data",
				},
			});
			// Temp messages são removidas pelo socket handler quando a mensagem real chega
		} catch (err) {
			console.error("Erro ao enviar mídia:", err);
			setMessages(prev => prev.filter(msg => !msg.id?.toString().startsWith("temp-")));
			const errMsg = err?.response?.data?.error || err?.message || "";
			if (errMsg.includes("INVALID_FILE") || errMsg.includes("corrompido")) {
				toast.error("Arquivo inválido ou tipo não suportado para envio.");
			} else if (errMsg.includes("MEDIA_UPLOAD") || errMsg.includes("#100")) {
				toast.error("Falha no envio do vídeo. Tente converter para MP4 (H.264) antes de enviar.", { autoClose: 6000 });
			} else if (errMsg.includes("MISSING_CREDENTIALS")) {
				toast.error("Credenciais da conexão oficial não configuradas.");
			} else if (errMsg && !errMsg.startsWith("ERR_")) {
				toast.error(errMsg, { autoClose: 8000 });
			} else {
				toast.error("Erro ao enviar arquivo. Tente novamente.");
			}
		} finally {
			isSendingMessageRef.current = false;
			setIsSendingMessage(false);
			setMediaPreviewOpen(false);
			setSelectedFile(null);
			setSelectedFiles([]);
			setReplyingTo(null);
		}
	};

	// Carrega IAs disponíveis (próprias + sistema)
	useEffect(() => {
		const loadAi = async () => {
			try {
				const [ownRes, sysRes] = await Promise.allSettled([
					api.get("/ai-settings"),
					api.get("/ai-credits/system-providers"),
				]);
				const own = ownRes.status === "fulfilled"
					? (Array.isArray(ownRes.value.data) ? ownRes.value.data : []).filter(s => s.active)
					: [];
				const sys = sysRes.status === "fulfilled" ? sysRes.value.data : {};
				const hasSystem = !!(sys?.openai || sys?.gemini || sys?.openrouter);
				// Mostra botão se empresa tem chave própria OU sistema tem chave configurada
				setAiProviders(own.length > 0 ? own : (hasSystem ? [{ provider: "system", active: true }] : []));
			} catch (e) {
				setAiProviders([]);
			}
		};
		loadAi();
	}, [selectedTicket?.companyId]);

	const handleStartRecording = async () => {
		setLoading(true);
		try {
			await navigator.mediaDevices.getUserMedia({ audio: true });
			await Mp3Recorder.start();
			setRecording(true);
			setRecordingTime(0);

			const interval = setInterval(() => {
				setRecordingTime(prev => prev + 1);
			}, 1000);
			setRecordingInterval(interval);

			setLoading(false);
		} catch (err) {
			if (err?.name === "NotAllowedError" || /Permission denied/i.test(err?.message || "")) {
				toast.error("Microfone bloqueado no navegador. Clique no cadeado ao lado da URL e permita o uso do microfone.");
			} else {
				toast.error("Erro ao acessar o microfone. Verifique as permissões.");
			}

			setRecording(false);
			setLoading(false);
		}
	};

	const handleStopRecording = async () => {
		if (!selectedTicket || isSendingMessageRef.current) return;
		setLoading(true);
		isSendingMessageRef.current = true;
		setIsSendingMessage(true);
		lastSendTimeRef.current = Date.now();
		try {
			const [, blob] = await Mp3Recorder.stop().getMp3();
			if (blob.size < 10000) {
				setLoading(false);
				setRecording(false);
				toast.error("Gravação muito curta. Grave por mais tempo.");
				isSendingMessageRef.current = false;
				setIsSendingMessage(false);
				return;
			}

			const formData = new FormData();
			const filename = `${new Date().getTime()}.mp3`;
			formData.append("medias", blob, filename);
			formData.append("body", filename);
			formData.append("fromMe", true);

			const tempMessage = {
				id: `temp-audio-${Date.now()}`,
				mediaUrl: URL.createObjectURL(blob),
				mediaType: "audio",
				fromMe: true,
				body: "",
				createdAt: new Date().toISOString(),
				loading: true
			};

			setMessages(prev => [...prev, tempMessage]);

			try {
				await api.post(`/messages/${selectedTicket.id}`, formData, {
					headers: {
						"Content-Type": "multipart/form-data",
					},
				});
				setMessages(prev => prev.filter(msg => !msg.id?.toString().startsWith("temp-")));
			} catch (err) {
				toast.error("Erro ao enviar áudio. Tente novamente.");
				setMessages(prev => prev.filter(msg => msg.id !== tempMessage.id));
			}
		} catch (err) {
			toast.error("Erro ao processar áudio.");
		} finally {
			setLoading(false);
			setRecording(false);
			if (recordingInterval) {
				clearInterval(recordingInterval);
				setRecordingInterval(null);
			}
			setRecordingTime(0);
			isSendingMessageRef.current = false;
			setIsSendingMessage(false);
		}
	};

	const handleCancelRecording = async () => {
		try {
			await Mp3Recorder.stop().getMp3();
			setRecording(false);
		} catch (err) {
			toast.error("Erro ao cancelar gravação.");
		} finally {
			if (recordingInterval) {
				clearInterval(recordingInterval);
				setRecordingInterval(null);
			}
			setRecordingTime(0);
			setLoading(false);
		}
	};

	const handleEmojiSelect = (emoji) => {
		setInputMessage((prev) => prev + emoji);
		setShowEmojiPicker(false);
	};

	const handleSendContact = async (contact) => {
		if (!selectedTicket || !contact) return;
		
		setLoading(true);
		try {
			// Enviar vCard como objeto com name e number
			await api.post(`/messages/${selectedTicket.id}`, {
				vCard: {
					name: contact.name,
					number: contact.number
				},
				fromMe: true,
			});
			
			toast.success("Contato enviado com sucesso!");
			setContactSendModalOpen(false);
		} catch (err) {
			console.error("Erro ao enviar contato:", err);
			toast.error("Erro ao enviar contato");
		} finally {
			setLoading(false);
		}
	};

	const handleSendLocation = async (locationData) => {
		if (!selectedTicket) return;
		
		setLoading(true);
		try {
			await api.post(`/messages/${selectedTicket.id}`, {
				body: locationData.address || `${locationData.latitude}, ${locationData.longitude}`,
				location: {
					latitude: locationData.latitude,
					longitude: locationData.longitude,
					address: locationData.address,
				},
				fromMe: true,
			});
			
			toast.success("Localização enviada com sucesso!");
			setLocationModalOpen(false);
		} catch (err) {
			console.error("Erro ao enviar localização:", err);
			toast.error("Erro ao enviar localização");
		} finally {
			setLoading(false);
		}
	};

	const handleCameraCapture = async (blob) => {
		if (!selectedTicket) return;
		
		setLoading(true);
		try {
			const fileName = `camera-${Date.now()}.jpg`;
			const file = new File([blob], fileName, { type: "image/jpeg" });
			
			const formData = new FormData();
			formData.append("medias", file);
			formData.append("body", "");
			formData.append("fromMe", true);
			
			await api.post(`/messages/${selectedTicket.id}`, formData, {
				headers: {
					"Content-Type": "multipart/form-data",
				},
			});
			
			toast.success("Foto enviada com sucesso!");
			setCameraModalOpen(false);
		} catch (err) {
			console.error("Erro ao enviar foto:", err);
			toast.error("Erro ao enviar foto");
		} finally {
			setLoading(false);
		}
	};

	const handleAttachmentOption = (option) => {
		switch (option.id) {
			case "document":
				if (fileInputRef.current) {
					fileInputRef.current.accept = "*/*";
					fileInputRef.current.click();
				}
				break;
			case "photos-videos":
				if (fileInputRef.current) {
					fileInputRef.current.accept = "image/*,video/*";
					fileInputRef.current.click();
				}
				break;
			case "camera":
				setCameraModalOpen(true);
				break;
			case "audio":
				if (fileInputRef.current) {
					fileInputRef.current.accept = "audio/*";
					fileInputRef.current.click();
				}
				break;
			case "contact":
				setContactSendModalOpen(true);
				break;
			case "location":
				setLocationModalOpen(true);
				break;
			case "schedule":
				setScheduleModalOpen(true);
				break;
			case "email": {
				const contactEmail = selectedTicket?.contact?.email;
				if (!contactEmail) {
					toast.warn("Este contato não possui e-mail cadastrado. Adicione um e-mail ao contato antes de enviar.");
					break;
				}
				setEmailComposeTo(contactEmail);
				setEmailComposeOpen(true);
				break;
			}
			case "quiz":
				setQuizSelectOpen(true);
				break;
			default:
				break;
		}
	};

	const handleQuizSend = async (quiz) => {
		try {
			const quizUrl = `${window.location.origin}/q/${quiz.slug}`;
			await api.post(`/messages/quiz/${selectedTicket.id}`, {
				quizName: quiz.name,
				quizUrl,
			});
			toast.success("Formulário enviado!");
		} catch (err) {
			toast.error("Erro ao enviar formulário.");
		}
	};

	const handlePaste = useCallback(async (event) => {
		if (!event.clipboardData || !selectedTicket) return;

		const items = event.clipboardData.items;
		const imageItems = [];

		for (let i = 0; i < items.length; i += 1) {
			const item = items[i];
			if (item.kind === "file") {
				const file = item.getAsFile();
				if (file && file.type.startsWith("image/")) {
					imageItems.push(file);
				}
			}
		}

		if (imageItems.length > 0) {
			event.preventDefault();
			const files = imageItems;
			const opened = openMediaPreview(files);
			if (!opened) {
				await handleSendMedia(files);
			}
		}
	}, [selectedTicket, handleSendMedia, openMediaPreview]);

	const handleBackToList = () => {
		if (isMobile) {
			setMobileView("list");
			history.push("/atendimentos");
			return;
		}
		
		history.push("/atendimentos");
	};

	// **NOVO: Componente para texto de anúncios com "ler mais"**
	const AdMessageText = ({ text, isBase64, hasMedia }) => {
		const [expanded, setExpanded] = useState(false);
		
		const LIMIT = 600;
		const shouldTruncate = text.length > LIMIT;
		const displayText = shouldTruncate && !expanded
			? text.substring(0, LIMIT)
			: text;
		
		return (
			<>
				<Typography 
					className={classes.messageText}
					style={{ 
						marginTop: hasMedia ? "8px" : "0",
						userSelect: 'text',
						WebkitUserSelect: 'text',
						MozUserSelect: 'text',
						msUserSelect: 'text'
					}}
					dangerouslySetInnerHTML={{ __html: formatWhatsAppText(displayText) }}
				/>
				{shouldTruncate && (
					<Typography 
						style={{ 
							color: "#00a884", 
							cursor: "pointer", 
							fontSize: "0.875em",
							marginTop: "4px",
							fontWeight: 500
						}}
						onClick={() => setExpanded(!expanded)}
					>
						{expanded ? "Ler menos" : "... Ler mais"}
					</Typography>
				)}
			</>
		);
	};

	const buildReactionDescription = (message) => {
		if (!message) return "Reação registrada";

		const actorName = message.fromMe
			? (message.fromAgent ? "Automação" : user?.name || "Você")
			: message.contact?.name || selectedTicket?.contact?.name || "Contato";

		const reactionEmoji = (message.body || "").trim();
		const emojiPart = reactionEmoji ? ` com ${reactionEmoji}` : "";

		let reactedTarget = " a uma mensagem";
		if (message.quotedMsg) {
			if (message.quotedMsg.fromMe) {
				reactedTarget = " na sua mensagem";
			} else if (message.quotedMsg.contact?.name) {
				reactedTarget = ` na mensagem de ${message.quotedMsg.contact.name}`;
			} else {
				reactedTarget = " na mensagem do contato";
			}
		}

		return `${actorName} reagiu${emojiPart}${reactedTarget}`;
	};

	// FUNÇÃO NOVA - Renderiza o conteúdo completo da mensagem (mídia ou texto)
	// Backend salva legenda no campo 'body' junto com a mídia
	const renderMessageContent = (message) => {
		// viewOnceMessage com botões CTA ([BOTOES])
		if (message?.mediaType === "viewOnceMessage" && message.body?.startsWith('[BOTOES]')) {
			try {
				const parsedData = JSON.parse(message.dataJson);
				const interactive = parsedData.message.viewOnceMessage.message.interactiveMessage;
				if (interactive) {
					const titulo = interactive.body?.text || "";
					const rodape = interactive.footer?.text || "";
					const botoes = interactive.nativeFlowMessage?.buttons?.map(btn => {
						const params = JSON.parse(btn.buttonParamsJson);
						return { tipo: btn.name, texto: params.display_text, conteudo: params.phoneNumber || params.url || params.copy_code };
					}) || [];
					const imagem = interactive.header?.imageMessage?.jpegThumbnail || null;
					return <ButtonPreview titulo={titulo} rodape={rodape} secoes={[{ titulo: "Botões", linhas: botoes }]} imagem={imagem} ticketId={message?.ticket?.id} />;
				}
			} catch (_) {}
		}

		// interactiveMessage com botões (nativeFlow / buttonsData)
		if (message?.mediaType === "interactiveMessage" && !message.body?.startsWith('[PIX]')) {
			try {
				if (message.dataJson) {
					const parsed = JSON.parse(message.dataJson);
					const buttons = parsed.buttonsData;
					if (buttons && buttons.length > 0) {
						return <InteractiveButtonsPreview body={message.body} buttons={buttons} ticketId={message?.ticket?.id} fromMe={message.fromMe} />;
					}
				}
			} catch (_) {}
		}

		if (message?.mediaType === "reactionMessage") {
			return (
				<Typography
					className={classes.messageText}
					style={{ 
						fontStyle: "italic", 
						color: "#54656f",
						userSelect: 'text',
						WebkitUserSelect: 'text',
						MozUserSelect: 'text',
						msUserSelect: 'text'
					}}
				>
					{buildReactionDescription(message)}
				</Typography>
			);
		}

		// Renderizar mensagem de contato (vCard) com card bonito
		if (message?.mediaType === "contactMessage" && message.body) {
			// Extrair informações do vCard
			const parseVCard = (vCardString) => {
				const lines = vCardString.split('\n');
				let name = '';
				let phone = '';
				
				lines.forEach(line => {
					if (line.startsWith('FN:')) {
						name = line.replace('FN:', '').trim();
					} else if (line.startsWith('TEL')) {
						// Extrair número do formato TEL:5524993959492 ou TEL;type=CELL;waid=...:+5524993959492
						const telMatch = line.match(/TEL[^:]*:[\+]?(\d+)/);
						if (telMatch) {
							phone = telMatch[1];
						}
					}
				});
				
				return { name, phone };
			};
			
			const { name, phone } = parseVCard(message.body);
			const displayName = name || phone || 'Contato';
			const displayPhone = phone ? `+${phone}` : '';
			
			console.log('📇 vCard parsed:', { name, phone, displayName, body: message.body });
			
			return (
				<div style={{
					backgroundColor: '#fff',
					borderRadius: '8px',
					overflow: 'hidden',
					maxWidth: '300px',
					border: '1px solid #e9edef',
					cursor: 'pointer'
				}}
					onClick={() => phone && window.open(`https://wa.me/${phone}`, '_blank')}
				>
					<div style={{
						padding: '12px',
						display: 'flex',
						alignItems: 'center',
						gap: '12px'
					}}>
						{/* Avatar do contato */}
						<div style={{
							width: 48,
							height: 48,
							borderRadius: '50%',
							backgroundColor: '#00a884',
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'center',
							flexShrink: 0
						}}>
							<PersonIcon style={{ color: '#fff', fontSize: 28 }} />
						</div>
						
						{/* Informações do contato */}
						<div style={{ flex: 1, minWidth: 0 }}>
							<Typography style={{
								fontSize: '15px',
								color: '#111b21',
								fontWeight: 500,
								marginBottom: '2px',
								overflow: 'hidden',
								textOverflow: 'ellipsis',
								whiteSpace: 'nowrap'
							}}>
								{displayName}
							</Typography>
							{displayPhone && (
								<Typography style={{
									fontSize: '13px',
									color: '#667781',
									overflow: 'hidden',
									textOverflow: 'ellipsis',
									whiteSpace: 'nowrap'
								}}>
									{displayPhone}
								</Typography>
							)}
						</div>
					</div>
					
					{/* Botão de ação */}
					<div style={{
						padding: '10px 12px',
						backgroundColor: '#f0f2f5',
						borderTop: '1px solid #e9edef',
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center',
						gap: '6px'
					}}>
						<WhatsAppIcon style={{ color: '#00a884', fontSize: 16 }} />
						<Typography style={{
							fontSize: '13px',
							color: '#00a884',
							fontWeight: 500
						}}>
							Enviar mensagem
						</Typography>
					</div>
				</div>
			);
		}

		// Renderizar mensagem de localização com card bonito
		if (message?.mediaType === "locationMessage" && message.body) {
			const parts = message.body.split("|");
			let mapUrl = "";
			let coordinates = "";
			let address = "";
			let lat = "";
			let lng = "";
			
			if (parts.length >= 2) {
				mapUrl = parts[0].trim();
				coordinates = parts[1].trim();
				// Extrair lat e lng das coordenadas
				const coords = coordinates.split(',');
				if (coords.length === 2) {
					lat = coords[0].trim();
					lng = coords[1].trim();
				}
				// Se tiver endereço (mais de 2 partes), usar ele
				if (parts.length > 2) {
					address = parts.slice(2).join("|").trim();
				} else {
					address = coordinates;
				}
			} else {
				address = message.body;
			}
			
			return (
				<div style={{
					backgroundColor: '#fff',
					borderRadius: '8px',
					overflow: 'hidden',
					maxWidth: '300px',
					cursor: 'pointer',
					border: '1px solid #e9edef'
				}}
					onClick={() => mapUrl && window.open(mapUrl, '_blank')}
				>
					{/* Mapa usando iframe do OpenStreetMap */}
					{lat && lng && (
						<iframe
							width="300"
							height="120"
							frameBorder="0"
							scrolling="no"
							marginHeight="0"
							marginWidth="0"
							src={`https://www.openstreetmap.org/export/embed.html?bbox=${parseFloat(lng)-0.01},${parseFloat(lat)-0.01},${parseFloat(lng)+0.01},${parseFloat(lat)+0.01}&layer=mapnik&marker=${lat},${lng}`}
							style={{
								border: 'none',
								display: 'block'
							}}
						/>
					)}
					
					{/* Informações da localização */}
					<div style={{
						padding: '10px 12px',
						backgroundColor: '#fff',
						borderTop: '1px solid #e9edef'
					}}>
						<div style={{
							display: 'flex',
							alignItems: 'flex-start',
							gap: '8px'
						}}>
							<LocationOnIcon style={{ color: '#00a884', fontSize: 20, marginTop: '2px', flexShrink: 0 }} />
							<div style={{ flex: 1, minWidth: 0 }}>
								<Typography style={{
									fontSize: '14px',
									color: '#111b21',
									fontWeight: 500,
									marginBottom: '2px'
								}}>
									Localização
								</Typography>
								<Typography style={{
									fontSize: '13px',
									color: '#667781',
									lineHeight: '1.3',
									overflow: 'hidden',
									textOverflow: 'ellipsis',
									display: '-webkit-box',
									WebkitLineClamp: 2,
									WebkitBoxOrient: 'vertical'
								}}>
									{address}
								</Typography>
							</div>
						</div>
					</div>
				</div>
			);
		}

		const hasMedia = Boolean(message.mediaUrl);
		const isBase64 = message.body && message.body.startsWith("data:image/");
		
		// **VERDADE: Backend salva legenda no 'body' quando tem mídia**
		let messageText = message.body || "";
		
		// **NOVO: Extrai texto de mensagens base64 (anúncios Facebook/Instagram)**
		if (isBase64 && messageText.includes(" | ")) {
			// Formato: data:image/png;base64,... | https://fb.me/... | Título do anúncio | Descrição
			const parts = messageText.split(" | ");
			if (parts.length >= 4) {
				// Pega apenas o título e descrição (ignora base64 e URL)
				messageText = parts.slice(2).join(" | "); // Título | Descrição
			}
		}
		
		return (
			<>
				{/* Renderiza a mídia se tiver */}
				{hasMedia && renderMessageMedia(message)}
				
				{/* Legenda: só exibe para imagem/vídeo com body real (não filename de arquivo nem "sticker") */}
				{hasMedia && message.body && message.body.trim() &&
					["image", "video"].includes(message.mediaType) &&
					message.body !== "sticker" && (
					<div style={{ marginTop: "8px" }}>
						<AdMessageText
							text={message.body}
							isBase64={false}
							hasMedia={false}
						/>
					</div>
				)}
				
				{/* Renderiza o texto normal (apenas se não tiver mídia) */}
				{!hasMedia && (
					<>
						{(() => {
							// Condição para exibir texto:
							const shouldShowText = (
								// Mensagem de texto normal (sem mídia)
								(!isBase64 && messageText && 
									!["audio", "reactionMessage", "locationMessage", "contactMessage", "liveLocationMessage"].includes(message.mediaType)
								) ||
								// **NOVO: Base64 (anúncios Facebook/Instagram) - extrai e exibe o texto**
								(isBase64 && messageText && messageText.includes(" | "))
							);
							
							return shouldShowText && messageText && (
								<AdMessageText 
									text={messageText} 
									isBase64={isBase64}
									hasMedia={hasMedia}
								/>
							);
						})()}
					</>
				)}
			</>
		);
	};

	const renderMessageMedia = (message) => {
		if (!message.mediaUrl && !message.mediaType && !message.body) return null;

		const isBase64Image = message.body && message.body.startsWith("data:image/");
		let imageUrl = isBase64Image ? message.body : message.mediaUrl;
		
		// **NOVO: Extrai apenas o base64 da imagem de anúncios Facebook/Instagram**
		if (isBase64Image && message.body.includes(" | ")) {
			const parts = message.body.split(" | ");
			imageUrl = parts[0]; // Pega apenas o data:image/png;base64,...
		}

		// Sticker: preenche o bubble sem fundo/borda
		if (message.mediaType === "sticker" || message.body === "sticker") {
			return (
				<img
					src={message.mediaUrl}
					alt="sticker"
					style={{
						width: "180px",
						height: "180px",
						objectFit: "contain",
						display: "block",
					}}
				/>
			);
		}

		if (message.mediaType === "image" || isBase64Image) {
			return (
				<img
					src={imageUrl}
					alt=""
					style={{
						width: "100%",
						maxHeight: "400px",
						objectFit: "cover",
						borderRadius: "8px",
						marginBottom: "4px",
						cursor: "pointer",
					}}
					onClick={() => handleOpenMediaGallery(message)}
				/>
			);
		}

		if (message.mediaType === "audio") {
			const avatarUrl = message.fromMe 
				? user.profileImage 
				: selectedTicket?.contact?.profilePicUrl;
			const userName = message.fromMe 
				? user.name 
				: selectedTicket?.contact?.name;
			
			return (
				<AudioModal 
					url={message.mediaUrl} 
					avatarUrl={avatarUrl}
					userName={userName}
				/>
			);
		}

		if (message.mediaType === "video") {
			return (
				<div style={{
					backgroundColor: "#000",
					borderRadius: "8px",
					overflow: "hidden",
					marginBottom: "4px",
					width: "100%",
					display: "flex",
					alignItems: "center",
					justifyContent: "center",
					maxHeight: "320px",
				}}>
					<video
						style={{
							maxWidth: "100%",
							maxHeight: "320px",
							display: "block",
						}}
						src={message.mediaUrl}
						controls
					/>
				</div>
			);
		}

		if (message.mediaUrl) {
			// Extrai nome do arquivo e extensão da URL
			const fileName = message.body || message.mediaUrl.split('/').pop().split('?')[0] || 'arquivo';
			const fileExtension = fileName.split('.').pop().toUpperCase();
			
			// Função para formatar tamanho do arquivo (se disponível)
			const formatFileSize = (bytes) => {
				if (!bytes) return '';
				const mb = bytes / (1024 * 1024);
				return mb >= 1 ? `${mb.toFixed(2)} MB` : `${(bytes / 1024).toFixed(2)} KB`;
			};
			
			// Ícone baseado no tipo de arquivo
			const getFileIcon = () => {
				const ext = fileExtension.toLowerCase();
				if (['pdf'].includes(ext)) return <DocumentIcon style={{ fontSize: 40, color: '#fff' }} />;
				if (['zip', 'rar', '7z'].includes(ext)) return <FileIcon style={{ fontSize: 40, color: '#fff' }} />;
				if (['doc', 'docx'].includes(ext)) return <DocumentIcon style={{ fontSize: 40, color: '#fff' }} />;
				if (['xls', 'xlsx', 'csv'].includes(ext)) return <DocumentIcon style={{ fontSize: 40, color: '#fff' }} />;
				if (['txt', 'xml'].includes(ext)) return <DocumentIcon style={{ fontSize: 40, color: '#fff' }} />;
				return <FileIcon style={{ fontSize: 40, color: '#fff' }} />;
			};
			
			return (
				<div style={{ 
					display: 'flex', 
					alignItems: 'center', 
					gap: 12,
					backgroundColor: '#1f2c33',
					padding: '12px 16px',
					borderRadius: 8,
					maxWidth: 350,
					marginBottom: 4
				}}>
					{/* Ícone do arquivo */}
					<div style={{
						width: 48,
						height: 48,
						backgroundColor: '#2a3942',
						borderRadius: 4,
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center',
						flexShrink: 0
					}}>
						{getFileIcon()}
					</div>
					
					{/* Informações do arquivo */}
					<div style={{ flex: 1, minWidth: 0 }}>
						<Typography style={{ 
							fontSize: 14, 
							color: '#e9edef',
							fontWeight: 500,
							overflow: 'hidden',
							textOverflow: 'ellipsis',
							whiteSpace: 'nowrap'
						}}>
							{fileName}
						</Typography>
						<Typography style={{ 
							fontSize: 12, 
							color: '#8696a0',
							marginTop: 2
						}}>
							{fileExtension} • {message.fileSize ? formatFileSize(message.fileSize) : '47 MB'}
						</Typography>
					</div>
					
					{/* Botão de download */}
					<IconButton
						size="small"
						href={message.mediaUrl}
						download
						target="_blank"
						style={{
							backgroundColor: '#2a3942',
							color: '#8696a0',
							flexShrink: 0
						}}
					>
						<GetAppIcon />
					</IconButton>
				</div>
			);
		}

		return null;
	};

	const formatMessageTime = (timestamp) => {
		try {
			return format(parseISO(timestamp), "HH:mm", { locale: ptBR });
		} catch {
			return "";
		}
	};

	// Abre galeria de mídia com todas as imagens/vídeos do ticket
	const handleOpenMediaGallery = (clickedMessage) => {
		// Filtra apenas imagens e vídeos de todas as mensagens
		const allMedias = messages
			.filter(msg => msg.mediaUrl && (msg.mediaType === "image" || msg.mediaType === "video"))
			.map(msg => ({
				id: msg.id,
				mediaUrl: msg.mediaUrl,
				mediaType: msg.mediaType,
				fromMe: msg.fromMe,
				contactName: selectedTicket?.contact?.name,
				createdAt: msg.createdAt,
			}));

		// Encontra o índice da mídia clicada
		const clickedIndex = allMedias.findIndex(media => media.id === clickedMessage.id);

		setGalleryMedias(allMedias);
		setGalleryInitialIndex(clickedIndex >= 0 ? clickedIndex : 0);
		setMediaGalleryOpen(true);
	};

	// Agrupa mensagens consecutivas com mídia do mesmo remetente
	const groupConsecutiveMediaMessages = (messages) => {
		const grouped = [];
		let currentGroup = null;

		messages.forEach((message, index) => {
			const hasMedia = message.mediaUrl && message.mediaType !== "audio";
			const prevMessage = messages[index - 1];
			
			// Verifica se deve agrupar com a mensagem anterior
			const shouldGroup = hasMedia && 
				prevMessage && 
				prevMessage.mediaUrl && 
				prevMessage.mediaType !== "audio" &&
				message.fromMe === prevMessage.fromMe &&
				Math.abs(new Date(message.createdAt) - new Date(prevMessage.createdAt)) < 5000; // 5 segundos

			if (shouldGroup && currentGroup) {
				// Adiciona à grupo atual
				currentGroup.messages.push(message);
			} else {
				// Finaliza grupo anterior se existir
				if (currentGroup) {
					// **SÓ CRIA GRUPO SE TIVER MAIS DE 1 MENSAGEM**
					if (currentGroup.messages.length > 1) {
						grouped.push(currentGroup);
					} else {
						// Se só tem 1 mensagem, adiciona como mensagem individual
						grouped.push(currentGroup.messages[0]);
					}
				}
				
				// Inicia novo grupo ou adiciona mensagem individual
				if (hasMedia) {
					currentGroup = {
						id: `group-${message.id}`,
						isGroup: true,
						messages: [message],
						fromMe: message.fromMe,
						createdAt: message.createdAt
					};
				} else {
					grouped.push(message);
					currentGroup = null;
				}
			}
		});

		// Adiciona último grupo se existir
		if (currentGroup) {
			// **SÓ CRIA GRUPO SE TIVER MAIS DE 1 MENSAGEM**
			if (currentGroup.messages.length > 1) {
				grouped.push(currentGroup);
			} else {
				// Se só tem 1 mensagem, adiciona como mensagem individual
				grouped.push(currentGroup.messages[0]);
			}
		}

		return grouped;
	};

	// Renderiza grid de múltiplos arquivos
	const renderMediaGrid = (messages, showDeleted = false) => {
		// Filtra mensagens deletadas se não estiver no modo de visualização de deletadas
		const filteredMessages = showDeleted ? messages : messages.filter(msg => !msg.isDeleted);
		const totalFiles = filteredMessages.length;
		
		if (totalFiles === 0) return null;
		
		const visibleFiles = Math.min(totalFiles, 4);
		const remainingFiles = totalFiles - visibleFiles;

		// Layout baseado na quantidade de arquivos
		const getGridLayout = () => {
			if (totalFiles === 1) return { columns: 1, rows: 1 };
			if (totalFiles === 2) return { columns: 2, rows: 1 };
			if (totalFiles === 3) return { columns: 2, rows: 2 };
			return { columns: 2, rows: 2 };
		};

		const layout = getGridLayout();
		const itemWidth = layout.columns === 1 ? '100%' : 'calc(50% - 2px)';
		const itemHeight = totalFiles === 2 ? '200px' : '150px';

		return (
			<div style={{ 
				display: 'grid',
				gridTemplateColumns: `repeat(${layout.columns}, 1fr)`,
				gap: 4,
				maxWidth: 350,
				marginBottom: 4
			}}>
				{filteredMessages.slice(0, visibleFiles).map((msg, index) => {
					const isLast = index === visibleFiles - 1 && remainingFiles > 0;
					
					return (
						<div 
							key={msg.id}
							style={{ 
								position: 'relative',
								width: '100%',
								height: itemHeight,
								overflow: 'hidden',
								borderRadius: 8
							}}
						>
							{msg.mediaType === 'image' ? (
								<>
									<img
										src={msg.mediaUrl}
										alt=""
										style={{
											width: '100%',
											height: '100%',
											objectFit: 'cover',
											cursor: 'pointer',
											filter: isLast ? 'brightness(0.5)' : 'none'
										}}
										onClick={() => handleOpenMediaGallery(msg)}
									/>
									{isLast && (
										<div style={{
											position: 'absolute',
											top: 0,
											left: 0,
											right: 0,
											bottom: 0,
											display: 'flex',
											alignItems: 'center',
											justifyContent: 'center',
											backgroundColor: 'rgba(0,0,0,0.6)',
											color: '#fff',
											fontSize: 48,
											fontWeight: 'bold',
											cursor: 'pointer'
										}}>
											+{remainingFiles}
										</div>
									)}
								</>
							) : msg.mediaType === 'video' ? (
							<>
								<video
									src={msg.mediaUrl}
									style={{
										width: '100%',
										height: '100%',
										objectFit: 'cover',
										cursor: 'pointer',
										filter: isLast ? 'brightness(0.5)' : 'none'
									}}
									onClick={() => handleOpenMediaGallery(msg)}
								/>
									{isLast && (
										<div style={{
											position: 'absolute',
											top: 0,
											left: 0,
											right: 0,
											bottom: 0,
											display: 'flex',
											alignItems: 'center',
											justifyContent: 'center',
											backgroundColor: 'rgba(0,0,0,0.6)',
											color: '#fff',
											fontSize: 48,
											fontWeight: 'bold'
										}}>
											+{remainingFiles}
										</div>
									)}
								</>
							) : (
								// Documentos em grid
								<div style={{
									width: '100%',
									height: '100%',
									backgroundColor: '#1f2c33',
									display: 'flex',
									flexDirection: 'column',
									alignItems: 'center',
									justifyContent: 'center',
									padding: 8,
									filter: isLast ? 'brightness(0.7)' : 'none'
								}}>
									<DocumentIcon style={{ fontSize: 40, color: '#8696a0', marginBottom: 4 }} />
									<Typography style={{ 
										fontSize: 11, 
										color: '#e9edef',
										textAlign: 'center',
										overflow: 'hidden',
										textOverflow: 'ellipsis',
										whiteSpace: 'nowrap',
										width: '100%'
									}}>
										{msg.body || 'Documento'}
									</Typography>
									{isLast && (
										<div style={{
											position: 'absolute',
											top: 0,
											left: 0,
											right: 0,
											bottom: 0,
											display: 'flex',
											alignItems: 'center',
											justifyContent: 'center',
											backgroundColor: 'rgba(0,0,0,0.6)',
											color: '#fff',
											fontSize: 48,
											fontWeight: 'bold'
										}}>
											+{remainingFiles}
										</div>
									)}
								</div>
							)}
						</div>
					);
				})}
			</div>
		);
	};

	const formatMessageDateTime = (timestamp) => {
		try {
			return format(parseISO(timestamp), "dd/MM/yyyy HH:mm", { locale: ptBR });
		} catch {
			return "";
		}
	};

	const getStatusColor = (status) => {
		const colors = {
			pending: "#FFA500",
			open: "#00a884",
			closed: "#999999",
		};
		return colors[status] || "#999999";
	};

	const getStatusLabel = (status) => {
		const labels = {
			pending: "Aguardando",
			open: "Atendendo",
			closed: "Finalizado",
		};
		return labels[status] || status;
	};

	const loadFiltersData = async () => {
		try {
			const [queuesRes, usersRes, tagsRes, whatsappsRes] = await Promise.all([
				api.get("/queue"),
				api.get("/users"),
				api.get("/tags"),
				api.get("/whatsapp")
			]);
			
			// Filtra filas baseado nas permissões do usuário
			const allQueues = Array.isArray(queuesRes.data) ? queuesRes.data : [];
			const userQueueIds = user?.queues?.map(q => q.id) || [];
			const filteredQueues = user?.profile === "admin" 
				? allQueues 
				: allQueues.filter(q => userQueueIds.includes(q.id));
			
			// Filtra conexões baseado nas permissões do usuário
			const allWhatsapps = Array.isArray(whatsappsRes.data) ? whatsappsRes.data : [];
			const canViewAllConnections = user?.profile === "admin" || user?.allowConnections === "enabled";
			const filteredWhatsapps = canViewAllConnections || !user?.whatsappId
				? allWhatsapps
				: allWhatsapps.filter(w => w.id === user.whatsappId);
			
			setQueues(filteredQueues);
			setUsers(Array.isArray(usersRes.data.users) ? usersRes.data.users : (Array.isArray(usersRes.data) ? usersRes.data : []));
			setTags(Array.isArray(tagsRes.data) ? tagsRes.data : []);
			setWhatsapps(filteredWhatsapps);
		} catch (err) {
			setQueues([]);
			setUsers([]);
			setTags([]);
			setWhatsapps([]);
		}
	};

	const sumUnread = (tickets = []) =>
		tickets.reduce((total, ticket) => total + (ticket.unreadMessages || 0), 0);
	
	const countTickets = (tickets = []) => tickets.length;

	const loadUnreadCounts = async () => {
		try {
			const baseParams = buildFilterParams();

			const [automationRes, assignedRes, openRes, closedRes, groupRes] = await Promise.all([
				api.get("/tickets", { params: { ...baseParams, status: "pending", pendingType: "automation", pageSize: 1 } }),
				api.get("/tickets", { params: { ...baseParams, status: "pending", pendingType: "assigned", pageSize: 1 } }),
				api.get("/tickets", { params: { ...baseParams, status: "open", pageSize: 1 } }),
				api.get("/tickets", { params: { ...baseParams, status: "closed", pageSize: 1 } }),
				api.get("/tickets", { params: { ...baseParams, status: "group", pageSize: 1 } })
			]);

			const counts = {
				automation: automationRes.data?.count || 0,
				pending: assignedRes.data?.count || 0,
				open: openRes.data?.count || 0,
				closed: closedRes.data?.count || 0,
				groups: groupRes.data?.count || 0,
			};

			setUnreadCounts(counts);
		} catch (err) {
		}
	};

	// Sincroniza ref para que socket handler sempre use versão atualizada de loadUnreadCounts
	// (resolve stale closure: socket captura loadUnreadCounts antigo quando useEffect foi criado)
	useEffect(() => {
		loadUnreadCountsRef.current = loadUnreadCounts;
	});

	const handleSelectQuickMessage = useCallback(async (quickMessage) => {
		setQuickMessagesOpen(false);

		if (!selectedTicket) {
			setInputMessage(quickMessage.message || "");
			return;
		}

		if (isSendingMessageRef.current) return;
		isSendingMessageRef.current = true;
		setIsSendingMessage(true);

		// Mensagem temporária otimista — faz a conversa rolar imediatamente
		const tempId = `temp-quick-${Date.now()}`;
		const tempMsg = {
			id: tempId,
			body: quickMessage.message || "",
			fromMe: true,
			createdAt: new Date().toISOString(),
			loading: true,
			...(quickMessage.messageType === "buttons" && {
				messageType: "buttons",
				buttons: quickMessage.buttons
			}),
			...(quickMessage.mediaPath && {
				mediaType: quickMessage.mediaType || "document",
				mediaUrl: quickMessage.mediaPath,
				mediaName: quickMessage.mediaName || "Arquivo"
			})
		};
		setMessages(prev => [...prev, tempMsg]);

		try {
			// Resposta rápida com botões CTA — envia pelo backend via SendCTAButtons
			if (quickMessage.messageType === "buttons" && quickMessage.buttons?.length) {
				await api.post(`/messages/${selectedTicket.id}`, {
					body: quickMessage.message || "",
					messageType: "buttons",
					buttons: quickMessage.buttons,
					fromMe: true,
				});
			} else if (quickMessage.mediaPath) {
				// Se a resposta rápida tem arquivo, delega ao backend
				await api.post(`/messages/${selectedTicket.id}`, {
					body: quickMessage.message || "",
					quickMessageId: quickMessage.id,
					fromMe: true,
				});
			} else if (quickMessage.message && quickMessage.message.trim()) {
				// Apenas texto
				await api.post(`/messages/${selectedTicket.id}`, {
					body: quickMessage.message,
					fromMe: true,
				});
			}

			setReplyingTo(null);
			setMediaPreviewOpen(false);
			setSelectedFile(null);
			setSelectedFiles([]);
		} catch (err) {
			// Remove temp em caso de erro
			setMessages(prev => prev.filter(m => m.id !== tempId));
			toast.error(`Erro ao enviar resposta rápida: ${err.message}`);
			setInputMessage(quickMessage.message || "");
		} finally {
			isSendingMessageRef.current = false;
			setIsSendingMessage(false);
		}
	}, [selectedTicket, user]);

	const handleMessageMenuOpen = (event, message) => {
		setMessageMenuAnchor(event.currentTarget);
		setSelectedMessage(message);
	};

	const handleTicketContextMenu = (event, ticket) => {
		event.preventDefault();
		setTicketMenuAnchor(event.currentTarget);
		setSelectedTicketForMenu(ticket);
	};

	const handleMessageMenuClose = () => {
		setMessageMenuAnchor(null);
	};

	const handleDeleteMessage = async () => {
		if (!selectedMessage) return;
		
		try {
			await api.delete(`/messages/${selectedMessage.id}`);
			loadMessages(selectedTicket.id);
			setDeleteModalOpen(false);
			setSelectedMessage(null);
		} catch (err) {
		}
	};

	const handleEditMessage = async (newText) => {
		if (!selectedMessage) return;
		
		try {
			await api.post(`/messages/edit/${selectedMessage.id}`, {
				body: newText,
			});
			loadMessages(selectedTicket.id);
			setEditModalOpen(false);
			setSelectedMessage(null);
		} catch (err) {
		}
	};

	const handleForwardMessage = async (contactIds) => {
		if (!selectedMessage) return;
		
		try {
			for (const contactId of contactIds) {
				// Buscar ou criar ticket para o contato
				const { data: ticketData } = await api.post("/tickets", {
					contactId: contactId,
					userId: user.id,
					status: "open",
				});
				
				// Enviar mensagem para o ticket
				await api.post(`/messages/${ticketData.id}`, {
					body: selectedMessage.body,
					mediaUrl: selectedMessage.mediaUrl,
				});
			}
			setForwardModalOpen(false);
			setSelectedMessage(null);
		} catch (err) {
		}
	};

	const handleReplyMessage = (message) => {
		setReplyingTo(message);
		setMessageMenuAnchor(null);
	};

	const toggleFilter = (type, id) => {
		if (type === "queue") {
			setSelectedQueues(prev => 
				prev.includes(id) ? prev.filter(i => i !== id) : [...prev, id]
			);
		} else if (type === "user") {
			setSelectedUsers(prev => 
				prev.includes(id) ? prev.filter(i => i !== id) : [...prev, id]
			);
		} else if (type === "tag") {
			setSelectedTags(prev => 
				prev.includes(id) ? prev.filter(i => i !== id) : [...prev, id]
			);
		} else if (type === "kanbanTag") {
			setSelectedKanbanTags(prev =>
				prev.includes(id) ? prev.filter(i => i !== id) : [...prev, id]
			);
		} else if (type === "whatsapp") {
			setSelectedWhatsapps(prev =>
				prev.includes(id) ? prev.filter(i => i !== id) : [...prev, id]
			);
		}
	};

	const clearFilters = () => {
		setSelectedQueues([]);
		setSelectedUsers([]);
		setSelectedTags([]);
		setSelectedKanbanTags([]);
		setSelectedWhatsapps([]);
		setMessageDirectionFilter(null);
	};

	const hasActiveFilters = selectedQueues.length > 0 || selectedUsers.length > 0 || selectedTags.length > 0 || selectedKanbanTags.length > 0 || selectedWhatsapps.length > 0 || messageDirectionFilter !== null;

	const handleOpenCloseAllDialog = () => {
		setCloseAllDialogOpen(true);
	};

	const handleCloseCloseAllDialog = () => {
		if (!closingAllTickets) {
			setCloseAllDialogOpen(false);
		}
	};

	const handleCreateGroup = async () => {
		if (!newGroupSubject.trim()) {
			toast.error("Informe o nome do grupo");
			return;
		}
		if (!newGroupWhatsappId) {
			toast.error("Selecione uma conexão WhatsApp");
			return;
		}
		const phones = newGroupParticipants
			.split(/[\n,;]+/)
			.map((p) => p.replace(/\D/g, ""))
			.filter((p) => p.length >= 10);
		if (phones.length === 0) {
			toast.error("Informe ao menos um número com DDD (10+ dígitos)");
			return;
		}
		setCreatingGroup(true);
		try {
			await api.post("/groups/create", {
				whatsappId: newGroupWhatsappId,
				subject: newGroupSubject.trim(),
				participantNumbers: phones,
			});
			toast.success("Grupo criado com sucesso!");
			setCreateGroupModal(false);
			setNewGroupSubject("");
			setNewGroupParticipants("");
		} catch (err) {
			toast.error(err?.response?.data?.error || "Erro ao criar grupo");
		} finally {
			setCreatingGroup(false);
		}
	};

	const handleCloseAllTickets = async () => {
		setClosingAllTickets(true);
		try {
			await api.post("/tickets/closeAll", {
				status: "open",
				selectedQueueIds: selectedQueues
			});
			toast.success("Todos os tickets em atendimento foram encerrados.");
			await Promise.all([loadTickets(), loadUnreadCounts()]);
			setCloseAllDialogOpen(false);
		} catch (err) {
			toast.error("Não foi possível encerrar os tickets. Tente novamente.");
		} finally {
			setClosingAllTickets(false);
		}
	};

	// eslint-disable-next-line react-hooks/rules-of-hooks
	useEffect(() => {
		const cNum = selectedTicket?.contact?.number || "";
		const isGrp = selectedTicket?.isGroup || cNum.replace(/\D/g, "").length > 15;
		if (!isGrp || !selectedTicket?.whatsappId) return;
		const grpJid = selectedTicket.contact?.number?.includes("@")
			? selectedTicket.contact.number
			: `${selectedTicket.contact?.number}@g.us`;
		if (groupAdminMap[grpJid] === true || groupAdminMap[grpJid] === false) return;
		api.get(`/groups/${encodeURIComponent(grpJid)}/metadata`, {
			params: { whatsappId: selectedTicket.whatsappId },
		}).then(({ data }) => {
			setGroupAdminMap(prev => ({ ...prev, [grpJid]: data.amIAdmin === true }));
		}).catch(() => {
			// Falha ao buscar → não sabe o status, deixa habilitado (null = desconhecido)
			setGroupAdminMap(prev => ({ ...prev, [grpJid]: null }));
		});
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [selectedTicket?.id]);

	// eslint-disable-next-line react-hooks/rules-of-hooks
	useEffect(() => {
		if (!isMobile) {
			setMobileView("desktop");
			return;
		}

		if (selectedTicket) {
			setMobileView("chat");
		} else {
			setMobileView("list");
		}
	}, [isMobile, selectedTicket]);

	const shouldShowList = (!isMobile || mobileView === "list") && !shouldHideMobileMenu;
	const shouldShowChat = (!isMobile || mobileView === "chat") || shouldHideMobileMenu;

	const canReturnClosedTicket =
		selectedTicket &&
		selectedTicket.status === "closed";

	const handleReturnTicket = async () => {
		if (!selectedTicket || selectedTicket.status !== "closed") return;

		try {
			await api.put(`/tickets/${selectedTicket.id}`, {
				status: "open",
				userId: user?.id,
				isBot: false
			});

			setTickets(prevTickets => {
				const updatedTickets = prevTickets.map(ticket => {
					if (ticket.id === selectedTicket.id) {
						return {
							...ticket,
							status: "open",
							userId: user?.id,
							updatedAt: new Date().toISOString()
						};
					}
					return ticket;
				});
				return updatedTickets.sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt));
			});

			setSelectedTicket(prev => prev ? { ...prev, status: "open", userId: user?.id } : prev);

			await loadUnreadCounts();
			if (tabIndex !== 2) {
				setTabIndex(2);
			}
			history.push(`/atendimentos/${selectedTicket.id}`);
		} catch (err) {
			toast.error("Não foi possível reabrir o ticket.");
		}
	};

	const handleRemoveGroup = async (ticket) => {
		if (!ticket || !ticket.isGroup) return;
		
		const confirmRemover = await showConfirm({
			type: "error",
			title: "Remover Grupo",
			message: `Deseja realmente remover o grupo "${ticket.contact?.name || 'Sem nome'}"?`,
			confirmText: "Sim, remover",
			cancelText: "Cancelar",
		});
		if (!confirmRemover) {
			return;
		}

		try {
			await api.delete(`/tickets/${ticket.id}`);
			toast.success("Grupo removido com sucesso!");
			await loadTickets();
			await loadUnreadCounts();
			if (selectedTicket?.id === ticket.id) {
				setSelectedTicket(null);
			}
		} catch (err) {
			toast.error("Erro ao remover grupo");
		}
	};

	// eslint-disable-next-line react-hooks/rules-of-hooks
	useEffect(() => {
		const timer = setTimeout(() => {
			if (quickReplyStartIndexRef.current === -1) {
				setShowQuickReplies(false);
				setFilteredQuickMessages([]);
				setSelectedQuickIndex(-1);
				return;
			}
			const term = quickReplySearchTerm.trim().toLowerCase();
			const filtered = term
				? quickMessages.filter(msg =>
					msg.message?.toLowerCase().includes(term) ||
					msg.shortcode?.toLowerCase().includes(term)
				)
				: quickMessages;
			setFilteredQuickMessages(filtered);
			setShowQuickReplies(filtered.length > 0);
			setSelectedQuickIndex(filtered.length ? 0 : -1);
		}, 200);

		return () => clearTimeout(timer);
	}, [quickReplySearchTerm, quickMessages]);

	// Variáveis de grupo expostas para o Dialog mobile (header mantém as mesmas via useMemo)
	const _gNum = selectedTicket?.contact?.number || "";
	const _isGroup = selectedTicket?.isGroup || _gNum.replace(/\D/g, "").length > 15;
	const groupIsConnected = _isGroup && (selectedTicket?.whatsapp?.status === "CONNECTED" || !!selectedTicket?.whatsappId);
	const groupJidDialog = _gNum.includes("@") ? _gNum : `${_gNum}@g.us`;
	const groupNameDialog = selectedTicket?.contact?.name || "Grupo";
	const groupWIdDialog = selectedTicket?.whatsappId;
	const groupIsAdmin = groupIsConnected ? (groupAdminMap[groupJidDialog] !== false) : true;

	// eslint-disable-next-line react-hooks/rules-of-hooks
	const chatHeaderMemo = useMemo(() => {
		if (!selectedTicket) return null;

		const contactNum = selectedTicket.contact?.number || "";
		const isGroup = selectedTicket.isGroup || contactNum.replace(/\D/g, "").length > 15;
		const isGroupConnected = isGroup && (selectedTicket?.whatsapp?.status === "CONNECTED" || selectedTicket?.whatsappId);
		const groupJid = selectedTicket.contact?.number?.includes("@")
			? selectedTicket.contact.number
			: `${selectedTicket.contact?.number}@g.us`;
		const groupName = selectedTicket.contact?.name || "Grupo";
		const wId = selectedTicket.whatsappId;
		const isGroupAdmin = isGroupConnected ? (groupAdminMap[groupJid] !== false) : true;
		const guardAdmin = (fn) => () => {
			if (!isGroupAdmin) { toast.warn("Você não é administrador deste grupo"); return; }
			fn();
		};

		return (
			<div className={`${classes.chatHeader} ${isMobile ? classes.chatHeaderMobile : ""}`}>
				<IconButton onClick={handleBackToList} style={{ marginRight: 8 }} aria-label="Voltar para atendimentos">
					<ArrowBackIcon />
				</IconButton>
				<Avatar
					src={selectedTicket.contact?.profilePicUrl}
					onClick={handleOpenContactModal}
					style={{ cursor: selectedTicket?.contact ? "pointer" : "default" }}
				>
					{selectedTicket.contact?.name?.charAt(0)}
				</Avatar>
				<div
					className={classes.chatHeaderInfo}
					onClick={handleOpenContactModal}
					style={{ cursor: selectedTicket?.contact ? "pointer" : "default" }}
				>
					<Typography style={{ fontSize: 16, fontWeight: 500, color: "#111b21" }}>
						{selectedTicket.contact?.name || "Sem nome"}
					</Typography>
					{!isMobile && (
						<Typography style={{ fontSize: 13, color: "#667781" }}>
							{selectedTicket.contact?.number}
						</Typography>
					)}
				</div>
				{isMobile && (
					<IconButton size="small" onClick={() => setMobileActionsOpen(true)} style={{ marginLeft: "auto" }}>
						<MoreVertIcon />
					</IconButton>
				)}
				{!isMobile && (
					<div style={{ display: 'flex', gap: 4, marginLeft: 'auto', alignItems: 'center' }}>
						{isGroupConnected && (
							<>
								<Tooltip title={isGroupAdmin ? "Participantes" : "Sem permissão — você não é admin deste grupo"}>
									<span>
										<IconButton size="small" onClick={guardAdmin(() => setParticipantsModal({ open: true, jid: groupJid, whatsappId: wId, name: groupName }))} style={!isGroupAdmin ? { opacity: 0.4 } : undefined}>
											<PeopleIcon fontSize="small" />
										</IconButton>
									</span>
								</Tooltip>
								<Tooltip title={isGroupAdmin ? "Foto do grupo" : "Sem permissão — você não é admin deste grupo"}>
									<span>
										<IconButton size="small" onClick={guardAdmin(() => setImageModal({ open: true, jid: groupJid, whatsappId: wId, name: groupName }))} style={!isGroupAdmin ? { opacity: 0.4 } : undefined}>
											<PhotoCameraIcon fontSize="small" />
										</IconButton>
									</span>
								</Tooltip>
								<Tooltip title={isGroupAdmin ? "Configurações do grupo" : "Sem permissão — você não é admin deste grupo"}>
									<span>
										<IconButton size="small" onClick={guardAdmin(() => setSettingsModal({ open: true, jid: groupJid, whatsappId: wId, name: groupName }))} style={!isGroupAdmin ? { opacity: 0.4 } : undefined}>
											<SettingsIcon fontSize="small" />
										</IconButton>
									</span>
								</Tooltip>
								<Tooltip title={isGroupAdmin ? "Link de convite" : "Sem permissão — você não é admin deste grupo"}>
									<span>
										<IconButton
											size="small"
											style={!isGroupAdmin ? { opacity: 0.4 } : undefined}
											onClick={guardAdmin(async () => {
												setInviteModal({ open: true, jid: groupJid, whatsappId: wId, name: groupName, link: "", loading: true });
												try {
													const { data } = await api.get(`/groups/${encodeURIComponent(groupJid)}/invite`, { params: { whatsappId: wId } });
													setInviteModal(prev => ({ ...prev, link: data.link || `https://chat.whatsapp.com/${data.code}` || "", loading: false }));
												} catch {
													toast.error("Erro ao obter link de convite");
													setInviteModal(prev => ({ ...prev, loading: false }));
												}
											})}
										>
											<LinkIcon fontSize="small" />
										</IconButton>
									</span>
								</Tooltip>
							</>
						)}
						{renderTicketActionButtons()}
					</div>
				)}
			</div>
		);
	}, [selectedTicket, isMobile, renderTicketActionButtons, handleBackToList, handleOpenContactModal, groupAdminMap]);

	return (
		<div className={`${classes.root} ${isMobile ? classes.rootMobile : ""}`}>
			{shouldShowList && (
				<div className={`${classes.sidebar} ${isMobile ? classes.sidebarMobile : ""}`}>
					{/* Header */}
					<div className={classes.sidebarHeader}>
						<Avatar src={user?.profileImage} alt={user?.name}>
							{user?.name?.charAt(0)}
						</Avatar>
						<div style={{ flex: 1 }} />
						<div style={{ display: "flex", gap: 6, marginRight: 8 }}>
							{channelQuickOptions.map(option => {
								const isActive = selectedChannelsQuickFilter.includes(option.key);
								return (
									<Tooltip key={option.key} title={`Filtrar ${option.label}`}>
										<span>
											<IconButton
												size="small"
												onClick={() => toggleChannelQuickFilter(option.key)}
												style={{
													border: `1px solid ${option.color}`,
													color: isActive ? "#ffffff" : option.color,
													backgroundColor: isActive ? option.color : "transparent",
													width: 34,
													height: 34
												}}
											>
												{option.icon}
											</IconButton>
										</span>
									</Tooltip>
								);
							})}
						</div>
						{/* Botão Ver Todos - apenas para quem tem permissão */}
						{(user?.profile === "admin" || user?.allUserChat === "enabled" || user?.allTicket === "enabled") && (
							<Tooltip title={showAllTickets ? "Ver apenas meus tickets" : "Ver todos os tickets"}>
								<IconButton
									size="small"
									onClick={toggleShowAllTickets}
									style={{ 
										marginRight: 8,
										backgroundColor: showAllTickets ? "#00a884" : "transparent",
										color: showAllTickets ? "#ffffff" : "inherit"
									}}
								>
									{showAllTickets ? <VisibilityIcon /> : <VisibilityOffIcon />}
								</IconButton>
							</Tooltip>
						)}
						<Tooltip title="Encerrar todos os atendimentos">
							<span>
								<IconButton
									size="small"
									onClick={handleOpenCloseAllDialog}
									disabled={closingAllTickets}
									style={{ marginRight: 8 }}
								>
									<DoneAllIcon />
								</IconButton>
							</span>
						</Tooltip>
						{canCreateGroup && (
							<Tooltip title="Criar grupo do WhatsApp">
								<IconButton
									size="small"
									onClick={() => {
										const connected = whatsapps.filter(w => w.status === "CONNECTED");
										if (connected.length === 0) {
											toast.error("Nenhuma conexão WhatsApp ativa");
											return;
										}
										const v = String(connected[0].id);
										setNewGroupWhatsappId(v);
										setCreateGroupModal(true);
									}}
									style={{
										border: "1px solid #667781",
										color: "#667781",
										backgroundColor: "transparent",
										width: 34,
										height: 34,
										marginRight: 6
									}}
								>
									<GroupsIcon style={{ fontSize: 19 }} />
								</IconButton>
							</Tooltip>
						)}

						{/* Iniciar conversa. Nao existia nesta tela: para falar com alguem
						    era preciso esperar a pessoa escrever primeiro. Cheia, para
						    separar acao de filtro nas bolinhas vizinhas. */}
						<Tooltip title="Nova conversa">
							<IconButton
								size="small"
								onClick={() => setNovaConversaAberta(true)}
								style={{
									border: "1px solid #1976d2",
									backgroundColor: "#1976d2",
									color: "#ffffff",
									width: 34,
									height: 34,
									flexShrink: 0
								}}
							>
								<PersonAddAlt1Icon style={{ fontSize: 19 }} />
							</IconButton>
						</Tooltip>

						<LigacaoOficial
							chamadaParaIniciar={chamadaOficial}
							aoEncerrar={() => setChamadaOficial(null)}
						/>

						<NewTicketModal
							modalOpen={novaConversaAberta}
							onClose={(ticket) => {
								setNovaConversaAberta(false);
								if (ticket?.id) history.push(`/atendimentos/${ticket.id}`);
							}}
						/>

					</div>

					{/* Tabs */}
					<Tabs
						value={tabIndex}
						onChange={(e, newValue) => setTabIndex(newValue)}
						className={classes.tabs}
						indicatorColor="primary"
						textColor="primary"
						variant="fullWidth"
					>
						{/* Aba de Automação - apenas para admins */}
						{user?.profile === "admin" && (
							<Tab 
								label={
									<div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 4, paddingTop: 10 }}>
										<Badge
											badgeContent={unreadCounts.automation}
											color="error"
											max={9999}
											overlap="rectangular"
											style={{ fontSize: '0.35rem', minWidth: 10, height: 10 }}
										>
											<span style={{ width: 1, height: 1, display: 'block' }}></span>
										</Badge>
										<span style={{ fontSize: '0.65rem', padding: '0 4px' }}>Automação</span>
									</div>
								} 
							/>
						)}
						<Tab 
							label={
								<div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 4, paddingTop: 10 }}>
									<Badge 
										badgeContent={unreadCounts.pending}
										color="error"
										max={9999}
										overlap="rectangular"
										style={{ fontSize: '0.35rem', minWidth: 10, height: 10 }}
									/>
									<span style={{ fontSize: '0.65rem', padding: '0 4px' }}>Aguardando</span>
								</div>
							} 
						/>
						<Tab 
							label={
								<div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 4, paddingTop: 10 }}>
									<Badge 
										badgeContent={unreadCounts.open}
										color="error"
										max={9999}
										overlap="rectangular"
										style={{ fontSize: '0.35rem', minWidth: 10, height: 10 }}
									/>
									<span style={{ fontSize: '0.65rem', padding: '0 4px' }}>Atendendo</span>
								</div>
							} 
						/>
						<Tab 
							label={
								<div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 4, paddingTop: 10 }}>
									<Badge 
										badgeContent={unreadCounts.closed}
										color="primary"
										max={9999}
										overlap="rectangular"
										style={{ fontSize: '0.35rem', minWidth: 10, height: 10 }}
									/>
									<span style={{ fontSize: '0.65rem', padding: '0 4px' }}>Finalizados</span>
								</div>
							} 
						/>
						{user?.allowGroup === true && (
							<Tab 
								label={
									<div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 4, paddingTop: 10 }}>
										<Badge 
											badgeContent={unreadCounts.groups}
											color="secondary"
											max={9999}
											overlap="rectangular"
											style={{ fontSize: '0.35rem', minWidth: 10, height: 10 }}
										/>
										<span style={{ fontSize: '0.65rem', padding: '0 4px' }}>Grupos</span>
									</div>
								} 
							/>
						)}
					</Tabs>

					{/* Tickets List */}
					<div
					className={classes.ticketsList}
					ref={ticketsListRef}
					onScroll={(e) => {
						const el = e.currentTarget;
						const nearBottom = el.scrollHeight - el.scrollTop - el.clientHeight < 80;
						if (nearBottom && ticketsHasMore && !loadingMoreTickets) {
							loadMoreTickets();
						}
					}}
				>
						{loading ? (
							<div style={{ display: "flex", justifyContent: "center", padding: 20 }}>
								<CircularProgress size={30} />
							</div>
						) : tickets.length === 0 ? (
							<div style={{ padding: 20, textAlign: "center", color: "#667781" }}>
								Nenhum atendimento encontrado
							</div>
						) : (
							tickets.map((ticket) => (
								<div
									key={ticket.id}
									className={`${classes.ticketItem} ${selectedTicket?.id === ticket.id ? "active" : ""}`}
									onClick={() => handleTicketClick(ticket)}
									onContextMenu={(e) => handleTicketContextMenu(e, ticket)}
								>
									<Avatar
										src={ticket.contact?.profilePicUrl}
										className={classes.ticketAvatar}
									>
										{ticket.contact?.name?.charAt(0)}
									</Avatar>
									<div className={classes.ticketInfo}>
										<Typography className={classes.ticketName}>
											{ticket.contact?.name || "Sem nome"}
										</Typography>
										<div className={classes.ticketLastMessage}>
											{ticket.lastMessage || "Sem mensagens"}
										</div>

										<div style={{ display: 'flex', alignItems: 'center', gap: 6, marginTop: 4, flexWrap: 'wrap' }}>
											{/* Conexão — sempre mostra */}
											{(() => {
												const channelStyle = getChannelStyle(ticket.channel);
												return (
													<div style={{ display: 'flex', alignItems: 'center', gap: 4, backgroundColor: channelStyle.bg, padding: '2px 6px', borderRadius: 4 }}>
														<ConnectionIcon connectionType={ticket.channel} size={12} />
														<Typography style={{ fontSize: 10, color: channelStyle.color, fontWeight: 500 }}>
															{ticket.whatsapp?.name || ticket.channel || 'WhatsApp'}
														</Typography>
													</div>
												);
											})()}
											{/* Fila — sempre mostra */}
											<div style={{ display: 'flex', alignItems: 'center', gap: 4, backgroundColor: '#f5f5f5', padding: '2px 6px', borderRadius: 4 }}>
												<Typography style={{ fontSize: 10, color: '#667781', fontWeight: 500 }}>
													{ticket.queue?.name || 'Sem fila'}
												</Typography>
											</div>
											{/* Usuário — sempre mostra */}
											<div style={{ display: 'flex', alignItems: 'center', gap: 4, backgroundColor: '#f5f5f5', padding: '2px 6px', borderRadius: 4 }}>
												<Typography style={{ fontSize: 10, color: '#667781', fontWeight: 500 }}>
													{ticket.user?.name || 'Sem usuário'}
												</Typography>
											</div>
											{TAB_CONFIG[tabIndex]?.key === "groups" && (ticket.lastFlowId || ticket.hashFlowId) && (
												<Tooltip title={`ID: ${ticket.lastFlowId || ticket.hashFlowId}`} arrow>
													<div style={{ display: 'flex', alignItems: 'center', backgroundColor: '#f3e8ff', padding: '2px 6px', borderRadius: 4 }}>
														<SmartToyIcon style={{ fontSize: 12, color: '#9054bc' }} />
													</div>
												</Tooltip>
											)}
											{/* Tempo de espera */}
											{TAB_CONFIG[tabIndex]?.key === "pending" && formatWaitingTime(ticket) && (
												<div style={{ display: 'flex', alignItems: 'center', gap: 4, backgroundColor: '#fff3e0', padding: '2px 6px', borderRadius: 4 }}>
													<Typography style={{ fontSize: 10, color: '#ff9800', fontWeight: 500 }}>
														{formatWaitingTime(ticket)}
													</Typography>
												</div>
											)}
										</div>
										{/* Tags — linha separada: tags normais do ticket + tags do contato (sem kanban) */}
										{(() => {
											const ticketTags = Array.isArray(ticket.tags) ? ticket.tags.filter(t => t.kanban !== 1) : [];
											const contactTags = Array.isArray(ticket.contact?.tags) ? ticket.contact.tags.filter(t => t.kanban !== 1) : [];
											// Une as duas listas removendo duplicatas por id
											const allTagIds = new Set();
											const allTags = [...ticketTags, ...contactTags].filter(tag => {
												if (allTagIds.has(tag.id)) return false;
												allTagIds.add(tag.id);
												return true;
											});
											if (allTags.length === 0) return null;
											return (
												<div style={{ display: 'flex', flexWrap: 'wrap', gap: 3, marginTop: 3 }}>
													{allTags.slice(0, 5).map(tag => (
														<div key={tag.id} style={{ display: 'flex', alignItems: 'center', backgroundColor: tag.color || '#e0e0e0', padding: '2px 7px', borderRadius: 4 }}>
															<Typography style={{ fontSize: 9, color: '#ffffff', fontWeight: 600 }}>
																{tag.name}
															</Typography>
														</div>
													))}
													{allTags.length > 5 && (
														<div style={{ display: 'flex', alignItems: 'center', backgroundColor: '#9e9e9e', padding: '2px 6px', borderRadius: 4 }}>
															<Typography style={{ fontSize: 9, color: '#ffffff', fontWeight: 500 }}>
																+{allTags.length - 5}
															</Typography>
														</div>
													)}
												</div>
											);
										})()}
									</div>
									<div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: 4, marginLeft: 'auto', alignSelf: 'flex-start' }}>
										<div style={{ display: 'flex', alignItems: 'center', gap: 2 }}>
											<Typography className={classes.ticketTime}>
												{ticket.lastMessage && formatMessageTime(ticket.updatedAt)}
											</Typography>
											{ticket.isGroup && (
												<IconButton
													size="small"
													onClick={(e) => { e.stopPropagation(); handleTicketContextMenu(e, ticket); }}
													style={{ padding: 2, color: "#94a3b8" }}
												>
													<ExpandMoreIcon style={{ fontSize: 16 }} />
												</IconButton>
											)}
										</div>
										{ticket.unreadMessages > 0 && (
											<div className={classes.unreadBadge}>
												{ticket.unreadMessages}
											</div>
										)}
									</div>
								</div>
							))
						)}
						{loadingMoreTickets && (
							<div style={{ display: 'flex', justifyContent: 'center', padding: '12px 0', borderTop: '1px solid #e9edef' }}>
								<CircularProgress size={20} style={{ color: '#00a884' }} />
							</div>
						)}
						{!loadingMoreTickets && !ticketsHasMore && tickets.length >= TICKETS_PAGE_SIZE && (
							<div style={{ textAlign: 'center', padding: '10px 0', color: '#a0aec0', fontSize: 11 }}>
								Todos os atendimentos carregados
							</div>
						)}
					</div>
				</div>
			)}

			{selectedTicketForMenu && (
				<TicketActionsMenu
					ticket={selectedTicketForMenu}
					anchorEl={ticketMenuAnchor}
					open={Boolean(ticketMenuAnchor)}
					onClose={() => {
						setTicketMenuAnchor(null);
						setSelectedTicketForMenu(null);
					}}
					onUpdate={() => {
						loadTickets();
						loadUnreadCounts();
						setTicketMenuAnchor(null);
						setSelectedTicketForMenu(null);
					}} 
				/>
			)}


			{/* Área de chat */}
			{shouldShowChat && (
				<div className={`${classes.chatArea} ${isMobile ? classes.chatAreaMobile : ""}`}>
					{selectedTicket ? (
						<>
							{/* Chat Header */}
							{chatHeaderMemo}

							{/* Modal de ações mobile */}
							<Dialog
								open={mobileActionsOpen}
								onClose={() => setMobileActionsOpen(false)}
								PaperProps={{ style: { borderRadius: 16, minWidth: 300, maxWidth: 380, margin: 16 } }}
							>
								<DialogTitle style={{ padding: "16px 20px 8px", fontWeight: 700, fontSize: 15 }}>
									Ações do atendimento
								</DialogTitle>
								<List style={{ padding: "0 8px 8px" }} disablePadding>
									{groupIsConnected && (
										<>
											<ListItem button style={{ borderRadius: 10, marginBottom: 2 }}
												onClick={() => {
													setMobileActionsOpen(false);
													if (!groupIsAdmin) { toast.warn("Você não é administrador deste grupo"); return; }
													setParticipantsModal({ open: true, jid: groupJidDialog, whatsappId: groupWIdDialog, name: groupNameDialog });
												}}>
												<ListItemIcon style={{ minWidth: 38 }}><PeopleIcon style={{ color: "#1976d2", opacity: groupIsAdmin ? 1 : 0.4 }} /></ListItemIcon>
												<ListItemText primary="Participantes do grupo" secondary={!groupIsAdmin ? "Sem permissão de admin" : undefined} />
											</ListItem>
											<ListItem button style={{ borderRadius: 10, marginBottom: 2 }}
												onClick={() => {
													setMobileActionsOpen(false);
													if (!groupIsAdmin) { toast.warn("Você não é administrador deste grupo"); return; }
													setImageModal({ open: true, jid: groupJidDialog, whatsappId: groupWIdDialog, name: groupNameDialog });
												}}>
												<ListItemIcon style={{ minWidth: 38 }}><PhotoCameraIcon style={{ color: "#1976d2", opacity: groupIsAdmin ? 1 : 0.4 }} /></ListItemIcon>
												<ListItemText primary="Foto do grupo" secondary={!groupIsAdmin ? "Sem permissão de admin" : undefined} />
											</ListItem>
											<ListItem button style={{ borderRadius: 10, marginBottom: 2 }}
												onClick={() => {
													setMobileActionsOpen(false);
													if (!groupIsAdmin) { toast.warn("Você não é administrador deste grupo"); return; }
													setSettingsModal({ open: true, jid: groupJidDialog, whatsappId: groupWIdDialog, name: groupNameDialog });
												}}>
												<ListItemIcon style={{ minWidth: 38 }}><SettingsIcon style={{ color: "#1976d2", opacity: groupIsAdmin ? 1 : 0.4 }} /></ListItemIcon>
												<ListItemText primary="Configurações do grupo" secondary={!groupIsAdmin ? "Sem permissão de admin" : undefined} />
											</ListItem>
											<ListItem button style={{ borderRadius: 10, marginBottom: 2 }}
												onClick={async () => {
													setMobileActionsOpen(false);
													if (!groupIsAdmin) { toast.warn("Você não é administrador deste grupo"); return; }
													setInviteModal({ open: true, jid: groupJidDialog, whatsappId: groupWIdDialog, name: groupNameDialog, link: "", loading: true });
													try {
														const { data } = await api.get(`/groups/${encodeURIComponent(groupJidDialog)}/invite`, { params: { whatsappId: groupWIdDialog } });
														setInviteModal(prev => ({ ...prev, link: data.link || `https://chat.whatsapp.com/${data.code}` || "", loading: false }));
													} catch {
														toast.error("Erro ao obter link de convite");
														setInviteModal(prev => ({ ...prev, loading: false }));
													}
												}}>
												<ListItemIcon style={{ minWidth: 38 }}><LinkIcon style={{ color: "#1976d2", opacity: groupIsAdmin ? 1 : 0.4 }} /></ListItemIcon>
												<ListItemText primary="Link de convite" secondary={!groupIsAdmin ? "Sem permissão de admin" : undefined} />
											</ListItem>
											<Divider style={{ margin: "4px 0" }} />
										</>
									)}
									{selectedTicket?.status === "pending" && (
										<>
											<ListItem button style={{ borderRadius: 10, marginBottom: 2 }}
												onClick={async () => {
													setMobileActionsOpen(false);
													try {
														await api.put(`/tickets/${selectedTicket.id}`, { status: "open", userId: user?.id });
														setMobileView("list");
														loadTickets(); loadUnreadCounts();
													} catch {}
												}}>
												<ListItemIcon style={{ minWidth: 38 }}><CheckCircleIcon style={{ color: "#00a884" }} /></ListItemIcon>
												<ListItemText primary="Aceitar ticket" />
											</ListItem>
											<ListItem button style={{ borderRadius: 10, marginBottom: 2 }}
												onClick={async () => {
													setMobileActionsOpen(false);
													const ok = await showConfirm({ type: "warning", title: "Ignorar Ticket", message: "Deseja realmente ignorar este ticket?", confirmText: "Sim, ignorar", cancelText: "Cancelar" });
													if (ok) { await api.delete(`/tickets/${selectedTicket.id}`); setSelectedTicket(null); history.push("/atendimentos" + window.location.search); loadTickets(); loadUnreadCounts(); }
												}}>
												<ListItemIcon style={{ minWidth: 38 }}><BlockIcon style={{ color: "#f44336" }} /></ListItemIcon>
												<ListItemText primary="Ignorar ticket" />
											</ListItem>
										</>
									)}
									{canReturnClosedTicket && (
										<ListItem button style={{ borderRadius: 10, marginBottom: 2 }}
											onClick={() => { setMobileActionsOpen(false); handleReturnTicket(); }}>
											<ListItemIcon style={{ minWidth: 38 }}><ReplayIcon style={{ color: "#1976d2" }} /></ListItemIcon>
											<ListItemText primary="Reabrir ticket" />
										</ListItem>
									)}
									{selectedTicket?.status === "open" && (
										<>
											<ListItem button style={{ borderRadius: 10, marginBottom: 2 }}
												onClick={() => { setMobileActionsOpen(false); handleOpenWavoipCall(); }}>
												<ListItemIcon style={{ minWidth: 38 }}><CallIcon style={{ color: "#0872b9" }} /></ListItemIcon>
												<ListItemText primary="Iniciar chamada" />
											</ListItem>
											<ListItem button style={{ borderRadius: 10, marginBottom: 2 }}
												onClick={() => { setMobileActionsOpen(false); setHistoryModalOpen(true); }}>
												<ListItemIcon style={{ minWidth: 38 }}><HistoryIcon style={{ color: "#ff9800" }} /></ListItemIcon>
												<ListItemText primary="Histórico de conversas" />
											</ListItem>
											<ListItem button style={{ borderRadius: 10, marginBottom: 2 }}
												onClick={() => { setMobileActionsOpen(false); handleOpenFaturaModal(); }}>
												<ListItemIcon style={{ minWidth: 38 }}><ReceiptIcon style={{ color: "#9c27b0" }} /></ListItemIcon>
												<ListItemText primary="Criar fatura" />
											</ListItem>
											<ListItem button style={{ borderRadius: 10, marginBottom: 2 }}
												onClick={() => { setMobileActionsOpen(false); handleOpenAppointmentModal(); }}>
												<ListItemIcon style={{ minWidth: 38 }}><EventIcon style={{ color: "#4caf50" }} /></ListItemIcon>
												<ListItemText primary="Agendar compromisso" />
											</ListItem>
											<ListItem button style={{ borderRadius: 10, marginBottom: 2 }}
												onClick={() => { setMobileActionsOpen(false); handleOpenTransferModal(); }}>
												<ListItemIcon style={{ minWidth: 38 }}><SwapHorizIcon style={{ color: "#437db5" }} /></ListItemIcon>
												<ListItemText primary="Transferir atendimento" />
											</ListItem>
											<ListItem button style={{ borderRadius: 10, marginBottom: 2 }}
												onClick={() => { setMobileActionsOpen(false); handleOpenProjectModal(); }}>
												<ListItemIcon style={{ minWidth: 38 }}><BusinessCenterIcon style={{ color: "#ff6b35" }} /></ListItemIcon>
												<ListItemText primary="Criar projeto" />
											</ListItem>
										</>
									)}
									<ListItem button style={{ borderRadius: 10, marginBottom: 2 }}
										onClick={() => { setMobileActionsOpen(false); setTagsKanbanModalOpen(true); }}>
										<ListItemIcon style={{ minWidth: 38 }}><LabelIcon style={{ color: "#00a884" }} /></ListItemIcon>
										<ListItemText primary="Tags e Kanban" />
									</ListItem>
									<ListItem button style={{ borderRadius: 10, marginBottom: 2 }}
										onClick={() => { setMobileActionsOpen(false); setNotesDrawerOpen(true); }}>
										<ListItemIcon style={{ minWidth: 38 }}><StickyNote2Icon style={{ color: "#6366f1" }} /></ListItemIcon>
										<ListItemText primary="Notas do atendimento" />
									</ListItem>
									{selectedTicket?.status === "open" && (
										<>
											<Divider style={{ margin: "4px 0" }} />
											<ListItem button style={{ borderRadius: 10, marginBottom: 2, color: "#ef4444" }}
												onClick={async () => {
													setMobileActionsOpen(false);
													const ok = await showConfirm({ type: "warning", title: "Fechar Ticket", message: "Deseja realmente fechar este ticket?", confirmText: "Sim, fechar", cancelText: "Cancelar" });
													if (ok) { await api.put(`/tickets/${selectedTicket.id}`, { status: "closed" }); setSelectedTicket(null); history.push("/atendimentos" + window.location.search); loadTickets(); loadUnreadCounts(); }
												}}>
												<ListItemIcon style={{ minWidth: 38 }}><CheckCircleIcon style={{ color: "#ff9800" }} /></ListItemIcon>
												<ListItemText primary="Fechar atendimento" />
											</ListItem>
											{["administrador", "gerente"].includes(user?.userType) && (
											<ListItem button style={{ borderRadius: 10, color: "#ef4444" }}
												onClick={async () => {
													setMobileActionsOpen(false);
													const ok = await showConfirm({ type: "error", title: "Excluir Ticket", message: "Deseja realmente excluir este ticket?", confirmText: "Sim, excluir", cancelText: "Cancelar" });
													if (ok) { await api.delete(`/tickets/${selectedTicket.id}`); setSelectedTicket(null); history.push("/atendimentos" + window.location.search); loadTickets(); loadUnreadCounts(); }
												}}>
												<ListItemIcon style={{ minWidth: 38 }}><DeleteIcon style={{ color: "#f44336" }} /></ListItemIcon>
												<ListItemText primary="Excluir ticket" primaryTypographyProps={{ style: { color: "#f44336" } }} />
											</ListItem>
											)}
										</>
									)}
								</List>
								<DialogActions style={{ padding: "8px 16px 12px" }}>
									<Button onClick={() => setMobileActionsOpen(false)} style={{ textTransform: "none" }}>Fechar</Button>
								</DialogActions>
							</Dialog>

							{/* Messages */}
							<div 
								className={classes.chatMessages} 
								ref={messagesContainerRef}
								tabIndex={0}
								style={{
									outline: 'none',
									userSelect: 'text',
									WebkitUserSelect: 'text',
									MozUserSelect: 'text',
									msUserSelect: 'text'
								}}
							>
								{/* Status de digitação */}
								{isTyping && (
									<div style={{
										display: 'flex',
										alignItems: 'center',
										gap: 8,
										padding: '8px 12px',
										margin: '4px 0',
										backgroundColor: '#f0f2f5',
										borderRadius: 18,
										alignSelf: 'flex-start',
										maxWidth: '70%'
									}}>
										<div style={{
											width: 8,
											height: 8,
											borderRadius: '50%',
											backgroundColor: '#25d366',
											animation: 'pulse 1.5s ease-in-out infinite'
										}} />
										<Typography style={{ 
											fontSize: 14, 
											color: '#111b21',
											fontStyle: 'italic'
										}}>
											{typingUser || 'Alguém'} está digitando...
										</Typography>
									</div>
								)}
								
								{loadingMore && (
									<div style={{
										display: 'flex',
										justifyContent: 'center',
										padding: '16px',
										color: '#667781'
									}}>
										<Typography variant="caption">Carregando mensagens antigas...</Typography>
									</div>
								)}
								
								<>
									{groupConsecutiveMediaMessages(messagesWithoutReactions).map((item) => {
										// Se for um grupo de mensagens com múltiplos arquivos
										if (item.isGroup) {
											const firstMessage = item.messages[0];
											const allDeleted = item.messages.every(msg => msg.isDeleted);
											const someDeleted = item.messages.some(msg => msg.isDeleted);
											
											return (
												<div
													key={item.id}
													className={classes.messageGroup}
													style={{ 
														alignItems: firstMessage.fromMe ? "flex-end" : "flex-start",
														position: "relative",
													}}
												>
												<div
													className={classes.messageBubble}
													style={{
														backgroundColor: (firstMessage.mediaType === "sticker" || firstMessage.body === "sticker") ? "transparent" : (firstMessage.fromMe ? "#d9fdd3" : "#ffffff"),
														padding: (firstMessage.mediaType === "sticker" || firstMessage.body === "sticker") ? "0" : "8px 12px",
														boxShadow: (firstMessage.mediaType === "sticker" || firstMessage.body === "sticker") ? "none" : undefined,
														maxWidth: (firstMessage.mediaType === "sticker" || firstMessage.body === "sticker") ? "180px" : undefined,
														width: (firstMessage.mediaType === "sticker" || firstMessage.body === "sticker") ? "180px" : undefined,
														position: "relative",
														cursor: !allDeleted ? "pointer" : "default"
													}}
													onDoubleClick={(e) => {
														if (!allDeleted) {
															handleMessageMenuOpen(e, firstMessage);
														}
													}}
													onMouseEnter={(e) => {
														const menuBtn = e.currentTarget.querySelector('.message-menu-btn');
														if (menuBtn) menuBtn.style.opacity = '1';
													}}
													onMouseLeave={(e) => {
														const menuBtn = e.currentTarget.querySelector('.message-menu-btn');
														if (menuBtn && !messageMenuAnchor) menuBtn.style.opacity = '0';
													}}
												>
													{!allDeleted && (
														<IconButton
															size="small"
															className="message-menu-btn"
															onClick={(e) => handleMessageMenuOpen(e, firstMessage)}
															style={{
																position: "absolute",
																top: "4px",
																right: "4px",
																left: "auto",
																opacity: 0,
																transition: "opacity 0.2s",
																padding: "4px",
																backgroundColor: "rgba(0,0,0,0.05)",
																zIndex: 10,
															}}
														>
															<MoreVertIcon style={{ fontSize: 16 }} />
														</IconButton>
													)}
													
													{allDeleted ? (
														<div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
															<Typography style={{ color: "#d32f2f", fontSize: "14px", fontStyle: "italic" }}>
																{item.messages.length} mensagens apagadas
															</Typography>
															<IconButton
																size="small"
																onClick={() => setViewingDeletedMessage(viewingDeletedMessage === firstMessage.id ? null : firstMessage.id)}
																style={{ padding: "4px" }}
															>
																<VisibilityIcon style={{ fontSize: 18, color: "#667781" }} />
															</IconButton>
														</div>
													) : (
														<>
															{/* Renderiza grid de múltiplos arquivos */}
															{renderMediaGrid(item.messages)}
															
															{someDeleted && (
																<Typography style={{ fontSize: "12px", color: "#d32f2f", fontStyle: "italic", marginTop: "4px" }}>
																	Algumas mensagens foram apagadas
																</Typography>
															)}
														</>
													)}
													
													{allDeleted && viewingDeletedMessage === firstMessage.id && (
														<div style={{
															marginTop: "8px", 
															padding: "8px", 
															backgroundColor: "rgba(0,0,0,0.05)", 
															borderRadius: "4px",
															borderLeft: "3px solid #d32f2f"
														}}>
															{renderMediaGrid(item.messages, true)}
														</div>
													)}
													
													{/* Reações inline no grupo de mensagens */}
													{reactionsMap[firstMessage.id] && Object.keys(reactionsMap[firstMessage.id]).length > 0 && (
														<div style={{ display: "flex", flexWrap: "wrap", gap: "4px", marginTop: "4px" }}>
															{Object.entries(reactionsMap[firstMessage.id]).map(([emoji, count]) => (
																<div key={emoji} style={{
																	display: "inline-flex",
																	alignItems: "center",
																	gap: "3px",
																	backgroundColor: firstMessage.fromMe ? "rgba(255,255,255,0.7)" : "rgba(0,0,0,0.07)",
																	border: "1px solid rgba(0,0,0,0.10)",
																	borderRadius: "12px",
																	padding: "1px 7px",
																	fontSize: "14px",
																	lineHeight: "20px",
																}}>
																	{emoji}
																	{count > 1 && <span style={{ fontSize: "11px", color: "#667781", fontWeight: 500 }}>{count}</span>}
																</div>
															))}
														</div>
													)}

													<div style={{ display: "flex", alignItems: "center", gap: "4px", marginTop: "4px", flexWrap: "wrap" }}>
														{!allDeleted && (
															<Typography style={{ fontSize: "11px", color: "#667781", fontWeight: 500 }}>
																{firstMessage.fromMe ? (firstMessage.fromAgent ? "Automação" : (firstMessage.user?.name || user.name)) : selectedTicket?.contact?.name} •
															</Typography>
														)}
														<Typography className={classes.messageTime}>
															{formatMessageTime(firstMessage.createdAt)}
														</Typography>
													</div>
												</div>
											</div>
										);
									}
									
									return (
										<div
											key={item.id}
											className={classes.messageGroup}
											style={{ 
												alignItems: item.fromMe ? "flex-end" : "flex-start",
												position: "relative",
											}}
										>
											<div
												className={classes.messageBubble}
												style={{
													backgroundColor: (item.mediaType === "sticker" || item.body === "sticker") ? "transparent" : (item.fromMe ? "#d9fdd3" : "#ffffff"),
													padding: (item.mediaType === "sticker" || item.body === "sticker") ? "0" : "8px 12px",
													boxShadow: (item.mediaType === "sticker" || item.body === "sticker") ? "none" : undefined,
													maxWidth: (item.mediaType === "sticker" || item.body === "sticker") ? "180px" : undefined,
													width: (item.mediaType === "sticker" || item.body === "sticker") ? "180px" : undefined,
													position: "relative",
													cursor: item.isDeleted ? "default" : "text"
												}}
												onDoubleClick={(e) => {
													if (!item.isDeleted) {
														handleMessageMenuOpen(e, item);
													}
												}}
												onMouseEnter={(e) => {
													const menuBtn = e.currentTarget.querySelector('.message-menu-btn');
													if (menuBtn) menuBtn.style.opacity = '1';
												}}
												onMouseLeave={(e) => {
													const menuBtn = e.currentTarget.querySelector('.message-menu-btn');
													if (menuBtn && !messageMenuAnchor) menuBtn.style.opacity = '0';
												}}
											>
												{!item.isDeleted && (
													<IconButton
														size="small"
														className="message-menu-btn"
														onClick={(e) => handleMessageMenuOpen(e, item)}
														style={{
															position: "absolute",
															top: "4px",
															right: "4px",
															left: "auto",
															opacity: 0,
															transition: "opacity 0.2s",
															padding: "4px",
															backgroundColor: "rgba(0,0,0,0.05)",
															zIndex: 10,
														}}
													>
														<MoreVertIcon style={{ fontSize: 16 }} />
													</IconButton>
												)}
												
												{item.isDeleted ? (
													<div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
														<Typography style={{ color: "#d32f2f", fontSize: "14px", fontStyle: "italic" }}>
															Mensagem apagada
														</Typography>
														<IconButton
															size="small"
															onClick={() => setViewingDeletedMessage(viewingDeletedMessage === item.id ? null : item.id)}
															style={{ padding: "4px" }}
														>
															<VisibilityIcon style={{ fontSize: 18, color: "#667781" }} />
														</IconButton>
													</div>
												) : (
													<>
														{/* Quoted Message */}
														{item.quotedMsg && (
															<div style={{
																backgroundColor: 'rgba(0,0,0,0.05)',
																borderLeft: '4px solid #00a884',
																padding: '6px 8px',
																borderRadius: '4px',
																marginBottom: '6px',
																cursor: 'pointer'
															}}>
																<Typography style={{ fontSize: 12, color: '#00a884', fontWeight: 500, marginBottom: 2 }}>
																	{item.quotedMsg.fromMe ? (item.quotedMsg.fromAgent ? "Automação" : (item.quotedMsg.user?.name || user.name)) : selectedTicket?.contact?.name}
																</Typography>
																<div style={{
																	fontSize: 13,
																	color: '#667781',
																	overflow: 'hidden',
																	textOverflow: 'ellipsis',
																	whiteSpace: 'nowrap'
																}}>
																	{renderMessageContent(item.quotedMsg)}
																</div>
															</div>
														)}
														{renderMessageContent(item)}
													</>
												)}
												
												{item.isDeleted && viewingDeletedMessage === item.id && (
													<div style={{ 
														marginTop: "8px", 
														padding: "8px", 
														backgroundColor: "rgba(0,0,0,0.05)", 
														borderRadius: "4px",
														borderLeft: "3px solid #d32f2f"
													}}>
														{renderMessageContent(item)}
													</div>
												)}
												
												{/* Reações inline — emojis abaixo da mensagem */}
												{reactionsMap[item.id] && Object.keys(reactionsMap[item.id]).length > 0 && (
													<div style={{
														display: "flex",
														flexWrap: "wrap",
														gap: "4px",
														marginTop: "4px",
														padding: (item.mediaType === "sticker" || item.body === "sticker") ? "2px 4px" : undefined,
													}}>
														{Object.entries(reactionsMap[item.id]).map(([emoji, count]) => (
															<div key={emoji} style={{
																display: "inline-flex",
																alignItems: "center",
																gap: "3px",
																backgroundColor: item.fromMe ? "rgba(255,255,255,0.7)" : "rgba(0,0,0,0.07)",
																border: "1px solid rgba(0,0,0,0.10)",
																borderRadius: "12px",
																padding: "1px 7px",
																fontSize: "14px",
																lineHeight: "20px",
																cursor: "default",
															}}>
																{emoji}
																{count > 1 && (
																	<span style={{ fontSize: "11px", color: "#667781", fontWeight: 500 }}>{count}</span>
																)}
															</div>
														))}
													</div>
												)}

												<div style={{ display: "flex", alignItems: "center", gap: "4px", marginTop: "4px", flexWrap: "wrap", padding: (item.mediaType === "sticker" || item.body === "sticker") ? "2px 4px" : undefined }}>
													{!item.isDeleted && (item.mediaType !== "sticker" && item.body !== "sticker") && (
														<Typography style={{ fontSize: "11px", color: "#667781", fontWeight: 500 }}>
															{item.fromMe ? (item.fromAgent ? "Automação" : (item.user?.name || user.name)) : selectedTicket?.contact?.name} •
														</Typography>
													)}
													<Typography className={classes.messageTime}>
														{formatMessageDateTime(item.createdAt)}
													</Typography>
													{item.isEdited && !item.isDeleted && (
														<EditIcon style={{ fontSize: 14, color: "#667781" }} />
													)}
													{item.fromMe && !item.isDeleted && (
														<>
															{item.ack === 0 && (
																<DoneIcon style={{ fontSize: 16, color: "#667781" }} />
															)}
															{item.ack === 1 && (
																<DoneIcon style={{ fontSize: 16, color: "#667781" }} />
															)}
															{item.ack === 2 && (
																<DoneAllIcon style={{ fontSize: 16, color: "#667781" }} />
															)}
															{(item.ack === 3 || item.ack === 4) && (
																<DoneAllIcon style={{ fontSize: 16, color: "#34b7f1" }} />
															)}
														</>
													)}
												</div>
											</div>
										</div>
									);
								})}
								<div ref={messagesEndRef} />
							</>
						</div>

						{/* Replying Message Preview */}
						{replyingTo && (
							<div style={{
								backgroundColor: '#f0f2f5',
								borderTop: '1px solid #e9edef',
								padding: '8px 16px',
								display: 'flex',
								alignItems: 'center',
								gap: 8
							}}>
								<div style={{
									width: 4,
									height: 40,
									backgroundColor: '#00a884',
									borderRadius: 2
								}} />
								<div style={{ flex: 1, minWidth: 0 }}>
									<Typography style={{ fontSize: 12, color: '#00a884', fontWeight: 500 }}>
										Respondendo a {replyingTo.fromMe ? (replyingTo.fromAgent ? "Automação" : (replyingTo.user?.name || user.name)) : selectedTicket?.contact?.name}
									</Typography>
									<Typography style={{
										fontSize: 13,
										color: '#667781',
										overflow: 'hidden',
										textOverflow: 'ellipsis',
										whiteSpace: 'nowrap'
									}}>
										{replyingTo.body || 'Mídia'}
									</Typography>
								</div>
								<IconButton
									size="small"
									onClick={() => setReplyingTo(null)}
									style={{ color: '#54656f' }}
								>
									<CloseIcon />
								</IconButton>
							</div>
						)}

						{/* Input */}
						<div className={classes.chatInput}>
							{!isMobile && showEmojiPicker && (
								<div style={{
									position: 'absolute',
									bottom: '60px',
									left: '10px',
									backgroundColor: '#fff',
									border: '1px solid #e9edef',
									borderRadius: '8px',
									padding: '8px',
									display: 'grid',
									gridTemplateColumns: 'repeat(8, 1fr)',
									gap: '4px',
									maxWidth: '320px',
									boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
									zIndex: 1000
								}}>
									{['😀', '😃', '😄', '😁', '😆', '😅', '🤣', '😂', '🙂', '🙃', '😉', '😊', '😇', '🥰', '😍', '🤩', '😘', '😗', '😚', '😙', '😋', '😛', '😜', '🤪', '😝', '🤑', '🤗', '🤭', '🤫', '🤔', '🤐', '🤨', '😐', '😑', '😶', '😏', '😒', '🙄', '😬', '🤥', '😌', '😔', '😪', '🤤', '😴', '😷', '🤒', '🤕', '🤢', '🤮', '🤧', '🥵', '🥶', '🥴', '😵', '🤯', '🤠', '🥳', '😎', '🤓', '🧐', '👍', '👎', '👏', '🙌', '🤝', '🙏', '❤️', '🔥', '💯', '✅', '❌'].map((emoji) => (
										<span
											key={emoji}
											onClick={() => handleEmojiSelect(emoji)}
											style={{
												fontSize: '24px',
												cursor: 'pointer',
												padding: '4px',
												borderRadius: '4px',
												transition: 'background-color 0.2s',
											}}
											onMouseEnter={(e) => e.target.style.backgroundColor = '#f0f2f5'}
											onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
										>
											{emoji}
										</span>
									))}
								</div>
							)}
							{!isMobile && (
								<>
									<IconButton 
										size="small"
										onClick={() => setSignMessage(!signMessage)}
										style={{ color: signMessage ? '#00a884' : '#54656f' }}
										title="Assinatura (nome do atendente)"
									>
										<SignatureIcon />
									</IconButton>
									<IconButton 
										size="small"
										onClick={() => setShowEmojiPicker(!showEmojiPicker)}
										style={{ color: '#54656f' }}
									>
										<EmojiIcon />
									</IconButton>
								</>
							)}
							<input
								type="file"
								ref={fileInputRef}
								style={{ display: 'none' }}
								onChange={handleFileUpload}
								multiple
								accept="image/*,video/*,audio/*,.pdf,.doc,.docx,.xls,.xlsx,.txt,.zip,.rar,.7z"
							/>
							<IconButton 
								size="small"
								onClick={() => setAttachmentModalOpen(true)}
								style={{ color: '#54656f' }}
							>
								<AddIcon />
							</IconButton>
														<InputBase
								className={classes.inputField}
								placeholder="Digite uma mensagem ou / para respostas rápidas"
								value={inputMessage}
								inputRef={inputMessageRef}
								onChange={(e) => {
									const value = e.target.value;
									setInputMessage(value);
									updateQuickReplyContext(value);
								}}
								onFocus={() => {
									keepInputFocusRef.current = true;
								}}
								onBlur={(event) => {
									const fallbackActive = typeof document !== "undefined" ? document.activeElement : null;
									const nextElement = event?.relatedTarget || fallbackActive;
									const isExternal = nextElement && nextElement !== document.body && nextElement !== inputMessageRef.current;
									if (isExternal) {
										keepInputFocusRef.current = false;
										return;
									}
									keepInputFocusRef.current = true;
									requestAnimationFrame(() => {
										if (inputMessageRef.current) {
											inputMessageRef.current.focus({ preventScroll: true });
										}
									});
								}}
								onKeyDown={handleInputKeyDown}
								onPaste={handlePaste}
								multiline
								maxRows={4}
							/>
							
							{/* Sugestões de respostas rápidas */}
							{showQuickReplies && filteredQuickMessages.length > 0 && (
								<Paper 
									elevation={3} 
									style={{ 
										position: 'absolute', 
										bottom: '100%', 
										left: 0, 
										right: 0,
										maxHeight: '200px',
										overflowY: 'auto',
										zIndex: 1000,
										marginBottom: '8px'
									}}
								>
									<Box style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '8px 12px', borderBottom: '1px solid #e0e0e0' }}>
										<Typography variant="caption" style={{ fontWeight: 600 }}>
											Mensagens Rápidas
										</Typography>
										<IconButton size="small" onClick={() => {
											setShowQuickReplies(false);
											setFilteredQuickMessages([]);
											setSelectedQuickIndex(-1);
										}}>
											<CloseIcon fontSize="small" />
										</IconButton>
									</Box>
									<List dense>
										{filteredQuickMessages.map((msg, index) => (
											<ListItem
												key={msg.id}
												button
												selected={index === selectedQuickIndex}
												onClick={() => handleSelectQuickReply(msg)}
												style={{
													backgroundColor: index === selectedQuickIndex ? '#e3f2fd' : 'transparent'
												}}
											>
												<ListItemText 
													primary={`${msg.shortcode} - ${msg.message?.substring(0, 25) || ""}${msg.message?.length > 25 ? "..." : ""}`}
													primaryTypographyProps={{
														style: { 
															fontSize: '14px',
															color: index === selectedQuickIndex ? '#1976d2' : 'inherit'
														}
													}}
												/>
											</ListItem>
										))}
									</List>
								</Paper>
							)}
							{inputMessage.trim() ? (
								<IconButton
									color="primary"
									onClick={handleSendMessage}
								>
									<SendIcon />
								</IconButton>
							) : recording ? (
								<div style={{ display: 'flex', alignItems: 'center', gap: 8, backgroundColor: '#f0f2f5', padding: '8px 12px', borderRadius: 20, flex: 1 }}>
									<IconButton
										size="small"
										onClick={handleCancelRecording}
										style={{ color: '#f44336' }}
										title="Cancelar gravação"
									>
										<CloseIcon />
									</IconButton>
									<div style={{ display: 'flex', alignItems: 'center', gap: 8, flex: 1 }}>
										<div style={{ 
											width: 8, 
											height: 8, 
											borderRadius: '50%', 
											backgroundColor: '#f44336',
											animation: 'pulse 1.5s ease-in-out infinite'
										}} />
										<Typography style={{ fontSize: 14, color: '#111b21', fontFamily: 'monospace' }}>
											{Math.floor(recordingTime / 60)}:{(recordingTime % 60).toString().padStart(2, '0')}
										</Typography>
									</div>
									<IconButton
										color="primary"
										onClick={handleStopRecording}
										style={{ backgroundColor: '#00a884', color: '#fff' }}
										title="Enviar áudio"
									>
										<SendIcon />
									</IconButton>
								</div>
							) : (
								<>
									{/* Botão ✨ Assistente IA */}
									{aiProviders.length > 0 && (
										<Tooltip title="Assistente IA">
											<IconButton
												onClick={e => setAiMenuAnchor(aiMenuAnchor ? null : e.currentTarget)}
												disabled={!selectedTicket}
												style={{ color: "#7c3aed", padding: 6 }}
											>
												<AutoAwesomeIcon fontSize="small" />
											</IconButton>
										</Tooltip>
									)}
									{/* Menu IA flutuante */}
									{Boolean(aiMenuAnchor) && (
										<Box style={{ position: "fixed", zIndex: 1400, bottom: 72, right: 20,
											backgroundColor: "#fff", borderRadius: 10,
											boxShadow: "0 4px 20px rgba(0,0,0,0.15)",
											border: "1px solid #e2e8f0", minWidth: 195, overflow: "hidden" }}>
											<Box style={{ position: "fixed", inset: 0, zIndex: -1 }} onClick={() => setAiMenuAnchor(null)} />
											{[
												{ icon: "✨", label: "Sugerir resposta", action: () => { setAiMenuAnchor(null); setAiSuggestOpen(true); } },
												{ icon: "📋", label: "Resumir conversa", action: () => { setAiMenuAnchor(null); setAiSummaryOpen(true); } },
												{ icon: "💬", label: "Perguntar à IA", action: () => { setAiMenuAnchor(null); setAiAskOpen(true); } },
											].map(item => (
												<Box key={item.label} onClick={item.action}
													style={{ display: "flex", alignItems: "center", gap: 10,
														padding: "10px 16px", cursor: "pointer", fontSize: 14, color: "#1a1a2e" }}
													onMouseEnter={e => e.currentTarget.style.backgroundColor = "#f8fafc"}
													onMouseLeave={e => e.currentTarget.style.backgroundColor = "transparent"}>
													<span style={{ fontSize: 16 }}>{item.icon}</span>{item.label}
												</Box>
											))}
										</Box>
									)}
									<IconButton
										color="primary"
										onClick={handleStartRecording}
										style={{ color: '#54656f' }}
									>
										<MicIcon />
									</IconButton>
								</>
							)}
						</div>
					</>
				) : (
					<div className={classes.welcomeContainer}>
						<ChatIcon className={classes.welcomeIcon} />
						<div className={classes.welcomeTitle}>
							Atendimentos
						</div>
						<div className={classes.welcomeText}>
							Selecione um atendimento para visualizar a conversa
							<br />
							ou inicie um novo atendimento
						</div>
					</div>
				)}
			</div>
			)}

			{/* Modais IA */}
			{aiSuggestOpen && selectedTicket && (
				<AiSuggestModal
					open={aiSuggestOpen}
					onClose={() => setAiSuggestOpen(false)}
					ticketId={selectedTicket.id}
					onUse={text => { setInputMessage(text); if (inputMessageRef.current) inputMessageRef.current.focus(); }}
				/>
			)}
			{aiSummaryOpen && selectedTicket && (
				<AiSummaryModal
					open={aiSummaryOpen}
					onClose={() => setAiSummaryOpen(false)}
					ticketId={selectedTicket.id}
				/>
			)}
			{aiAskOpen && selectedTicket && (
				<AiAskModal
					open={aiAskOpen}
					onClose={() => setAiAskOpen(false)}
					ticketId={selectedTicket.id}
				/>
			)}

			{/* Modal de Agendamento */}
			{scheduleModalOpen && selectedTicket && (
				<ScheduleModal
					open={scheduleModalOpen}
					onClose={() => setScheduleModalOpen(false)}
					aria-labelledby="form-dialog-title"
					contactId={selectedTicket.contact?.id}
				/>
			)}

			{/* Modal de Respostas Rápidas */}
			<Dialog
				open={quickMessagesOpen}
				onClose={() => setQuickMessagesOpen(false)}
				maxWidth="sm"
				fullWidth
			>
				<DialogTitle style={{ backgroundColor: "#5b68ea", color: "#fff", textAlign: "center", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
					<span>Mensagens Rápidas</span>
					<IconButton onClick={() => setQuickMessagesOpen(false)} style={{ color: "#fff" }}>
						<CloseIcon />
					</IconButton>
				</DialogTitle>
				<DialogContent style={{ padding: "16px" }}>
					<Grid container direction="column" spacing={1}>
						{quickMessages.map((message, index) => (
							<Grid item xs={12} key={index}>
								<Button
									fullWidth
									variant="contained"
									style={{
										backgroundColor: "#4a5568",
										color: "#fff",
										textTransform: "none",
										justifyContent: "flex-start",
										padding: "12px 16px",
									}}
									onClick={() => {
									console.log("🖱️ Clicou na resposta rápida:", message.shortcode, "- mediaPath:", message.mediaPath);
									if (message.mediaPath) {
										// Se tem arquivo, abre preview
										console.log("📎 Tem arquivo - abrindo preview");
										setQuickMessagePreview(message);
										setQuickMessagePreviewOpen(true);
										setQuickMessagesOpen(false);
									} else {
										// Se não tem arquivo, envia direto
										console.log("📝 Sem arquivo - enviando direto");
										handleSelectQuickMessage(message);
									}
								}}
								>
									<div style={{ display: "flex", alignItems: "center", gap: 8, width: "100%" }}>
										{message.mediaPath && (
											<span style={{ fontSize: 12, backgroundColor: "#5b68ea", padding: "2px 6px", borderRadius: 4 }}>
												📎
											</span>
										)}
										<span>
											{message.shortcode}
										</span>
										<span style={{ opacity: 0.7, fontSize: 12 }}>
											- {message.message?.substring(0, 25) || "(sem texto)"}
											{message.message?.length > 25 ? "..." : ""}
										</span>
									</div>
								</Button>
							</Grid>
						))}
					</Grid>
				</DialogContent>
			</Dialog>

			{/* Modal de Preview de Mídia */}
			<MediaPreviewModal
				open={mediaPreviewOpen}
				onClose={() => {
					setMediaPreviewOpen(false);
					setSelectedFile(null);
					setSelectedFiles([]);
				}}
				file={selectedFile}
				files={selectedFiles}
				onSend={handleSendMedia}
			/>

			{/* Modal de Preview de Resposta Rápida */}
			<QuickMessagePreviewModal
				open={quickMessagePreviewOpen}
				onClose={() => {
					setQuickMessagePreviewOpen(false);
					setQuickMessagePreview(null);
				}}
				quickMessage={quickMessagePreview}
				onSend={handleSelectQuickMessage}
			/>

			{/* Menu de Ações da Mensagem */}
			<Menu
				anchorEl={messageMenuAnchor}
				open={Boolean(messageMenuAnchor)}
				onClose={handleMessageMenuClose}
			>
				<MenuItem
					onClick={() => {
						handleReplyMessage(selectedMessage);
						handleMessageMenuClose();
					}}
				>
					Responder
				</MenuItem>
				{/* Copiar Texto */}
				{(selectedMessage?.body || selectedMessage?.caption || selectedMessage?.mediaCaption) && (
					<MenuItem
						onClick={() => {
							const textToCopy = selectedMessage?.caption || selectedMessage?.mediaCaption || selectedMessage?.body || "";
							navigator.clipboard.writeText(textToCopy);
							handleMessageMenuClose();
						}}
					>
						Copiar Texto
					</MenuItem>
				)}
				{/* Baixar Arquivo */}
				{selectedMessage?.mediaUrl && (
					<MenuItem
						onClick={() => {
							const link = document.createElement('a');
							link.href = selectedMessage.mediaUrl;
							link.download = selectedMessage.body || 'arquivo';
							link.target = '_blank';
							document.body.appendChild(link);
							link.click();
							document.body.removeChild(link);
							handleMessageMenuClose();
						}}
					>
						Baixar Arquivo
					</MenuItem>
				)}
				{selectedMessage?.fromMe && (
					<MenuItem
						onClick={() => {
							setEditModalOpen(true);
							handleMessageMenuClose();
						}}
					>
						Editar
					</MenuItem>
				)}
				<MenuItem
					onClick={() => {
						setDeleteModalOpen(true);
						handleMessageMenuClose();
					}}
				>
					Deletar
				</MenuItem>
				<MenuItem
					onClick={() => {
						setForwardModalOpen(true);
						handleMessageMenuClose();
					}}
				>
					Encaminhar
				</MenuItem>
			</Menu>

			{/* Modal de Confirmação de Exclusão */}
			<DeleteConfirmModal
				open={deleteModalOpen}
				onClose={() => setDeleteModalOpen(false)}
				onConfirm={handleDeleteMessage}
				messageText={selectedMessage?.body}
			/>

			{/* Modal de Edição de Mensagem */}
			<EditMessageModal
				open={editModalOpen}
				onClose={() => setEditModalOpen(false)}
				onSave={handleEditMessage}
				initialMessage={selectedMessage?.body}
			/>

			{/* Modal de Encaminhamento */}
			<ForwardMessageModal
				open={forwardModalOpen}
				onClose={() => setForwardModalOpen(false)}
				onForward={handleForwardMessage}
				message={selectedMessage}
			/>

			{/* Modal de Galeria de Mídia */}
			<MediaGalleryModal
				open={mediaGalleryOpen}
				onClose={() => setMediaGalleryOpen(false)}
				medias={galleryMedias}
				initialIndex={galleryInitialIndex}
				onDelete={(media) => {
					// Encontra a mensagem original pelo ID
					const message = messages.find(msg => msg.id === media.id);
					if (message) {
						setSelectedMessage(message);
						setDeleteModalOpen(true);
						setMediaGalleryOpen(false);
					}
				}}
				onForward={(media) => {
					// Encontra a mensagem original pelo ID
					const message = messages.find(msg => msg.id === media.id);
					if (message) {
						setSelectedMessage(message);
						setForwardModalOpen(true);
						setMediaGalleryOpen(false);
					}
				}}
			/>

			{/* Modal de Tags e Kanban */}
			{selectedTicket && (
				<TicketNotesDrawer
					open={notesDrawerOpen}
					onClose={() => setNotesDrawerOpen(false)}
					ticket={selectedTicket}
				/>
			)}
			{selectedTicket && (
				<TicketTagsKanbanModal
					open={tagsKanbanModalOpen}
					onClose={() => setTagsKanbanModalOpen(false)}
					contact={selectedTicket.contact}
					ticket={selectedTicket}
					onUpdate={async () => {
						// Recarrega o ticket atualizado
						try {
							const { data } = await api.get(`/tickets/${selectedTicket.id}`);
							setSelectedTicket(data);
							
							// Atualiza também na lista de tickets mantendo updatedAt original
							setTickets(prevTickets => {
								const originalTicket = prevTickets.find(t => t.id === data.id);
								const updatedTicket = {
									...data,
									updatedAt: originalTicket?.updatedAt || data.updatedAt
								};
								return prevTickets.map(ticket => 
									ticket.id === data.id ? updatedTicket : ticket
								);
							});
							
						} catch (err) {
						}
					}}
				/>
			)}

			{/* Modal de Transferência */}
			{selectedTicket && (
				<TransferTicketModalCustom
					modalOpen={transferTicketModalOpen}
					onClose={handleCloseTransferModal}
					ticketid={selectedTicket.id}
					ticket={selectedTicket}
				/>
			)}

			{/* Modal de Contato */}
			{contactModalOpen && contactModalContact && (
				<ContactModal
					open={contactModalOpen}
					onClose={handleCloseContactModal}
					contactId={contactModalContact.id}
					initialValues={contactModalContact}
				/>
			)}

			{/* Modal de Fatura */}
			{faturaModalOpen && (
				<FaturaModal
					open={faturaModalOpen}
					onClose={() => {
						setFaturaModalOpen(false);
						loadTickets();
					}}
					initialData={{
						clientId: selectedTicket?.crmClient?.id || selectedTicket?.contact?.crmClients?.[0]?.id
					}}
				/>
			)}

			{/* Modal de Compromisso */}
			{appointmentModalOpen && (
				<AppointmentModal
					open={appointmentModalOpen}
					onClose={() => {
						setAppointmentModalOpen(false);
						setAppointmentInitialData(null);
					}}
					onSave={() => {
						setAppointmentModalOpen(false);
						setAppointmentInitialData(null);
					}}
					appointment={null}
					initialScheduleId={appointmentInitialData?.scheduleId}
					initialContactId={appointmentInitialData?.contactId}
					initialClientId={appointmentInitialData?.clientId}
					initialLeadId={appointmentInitialData?.leadId}
				/>
			)}

			{/* Modal de Histórico de Conversas */}
			{historyModalOpen && selectedTicket && (
				<TicketMessagesDialog
					open={historyModalOpen}
					handleClose={() => setHistoryModalOpen(false)}
					ticketId={selectedTicket.id}
				/>
			)}

			{/* Modal de Projeto */}
			{projectModalOpen && (
				<ProjectModal
					open={projectModalOpen}
					onClose={() => setProjectModalOpen(false)}
					initialData={{
						clientId: selectedTicket?.crmClient?.id || selectedTicket?.contact?.crmClients?.[0]?.id
					}}
				/>
			)}

			{/* Modal de Detalhes do Cliente */}
			{clientDetailsModalOpen && (
				<ClientDetailsModal
					open={clientDetailsModalOpen}
					onClose={() => setClientDetailsModalOpen(false)}
					client={selectedTicket?.crmClient || selectedTicket?.contact?.crmClients?.[0]}
					onConvertToClient={handleConvertToClient}
				/>
			)}


			<Dialog open={closeAllDialogOpen} onClose={handleCloseCloseAllDialog} maxWidth="xs" fullWidth>
				<DialogTitle>Encerrar atendimentos</DialogTitle>
				<DialogContent dividers>
					<Typography>
						Essa ação vai encerrar todos os tickets em atendimento. Deseja continuar?
					</Typography>
				</DialogContent>
				<DialogActions>
					<Button onClick={handleCloseCloseAllDialog} disabled={closingAllTickets}>
						Cancelar
					</Button>
					<Button
						color="secondary"
						variant="contained"
						startIcon={<DoneAllIcon />}
						onClick={handleCloseAllTickets}
						disabled={closingAllTickets}
					>
						{closingAllTickets ? "Encerrando..." : "Encerrar todos"}
					</Button>
				</DialogActions>
			</Dialog>

			{/* Modal WAVoIP - Ligação */}
			<Dialog
				open={wavoipModalOpen}
				onClose={handleCloseWavoipModal}
				maxWidth="md"
				disableEscapeKeyDown
				BackdropProps={{ invisible: true }}
				PaperProps={{
					style: {
						width: '600px',
						height: '800px',
						maxWidth: 'none',
						maxHeight: 'none',
						boxShadow: 'none',
					}
				}}
			>
				<iframe
					src={wavoipUrl}
					style={{ width: '100%', height: '100%', border: 'none' }}
					title="WAVoIP Call"
					allow="microphone; autoplay"
				/>
				<DialogActions>
					<Button onClick={handleCloseWavoipModal} color="primary">
						Fechar
					</Button>
				</DialogActions>
			</Dialog>

			{/* Modal de Anexos */}
			<AttachmentModal
				open={attachmentModalOpen}
				onClose={() => setAttachmentModalOpen(false)}
				onSelectOption={handleAttachmentOption}
			/>

			<EmailComposeModal
				open={emailComposeOpen}
				onClose={() => setEmailComposeOpen(false)}
				initialTo={emailComposeTo}
				initialSubject={`Atendimento — ${selectedTicket?.contact?.name || ""}`}
			/>

			<FormSelectModal
				open={quizSelectOpen}
				onClose={() => setQuizSelectOpen(false)}
				onSelect={handleQuizSend}
			/>

			{/* Modal de Envio de Contato */}
			<ContactSendModal
				modalOpen={contactSendModalOpen}
				onClose={(contact) => {
					if (contact) {
						handleSendContact(contact);
					} else {
						setContactSendModalOpen(false);
					}
				}}
			/>

			{/* Modal de Localização */}
			<LocationModal
				open={locationModalOpen}
				onClose={() => setLocationModalOpen(false)}
				onSend={handleSendLocation}
			/>

			{/* Modal de Câmera */}
			<ModalCamera
				isOpen={cameraModalOpen}
				onRequestClose={() => setCameraModalOpen(false)}
				onCapture={handleCameraCapture}
			/>
		{/* Modais de gerenciamento de grupo */}
		<GroupParticipantsModal
			open={participantsModal.open}
			onClose={() => setParticipantsModal({ open: false, jid: null, whatsappId: null, name: "" })}
			groupJid={participantsModal.jid}
			whatsappId={participantsModal.whatsappId}
			groupName={participantsModal.name}
		/>
		<GroupSettingsModal
			open={settingsModal.open}
			onClose={() => setSettingsModal({ open: false, jid: null, whatsappId: null, name: "" })}
			groupJid={settingsModal.jid}
			whatsappId={settingsModal.whatsappId}
			groupName={settingsModal.name}
		/>
		<GroupImageModal
			open={imageModal.open}
			onClose={() => setImageModal({ open: false, jid: null, whatsappId: null, name: "" })}
			groupJid={imageModal.jid}
			whatsappId={imageModal.whatsappId}
			groupName={imageModal.name}
		/>
		<Dialog
			open={inviteModal.open}
			onClose={() => setInviteModal({ open: false, jid: null, whatsappId: null, name: "", link: "", loading: false })}
			maxWidth="sm"
			fullWidth
		>
			<DialogTitle>Link de Convite — {inviteModal.name}</DialogTitle>
			<DialogContent>
				{inviteModal.loading ? (
					<Box display="flex" justifyContent="center" py={3}>
						<CircularProgress />
					</Box>
				) : (
					<Box display="flex" flexDirection="column" style={{ gap: 12 }}>
						<TextField
							variant="outlined"
							size="small"
							fullWidth
							value={inviteModal.link || "Erro ao carregar link"}
							InputProps={{ readOnly: true }}
						/>
						<Box display="flex" style={{ gap: 8 }}>
							<Button
								variant="contained"
								color="primary"
								size="small"
								onClick={() => { navigator.clipboard.writeText(inviteModal.link); toast.success("Link copiado!"); }}
								disabled={!inviteModal.link}
							>
								Copiar link
							</Button>
							<Button
								variant="outlined"
								size="small"
								style={{ color: "#dc2626", borderColor: "#dc2626" }}
								onClick={async () => {
									if (!window.confirm("Revogar o link atual? O link anterior não funcionará mais.")) return;
									try {
										const { data } = await api.delete(`/groups/${encodeURIComponent(inviteModal.jid)}/invite`, { data: { whatsappId: inviteModal.whatsappId } });
										setInviteModal(prev => ({ ...prev, link: data.link || `https://chat.whatsapp.com/${data.code}` || "" }));
										toast.success("Link revogado e novo link gerado!");
									} catch {
										toast.error("Erro ao revogar link");
									}
								}}
								disabled={!inviteModal.link}
							>
								Revogar link
							</Button>
						</Box>
					</Box>
				)}
			</DialogContent>
			<DialogActions>
				<Button onClick={() => setInviteModal({ open: false, jid: null, whatsappId: null, name: "", link: "", loading: false })} color="primary">
					Fechar
				</Button>
			</DialogActions>
		</Dialog>

		{/* Dialog criar grupo */}
		<Dialog
			open={createGroupModal}
			onClose={() => !creatingGroup && setCreateGroupModal(false)}
			maxWidth="sm"
			fullWidth
		>
			<DialogTitle>Criar Novo Grupo</DialogTitle>
			<DialogContent>
				{whatsapps.filter(w => w.status === "CONNECTED").length > 1 && (
					<div style={{ marginBottom: 16 }}>
						<Typography variant="caption" style={{ color: "#667781", display: "block", marginBottom: 6 }}>
							Conexão WhatsApp
						</Typography>
						<select
							value={newGroupWhatsappId}
							onChange={(e) => { const v = e.target.value; setNewGroupWhatsappId(v); }}
							style={{ width: "100%", padding: "8px 12px", borderRadius: 4, border: "1px solid #ccc", fontSize: 14 }}
						>
							{whatsapps.filter(w => w.status === "CONNECTED").map(w => (
								<option key={w.id} value={w.id}>{w.name}</option>
							))}
						</select>
					</div>
				)}
				<TextField
					fullWidth
					size="small"
					variant="outlined"
					label="Nome do grupo"
					value={newGroupSubject}
					onChange={(e) => { const v = e.target.value; setNewGroupSubject(v); }}
					style={{ marginBottom: 16 }}
					disabled={creatingGroup}
				/>
				<TextField
					fullWidth
					size="small"
					variant="outlined"
					label="Participantes (números com DDD)"
					placeholder={"11999887766\n21988776655"}
					multiline
					rows={4}
					value={newGroupParticipants}
					onChange={(e) => { const v = e.target.value; setNewGroupParticipants(v); }}
					helperText="Um número por linha ou separados por vírgula. Inclua o código do país (ex: 5511999887766 para Brasil)"
					disabled={creatingGroup}
				/>
			</DialogContent>
			<DialogActions>
				<Button onClick={() => setCreateGroupModal(false)} disabled={creatingGroup}>
					Cancelar
				</Button>
				<Button
					variant="contained"
					color="primary"
					onClick={handleCreateGroup}
					disabled={creatingGroup}
				>
					{creatingGroup ? <CircularProgress size={18} color="inherit" /> : "Criar Grupo"}
				</Button>
			</DialogActions>
		</Dialog>
		</div>
	);
};

export default Atendimentos;


